// SHADOW MARKET™ — RE₿EL Lab de Mercado · Casos de Estudio completos
// 8 casos institucionales con timeline, análisis técnico y lecciones.
// Estructura i18n: cada caso tiene "es" base + traducciones EN / SK.
// (Las traducciones EN / SK se generan vía /app/backend/scripts/translate_casos_estudio.py)

// Color/badge meta is shared across languages.
export const CASOS_ESTUDIO = [
  // ───────────────────────────────────────────────────────────
  // CASO 1 · BTC Bull Run 2021
  // ───────────────────────────────────────────────────────────
  {
    slug: "btc-bull-run-2021",
    colorCategoria: "#ff6b35",
    nivel: "intermedio",
    datosCarousel: [
      { key: "ath", valor: "69.000$", color: "#f5a623" },
      { key: "caida", valor: "-77%", color: "#ff3355" },
      { key: "duracion_bear", valor: "13 meses", color: "#ff6b35" },
      { key: "nupl_techo", valor: "0.79", color: "#ff3355" },
      { key: "fg_techo", valor: "95/100", color: "#ff3355" },
      { key: "capital_destruido", valor: "~2T USD", color: "#ff6b35" },
    ],
    i18n: {
      es: {
        categoria: "DISTRIBUCIÓN",
        titulo: "BTC Bull Run 2021: Techo de Euforia ETF",
        subtitulo: "Cómo la venta institucional en ATH creó el doble techo que destruyó el mercado",
        descripcion: "Cómo la venta institucional en ATH creó el patrón de distribución que llevó a un bear market del 77%.",
        duracionLectura: "18 min",
        nivel: "Intermedio",
        resumen: "El Bull Run de 2021 terminó exactamente como lo hace siempre en los mercados financieros: con los institucionales vendiendo silenciosamente mientras el retail compraba eufórico. Bitcoin tocó 64.000$ en abril, luego 69.000$ en noviembre. Ambos máximos fueron oportunidades de distribución institucional masiva. Lo que siguió fue el bear market más severo desde 2018.",
        contexto: "En 2020-2021 la narrativa era perfecta: COVID monetario, impresión de dinero masiva, inflación creciente, y Bitcoin posicionado como \"digital gold\". MicroStrategy, Tesla, Square compraban públicamente. Los ETFs de futuros de Bitcoin en EE.UU. se aprobaban por primera vez. El miedo a perderse el movimiento (FOMO) era máximo. El Fear & Greed Index marcaba 95/100 semana tras semana.",
        timeline: [
          { fecha: "Feb 2021", titulo: "Primer ATH: 58.000$", descripcion: "Tesla anuncia compra de 1.5B en BTC. El mercado explota al alza. FOMO masivo.", tipo: "alcista" },
          { fecha: "Abr 2021", titulo: "ATH de 64.000$", descripcion: "Coinbase sale a bolsa en Nasdaq (COIN). Bitcoin toca máximos históricos. NUPL en zona de euforia (>0.75). Primer techo del doble techo.", tipo: "critico" },
          { fecha: "May 2021", titulo: "Crash del 55% en 3 semanas", descripcion: "China prohíbe minería. Tesla vende BTC. Cascada de liquidaciones. De 64K a 29K en 3 semanas. Uno de los crashes más rápidos de la historia.", tipo: "bajista" },
          { fecha: "Jul 2021", titulo: "Recuperación y consolidación", descripcion: "BTC se estabiliza en zona 30-40K. Wyckoff Spring formation. Los institucionales acumulan silenciosamente. El retail tiene miedo.", tipo: "neutro" },
          { fecha: "Oct 2021", titulo: "Nuevo ATH: 67.000$", descripcion: "Aprobación del primer ETF de futuros de Bitcoin en EE.UU. (ProShares BITO). Rally explosivo. Segundo techo del doble techo.", tipo: "critico" },
          { fecha: "Nov 2021", titulo: "ATH final: 69.000$", descripcion: "El precio no puede superar el ATH anterior con fuerza. Volumen decreciente. NUPL en máximos históricos. Los institucionales terminan la distribución.", tipo: "critico" },
          { fecha: "Nov 2021 – Dic 2022", titulo: "Bear Market: -77%", descripcion: "Caída gradual pero implacable. De 69K a 15.5K en 13 meses. Contagio: LUNA, 3AC, Celsius, FTX.", tipo: "bajista" },
        ],
        analisisTecnico: "El doble techo de 64K-69K es uno de los patrones más claros de la historia cripto. El segundo máximo (69K) formó con MENOR volumen que el primero (64K) — señal clásica de agotamiento comprador y distribución institucional. La línea de cuello estaba en ~29K. La ruptura definitiva de esos 29K en junio 2022 activó el objetivo técnico teórico de ~0$ (proyectando la altura del patrón). MVRV en 3.8 en el techo (históricamente zona de venta) y NUPL en 0.79 (euforia extrema).",
        senalesOnchain: "Exchange Inflow en máximos históricos durante octubre-noviembre 2021: las ballenas enviaban BTC a los exchanges para vender. El Long/Short Holder Profit en máximos. Las métricas de Glassnode mostraban que los holders a largo plazo estaban distribuyendo activamente por primera vez desde el techo de 2018.",
        leccionesAprendidas: [
          "Cuando el Fear & Greed lleva semanas por encima de 80, empieza a reducir exposición gradualmente",
          "El segundo máximo con menos volumen que el primero es SIEMPRE una señal de alerta roja",
          "El NUPL por encima de 0.75 históricamente precede correcciones del 50%+. Actúa antes de que el mercado caiga.",
          "Las aprobaciones regulatorias positivas (ETF) suelen marcar techos de corto-medio plazo — \"buy the rumor, sell the news\"",
          "El precio puede seguir subiendo mientras las ballenas venden: el FOMO retail es el comprador de última instancia",
        ],
        comoAplicarlo: "En el próximo bull run, monitorea: (1) NUPL > 0.7 → empieza a tomar beneficios parciales. (2) Segundo máximo con volumen decreciente → señal de distribución. (3) Exchange Inflow creciente → ballenas vendiendo. (4) Fear & Greed > 85 durante 3+ semanas → alerta máxima. Establece un plan de salida escalonada: vende 20% en cada nuevo ATH significativo.",
        conclusionFinal: "El Bull Run 2021 no fue una anomalía — fue un manual de cómo funcionan los ciclos de mercado. Identificar la distribución institucional ANTES de que el precio caiga es la habilidad más valiosa de un trader. Las señales estaban ahí. El que las supo leer vendió en los 60.000$. El que no, compró en los 69.000$ y esperó 2 años para recuperar.",
        datosCarouselLabels: {
          ath: "ATH alcanzado",
          caida: "Caída posterior",
          duracion_bear: "Duración bear",
          nupl_techo: "NUPL en techo",
          fg_techo: "F&G en techo",
          capital_destruido: "Capital destruido",
        },
      },
      en: {
        "categoria": "DISTRIBUTION",
        "titulo": "BTC Bull Run 2021: ETF Euphoria Top",
        "subtitulo": "How institutional selling at ATH created the double top that destroyed the market",
        "descripcion": "How institutional selling at ATH created the distribution pattern that led to a 77% bear market.",
        "duracionLectura": "18 min",
        "nivel": "Intermediate",
        "resumen": "The 2021 Bull Run ended exactly as it always does in financial markets: with institutions quietly selling while retail bought euphorically. Bitcoin hit $64,000 in April, then $69,000 in November. Both highs were massive institutional distribution opportunities. What followed was the most severe bear market since 2018.",
        "contexto": "In 2020-2021 the narrative was perfect: COVID monetary policy, massive money printing, rising inflation, and Bitcoin positioned as \"digital gold\". MicroStrategy, Tesla, Square were buying publicly. Bitcoin futures ETFs in the U.S. were approved for the first time. Fear of missing out (FOMO) was at its peak. The Fear & Greed Index was marking 95/100 week after week.",
        "timeline": [
                {
                        "fecha": "Feb 2021",
                        "titulo": "First ATH: $58,000",
                        "descripcion": "Tesla announces $1.5B BTC purchase. The market explodes upward. Massive FOMO.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Apr 2021",
                        "titulo": "ATH of $64,000",
                        "descripcion": "Coinbase goes public on Nasdaq (COIN). Bitcoin reaches all-time highs. NUPL in euphoria zone (>0.75). First top of the double top.",
                        "tipo": "critico"
                },
                {
                        "fecha": "May 2021",
                        "titulo": "55% crash in 3 weeks",
                        "descripcion": "China bans mining. Tesla sells BTC. Cascade of liquidations. From 64K to 29K in 3 weeks. One of the fastest crashes in history.",
                        "tipo": "bajista"
                },
                {
                        "fecha": "Jul 2021",
                        "titulo": "Recovery and consolidation",
                        "descripcion": "BTC stabilizes in the 30-40K zone. Wyckoff Spring formation. Institutions accumulate quietly. Retail is fearful.",
                        "tipo": "neutro"
                },
                {
                        "fecha": "Oct 2021",
                        "titulo": "New ATH: $67,000",
                        "descripcion": "Approval of the first Bitcoin futures ETF in the U.S. (ProShares BITO). Explosive rally. Second top of the double top.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Nov 2021",
                        "titulo": "Final ATH: $69,000",
                        "descripcion": "Price cannot break above the previous ATH with strength. Decreasing volume. NUPL at historical highs. Institutions finish distribution.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Nov 2021 – Dec 2022",
                        "titulo": "Bear Market: -77%",
                        "descripcion": "Gradual but relentless drop. From 69K to 15.5K in 13 months. Contagion: LUNA, 3AC, Celsius, FTX.",
                        "tipo": "bajista"
                }
        ],
        "analisisTecnico": "The 64K-69K double top is one of the clearest patterns in crypto history. The second high (69K) formed with LOWER volume than the first (64K) — classic signal of buyer exhaustion and institutional distribution. The neckline was at ~29K. The definitive break of that 29K in June 2022 activated the theoretical technical target of ~$0 (projecting the pattern's height). MVRV at 3.8 at the top (historically a selling zone) and NUPL at 0.79 (extreme euphoria).",
        "senalesOnchain": "Exchange Inflow at all-time highs during October-November 2021: whales were sending BTC to exchanges to sell. Long/Short Holder Profit at highs. Glassnode metrics showed that long-term holders were actively distributing for the first time since the 2018 top.",
        "leccionesAprendidas": [
                "When Fear & Greed stays above 80 for weeks, start reducing exposure gradually",
                "A second high with less volume than the first is ALWAYS a red alert signal",
                "NUPL above 0.75 has historically preceded 50%+ corrections. Act before the market drops.",
                "Positive regulatory approvals (ETF) often mark short-to-medium term tops — \"buy the rumor, sell the news\"",
                "Price can keep rising while whales are selling: retail FOMO is the buyer of last resort"
        ],
        "comoAplicarlo": "In the next bull run, monitor: (1) NUPL > 0.7 → start taking partial profits. (2) Second high with decreasing volume → distribution signal. (3) Rising Exchange Inflow → whales selling. (4) Fear & Greed > 85 for 3+ weeks → maximum alert. Establish a staggered exit plan: sell 20% at each significant new ATH.",
        "conclusionFinal": "The 2021 Bull Run was not an anomaly — it was a textbook on how market cycles work. Identifying institutional distribution BEFORE the price drops is the most valuable skill of a trader. The signals were there. Those who knew how to read them sold at $60,000. Those who didn't bought at $69,000 and waited 2 years to recover.",
        "datosCarouselLabels": {
                "ath": "ATH reached",
                "caida": "Subsequent drop",
                "duracion_bear": "Bear duration",
                "nupl_techo": "NUPL at top",
                "fg_techo": "F&G at top",
                "capital_destruido": "Capital destroyed"
        }
},
      sk: {
        "categoria": "DISTRIBÚCIA",
        "titulo": "BTC Bull Run 2021: Strop Eufórie ETF",
        "subtitulo": "Ako inštitucionálny predaj na ATH vytvoril dvojitý vrchol, ktorý zničil trh",
        "descripcion": "Ako inštitucionálny predaj na ATH vytvoril distribučný vzor, ktorý viedol k bear marketu -77%.",
        "duracionLectura": "18 min",
        "nivel": "Stredne pokročilý",
        "resumen": "Bull Run 2021 skončil presne tak, ako to vždy funguje na finančných trhoch: inštitucionálni hráči predávali potichu, zatiaľ čo retailoví investori euforicky nakupovali. Bitcoin dosiahol 64 000$ v apríli, potom 69 000$ v novembri. Obe maximá boli príležitosťami pre masívnu inštitucionálnu distribúciu. Následoval najtvrdší bear market od roku 2018.",
        "contexto": "V rokoch 2020-2021 bol príbeh dokonalý: COVID menová politika, masívne tlačenie peňazí, rastúca inflácia a Bitcoin pozicionovaný ako \"digitálne zlato\". MicroStrategy, Tesla, Square nakupovali verejne. ETF na futures Bitcoinu v USA boli po prvýkrát schválené. FOMO bol na maxime. Fear & Greed Index ukazoval 95/100 týždeň čo týždeň.",
        "timeline": [
                {
                        "fecha": "Feb 2021",
                        "titulo": "Prvé ATH: 58 000$",
                        "descripcion": "Tesla oznamuje nákup BTC za 1,5 mld. Trh exploduje nahor. Masívne FOMO.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Apr 2021",
                        "titulo": "ATH 64 000$",
                        "descripcion": "Coinbase vstupuje na burzu Nasdaq (COIN). Bitcoin dosahuje historické maximá. NUPL v zóne eufórie (>0.75). Prvý vrchol dvojitého vrcholu.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Máj 2021",
                        "titulo": "Crash -55% za 3 týždne",
                        "descripcion": "Čína zakazuje ťažbu. Tesla predáva BTC. Kaskáda likvidácií. Z 64K na 29K za 3 týždne. Jeden z najrýchlejších crashov v histórii.",
                        "tipo": "bajista"
                },
                {
                        "fecha": "Júl 2021",
                        "titulo": "Obnova a konsolidácia",
                        "descripcion": "BTC sa stabilizuje v zóne 30-40K. Wyckoff Spring formácia. Inštitucionálni hráči potichu akumulujú. Retail má strach.",
                        "tipo": "neutro"
                },
                {
                        "fecha": "Okt 2021",
                        "titulo": "Nové ATH: 67 000$",
                        "descripcion": "Schválenie prvého ETF na Bitcoin futures v USA (ProShares BITO). Explozívne rally. Druhý vrchol dvojitého vrcholu.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Nov 2021",
                        "titulo": "Finálne ATH: 69 000$",
                        "descripcion": "Cena nedokáže prekonať predchádzajúce ATH so silou. Klesajúci objem. NUPL na historických maximách. Inštitucionálni hráči dokončujú distribúciu.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Nov 2021 – Dec 2022",
                        "titulo": "Bear Market: -77%",
                        "descripcion": "Postupný, ale neúprosný pokles. Z 69K na 15,5K za 13 mesiacov. Nákaza: LUNA, 3AC, Celsius, FTX.",
                        "tipo": "bajista"
                }
        ],
        "analisisTecnico": "Dvojitý vrchol 64K-69K je jedným z najjasnejších vzorov v histórii krypta. Druhé maximum (69K) sa formovalo s NIŽŠÍM objemom ako prvé (64K) — klasický signál vyčerpania kupujúcich a inštitucionálnej distribúcie. Línia krku bola na ~29K. Definitívny prelom týchto 29K v júni 2022 aktivoval teoretický technický cieľ ~0$ (projekcia výšky vzoru). MVRV na 3,8 na vrchole (historicky zóna predaja) a NUPL na 0,79 (extrémna eufória).",
        "senalesOnchain": "Exchange Inflow na historických maximách počas októbra-novembra 2021: veľryby posielali BTC na burzy, aby predávali. Long/Short Holder Profit na maximách. Metriky Glassnode ukazovali, že dlhodobí držitelia aktívne distribuovali po prvýkrát od vrcholu 2018.",
        "leccionesAprendidas": [
                "Keď Fear & Greed je týždne nad 80, začni postupne znižovať expozíciu",
                "Druhé maximum s nižším objemom ako prvé je VŽDY signál červeného poplachu",
                "NUPL nad 0,75 historicky predchádza korekciám 50%+. Konaj skôr, ako trh spadne.",
                "Pozitívne regulačné schválenia (ETF) zvyčajne označujú krátkodobé až strednodobé stropy — \"buy the rumor, sell the news\"",
                "Cena môže pokračovať v raste, zatiaľ čo veľryby predávajú: retail FOMO je kupujúci poslednej inštancie"
        ],
        "comoAplicarlo": "V ďalšom bull rune monitoruj: (1) NUPL > 0,7 → začni realizovať čiastočné zisky. (2) Druhé maximum s klesajúcim objemom → signál distribúcie. (3) Rastúci Exchange Inflow → veľryby predávajú. (4) Fear & Greed > 85 počas 3+ týždňov → maximálna výstraha. Vytvor stupňovitý výstupný plán: predaj 20% pri každom významnom novom ATH.",
        "conclusionFinal": "Bull Run 2021 nebol anomália — bol to učebnicový príklad fungovania trhových cyklov. Identifikovať inštitucionálnu distribúciu PREDTÝM, ako cena spadne, je najcennejšia schopnosť tradera. Signály tam boli. Ten, kto ich vedel čítať, predal na 60 000$. Ten, kto nie, nakúpil na 69 000$ a čakal 2 roky na zotavenie.",
        "datosCarouselLabels": {
                "ath": "Dosiahnuté ATH",
                "caida": "Následný pokles",
                "duracion_bear": "Trvanie bear marketu",
                "nupl_techo": "NUPL na vrchole",
                "fg_techo": "F&G na vrchole",
                "capital_destruido": "Zničený kapitál"
        }
},
      de: {
        categoria: "DISTRIBUTION",
        titulo: "BTC Bull Run 2021: Euphorie-Decke durch ETF",
        subtitulo: "Wie institutioneller Verkauf am ATH das Doppeltop schuf, das den Markt zerstörte",
        descripcion: "Wie institutioneller Verkauf am ATH das Distributionsmuster schuf, das zu einem 77%igen Bärenmarkt führte.",
        duracionLectura: "18 min",
        nivel: "Fortgeschritten",
        resumen: "Der Bull Run von 2021 endete genau so, wie es in Finanzmärkten immer geschieht: mit institutionellen Verkäufern, die still verkauften, während euphorische Privatanleger kauften. Bitcoin erreichte 64.000$ im April, dann 69.000$ im November. Beide Höchststände waren Gelegenheiten für massive institutionelle Distribution. Was folgte, war der schwerste Bärenmarkt seit 2018.",
        contexto: "In 2020-2021 war das Narrativ perfekt: COVID-Geldpolitik, massive Gelddruckerei, steigende Inflation und Bitcoin positioniert als \"digital gold\". MicroStrategy, Tesla, Square kauften öffentlich. Die Bitcoin-Futures-ETFs in den USA wurden zum ersten Mal genehmigt. Die Angst, die Bewegung zu verpassen (FOMO), war maximal. Der Fear & Greed Index zeigte Woche für Woche 95/100.",
        timeline: [
          {
            fecha: "Feb 2021",
            titulo: "Erstes ATH: 58.000$",
            descripcion: "Tesla kündigt Kauf von 1,5 Mrd. in BTC an. Der Markt explodiert nach oben. Massives FOMO.",
            tipo: "alcista"
          },
          {
            fecha: "Abr 2021",
            titulo: "ATH von 64.000$",
            descripcion: "Coinbase geht an der Nasdaq an die Börse (COIN). Bitcoin erreicht historische Höchststände. NUPL in Euphoriezone (>0,75). Erstes Top des Doppeltops.",
            tipo: "critico"
          },
          {
            fecha: "May 2021",
            titulo: "Crash von 55% in 3 Wochen",
            descripcion: "China verbietet Mining. Tesla verkauft BTC. Kaskade von Liquidationen. Von 64K auf 29K in 3 Wochen. Einer der schnellsten Crashes der Geschichte.",
            tipo: "bajista"
          },
          {
            fecha: "Jul 2021",
            titulo: "Erholung und Konsolidierung",
            descripcion: "BTC stabilisiert sich in der Zone 30-40K. Wyckoff Spring Formation. Institutionelle akkumulieren still. Privatanleger haben Angst.",
            tipo: "neutro"
          },
          {
            fecha: "Oct 2021",
            titulo: "Neues ATH: 67.000$",
            descripcion: "Genehmigung des ersten Bitcoin-Futures-ETF in den USA (ProShares BITO). Explosive Rally. Zweites Top des Doppeltops.",
            tipo: "critico"
          },
          {
            fecha: "Nov 2021",
            titulo: "Finales ATH: 69.000$",
            descripcion: "Der Preis kann das vorherige ATH nicht mit Kraft überschreiten. Abnehmendes Volumen. NUPL auf historischen Höchstständen. Institutionelle beenden die Distribution.",
            tipo: "critico"
          },
          {
            fecha: "Nov 2021 – Dic 2022",
            titulo: "Bärenmarkt: -77%",
            descripcion: "Allmählicher aber unerbittlicher Fall. Von 69K auf 15,5K in 13 Monaten. Ansteckung: LUNA, 3AC, Celsius, FTX.",
            tipo: "bajista"
          }
        ],
        analisisTecnico: "Das Doppeltop von 64K-69K ist eines der klarsten Muster in der Krypto-Geschichte. Das zweite Maximum (69K) bildete sich mit GERINGEREM Volumen als das erste (64K) — klassisches Signal für Käufererschöpfung und institutionelle Distribution. Die Nackenlinie lag bei ~29K. Der definitive Bruch dieser 29K im Juni 2022 aktivierte das theoretische technische Ziel von ~0$ (Projektion der Musterhöhe). MVRV bei 3,8 am Top (historisch Verkaufszone) und NUPL bei 0,79 (extreme Euphorie).",
        senalesOnchain: "Exchange Inflow auf historischen Höchstständen während Oktober-November 2021: Wale schickten BTC an Börsen zum Verkauf. Der Long/Short Holder Profit auf Höchstständen. Die Glassnode-Metriken zeigten, dass langfristige Holder zum ersten Mal seit dem Top von 2018 aktiv distribuierten.",
        leccionesAprendidas: [
          "Wenn Fear & Greed wochenlang über 80 liegt, beginne schrittweise Exposition zu reduzieren",
          "Das zweite Maximum mit weniger Volumen als das erste ist IMMER ein rotes Warnsignal",
          "NUPL über 0,75 geht historisch Korrekturen von 50%+ voraus. Handle, bevor der Markt fällt.",
          "Positive regulatorische Genehmigungen (ETF) markieren oft kurz- bis mittelfristige Tops — \"buy the rumor, sell the news\"",
          "Der Preis kann weiter steigen, während Wale verkaufen: Retail-FOMO ist der Käufer letzter Instanz"
        ],
        comoAplicarlo: "Im nächsten Bull Run überwache: (1) NUPL > 0,7 → beginne partielle Gewinne zu realisieren. (2) Zweites Maximum mit abnehmendem Volumen → Distributionssignal. (3) Steigender Exchange Inflow → Wale verkaufen. (4) Fear & Greed > 85 für 3+ Wochen → maximale Warnung. Etabliere einen gestaffelten Ausstiegsplan: verkaufe 20% bei jedem signifikanten neuen ATH.",
        conclusionFinal: "Der Bull Run 2021 war keine Anomalie — er war ein Lehrbuch darüber, wie Marktzyklen funktionieren. Institutionelle Distribution zu identifizieren, BEVOR der Preis fällt, ist die wertvollste Fähigkeit eines Traders. Die Signale waren da. Wer sie lesen konnte, verkaufte bei 60.000$. Wer nicht, kaufte bei 69.000$ und wartete 2 Jahre auf Erholung.",
        datosCarouselLabels: {
          ath: "ATH erreicht",
          caida: "Nachfolgender Fall",
          duracion_bear: "Bärenmarkt-Dauer",
          nupl_techo: "NUPL am Top",
          fg_techo: "F&G am Top",
          capital_destruido: "Vernichtetes Kapital"
        }
      },
      "zh-CN": {
        categoria: "派发",
        titulo: "BTC 2021牛市：ETF狂热顶部",
        subtitulo: "机构如何在历史高点抛售，形成摧毁市场的双顶",
        descripcion: "机构如何在历史高点抛售，形成导致77%熊市的派发形态。",
        duracionLectura: "18分钟",
        nivel: "中级",
        resumen: "2021年牛市的结束方式与金融市场历来的规律完全一致：机构悄然抛售，散户狂热买入。Bitcoin在4月触及64,000美元，随后在11月达到69,000美元。两个高点都是机构大规模派发的机会。随之而来的是自2018年以来最严重的熊市。",
        contexto: "2020-2021年的叙事堪称完美：COVID货币政策、大规模印钞、通胀上升，Bitcoin被定位为\"数字黄金\"。MicroStrategy、Tesla、Square公开买入。美国首次批准Bitcoin期货ETF。错失恐惧症（FOMO）达到顶峰。Fear & Greed指数连续数周维持在95/100。",
        timeline: [
          {
            fecha: "Feb 2021",
            titulo: "首次ATH：58,000美元",
            descripcion: "Tesla宣布购买15亿美元BTC。市场爆发式上涨。大规模FOMO。",
            tipo: "alcista"
          },
          {
            fecha: "Abr 2021",
            titulo: "ATH 64,000美元",
            descripcion: "Coinbase在Nasdaq上市（COIN）。Bitcoin触及历史高点。NUPL进入狂热区（>0.75）。双顶的第一个顶部。",
            tipo: "critico"
          },
          {
            fecha: "May 2021",
            titulo: "3周内暴跌55%",
            descripcion: "中国禁止挖矿。Tesla抛售BTC。连环爆仓。从64K跌至29K，仅用3周。历史上最快的崩盘之一。",
            tipo: "bajista"
          },
          {
            fecha: "Jul 2021",
            titulo: "复苏与盘整",
            descripcion: "BTC稳定在30-40K区间。Wyckoff Spring形态。机构悄然积累。散户恐慌。",
            tipo: "neutro"
          },
          {
            fecha: "Oct 2021",
            titulo: "新ATH：67,000美元",
            descripcion: "美国首个Bitcoin期货ETF获批（ProShares BITO）。爆发式上涨。双顶的第二个顶部。",
            tipo: "critico"
          },
          {
            fecha: "Nov 2021",
            titulo: "最终ATH：69,000美元",
            descripcion: "价格无法强势突破前高。交易量递减。NUPL创历史新高。机构完成派发。",
            tipo: "critico"
          },
          {
            fecha: "Nov 2021 – Dic 2022",
            titulo: "熊市：-77%",
            descripcion: "渐进但无情的下跌。13个月内从69K跌至15.5K。传染效应：LUNA、3AC、Celsius、FTX。",
            tipo: "bajista"
          }
        ],
        analisisTecnico: "64K-69K的双顶是加密货币历史上最清晰的形态之一。第二个高点（69K）的交易量低于第一个高点（64K）——这是买盘枯竭和机构派发的经典信号。颈线位于约29K。2022年6月对29K的决定性突破触发了理论目标位约0美元（投射形态高度）。顶部时MVRV为3.8（历史上的抛售区域），NUPL为0.79（极度狂热）。",
        senalesOnchain: "2021年10月至11月期间，交易所流入量创历史新高：巨鲸将BTC转入交易所准备抛售。长期/短期持有者利润达到峰值。Glassnode的指标显示，长期持有者自2018年顶部以来首次主动派发。",
        leccionesAprendidas: [
          "当Fear & Greed指数连续数周超过80时，开始逐步减少仓位",
          "第二个高点交易量低于第一个高点，永远是红色警报信号",
          "NUPL超过0.75在历史上预示着50%以上的回调。在市场下跌前行动。",
          "积极的监管批准（ETF）通常标志着中短期顶部——\"传闻买入，消息卖出\"",
          "巨鲸抛售时价格可能继续上涨：散户FOMO是最后的买家"
        ],
        comoAplicarlo: "在下一轮牛市中，监控：(1) NUPL > 0.7 → 开始部分获利。(2) 第二个高点交易量递减 → 派发信号。(3) 交易所流入量增加 → 巨鲸抛售。(4) Fear & Greed > 85持续3周以上 → 最高警戒。制定分批退出计划：每次新的重要ATH卖出20%。",
        conclusionFinal: "2021年牛市并非异常——它是市场周期运作的教科书。在价格下跌之前识别机构派发是交易者最宝贵的技能。信号就在那里。读懂信号的人在60,000美元卖出。没读懂的人在69,000美元买入，等了2年才回本。",
        datosCarouselLabels: {
          ath: "达到的ATH",
          caida: "随后跌幅",
          duracion_bear: "熊市持续时间",
          nupl_techo: "顶部NUPL",
          fg_techo: "顶部F&G",
          capital_destruido: "摧毁的资本"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 2 · Crash COVID 2020
  // ───────────────────────────────────────────────────────────
  {
    slug: "crash-covid-2020",
    colorCategoria: "#00e676",
    nivel: "basico",
    datosCarousel: [
      { key: "minimo", valor: "3.800$", color: "#ff3355" },
      { key: "caida_24h", valor: "-50%", color: "#ff3355" },
      { key: "rally_post", valor: "+1.584%", color: "#00e676" },
      { key: "ath_sig", valor: "69.000$", color: "#f5a623" },
      { key: "tiempo_ath", valor: "13 meses", color: "#00e676" },
      { key: "fg_minimo", valor: "8/100", color: "#00e676" },
    ],
    i18n: {
      es: {
        categoria: "ACUMULACIÓN",
        titulo: "Crash COVID Marzo 2020 y Recuperación",
        subtitulo: "El crash más rápido de la historia y la acumulación institucional que siguió",
        descripcion: "Analizando el crash cripto del 50% más rápido y la acumulación institucional que siguió.",
        duracionLectura: "15 min",
        nivel: "Básico",
        resumen: "El 12 de marzo de 2020, Bitcoin perdió el 50% de su valor en menos de 24 horas. El crash más rápido y severo de su historia. Sin embargo, este \"Black Thursday\" resultó ser la mejor oportunidad de compra de la última década. Lo que siguió fue un rally del 1.500% en 18 meses.",
        contexto: "La pandemia COVID-19 declarada por la OMS el 11 de marzo de 2020 provocó un pánico global sin precedentes. Los mercados tradicionales colapsaron (-30% en semanas). El cripto, al ser el activo más líquido y de mayor riesgo, fue el primero en liquidarse. Los traders apalancados fueron destruidos. Pero algo crucial pasaba por debajo: la Fed anunciaba el mayor programa de estímulo monetario de la historia. Y los institucionales lo sabían.",
        timeline: [
          { fecha: "11 Mar 2020", titulo: "OMS declara pandemia", descripcion: "Mercados globales en colapso. BTC en 7.900$.", tipo: "neutro" },
          { fecha: "12 Mar 2020", titulo: "Black Thursday: -50% en 24h", descripcion: "BTC cae de 7.900$ a 3.800$ en menos de 24 horas. Cascada de liquidaciones en exchanges. BitMEX tiene problemas técnicos. 1.000M$ en posiciones liquidadas.", tipo: "critico" },
          { fecha: "15 Mar 2020", titulo: "Fed anuncia QE infinito", descripcion: "La Reserva Federal anuncia compras ilimitadas de activos. Impresión de dinero masiva. Los institucionales entienden que el dinero se va a devaluar.", tipo: "critico" },
          { fecha: "Mar–May 2020", titulo: "Acumulación silenciosa", descripcion: "BTC consolida entre 5.000-10.000$. MicroStrategy analiza BTC como reserva de valor. Las ballenas acumulan en el silencio del retail asustado.", tipo: "alcista" },
          { fecha: "Ago 2020", titulo: "MicroStrategy compra BTC", descripcion: "MicroStrategy compra 250M$ en BTC. Primera empresa pública en adoptar BTC como reserva de tesorería. El catalizador institucional que faltaba.", tipo: "alcista" },
          { fecha: "Oct 2020", titulo: "PayPal habilita BTC", descripcion: "PayPal anuncia que permitirá comprar y vender BTC. 300 millones de usuarios de acceso potencial. El rally comienza formalmente.", tipo: "alcista" },
          { fecha: "Nov 2020", titulo: "BTC supera ATH 2017 (20.000$)", descripcion: "Por primera vez desde diciembre 2017, BTC supera su máximo histórico previo. Confirmación técnica del nuevo bull market.", tipo: "alcista" },
          { fecha: "Abr 2021", titulo: "ATH 64.000$ — 1.500% desde mínimos", descripcion: "Desde los 3.800$ del crash COVID hasta 64.000$. +1.584% en 13 meses. Los que compraron en el pánico multiplicaron por 16.", tipo: "alcista" },
        ],
        analisisTecnico: "El crash de marzo 2020 formó el patrón Wyckoff de Acumulación más claro de la historia de Bitcoin. Selling Climax (SC) en 3.800$, Automatic Rally (AR) a 10.000$, Secondary Test (ST) múltiples veces en 5.000-6.000$. El rango de acumulación duró 7 meses (marzo-octubre 2020). El Jump Across the Creek (JAC) ocurrió cuando BTC superó los 12.000$ en agosto-septiembre 2020.",
        senalesOnchain: "Exchange Outflow masivo durante el verano 2020: las ballenas retiraban BTC de los exchanges (señal de no vender). El NUPL pasó de -0.2 (capitulación) en marzo a zonas positivas en julio. El Puell Multiple tocó mínimos históricos durante el crash.",
        leccionesAprendidas: [
          "Los black swans son las MEJORES oportunidades de compra — si tienes liquidez preparada",
          "El pánico extremo (Fear & Greed < 10) históricamente precede los mejores retornos a 12-18 meses",
          "Los eventos macro que implican impresión masiva de dinero son alcistas para Bitcoin a medio-largo plazo",
          "Mantener siempre un porcentaje de la cartera en liquidez (20-30%) para capturar crashes extraordinarios",
          "En el crash, el Exchange Outflow que sigan las ballenas es más importante que el precio",
        ],
        comoAplicarlo: "Prepara un \"plan de crisis\": define por adelantado a qué niveles comprarías en un black swan. Regla práctica: si BTC cae >40% en <72h, activa el protocolo de compra escalonada. 30% de tu liquidez disponible al primer -40%, 30% al -55%, 40% al -70%. Esto requiere disciplina total — en el momento del crash, todo parece perdido.",
        conclusionFinal: "El COVID crash de 2020 demostró que Bitcoin no es un activo de refugio en el corto plazo (correlaciona con riesgo en crisis), pero sí en el medio-largo plazo cuando el catalizador es monetario. Los que vendieron en el pánico perdieron el mayor bull market de la historia cripto. Los que compraron en el miedo extremo se hicieron millonarios.",
        datosCarouselLabels: {
          minimo: "Mínimo del crash",
          caida_24h: "Caída en 24h",
          rally_post: "Rally posterior",
          ath_sig: "ATH siguiente",
          tiempo_ath: "Tiempo hasta ATH",
          fg_minimo: "F&G en mínimo",
        },
      },
      en: {
        "categoria": "ACCUMULATION",
        "titulo": "COVID Crash March 2020 and Recovery",
        "subtitulo": "The fastest crash in history and the institutional accumulation that followed",
        "descripcion": "Analyzing the fastest 50% crypto crash and the institutional accumulation that followed.",
        "duracionLectura": "15 min",
        "nivel": "Basic",
        "resumen": "On March 12, 2020, Bitcoin lost 50% of its value in less than 24 hours. The fastest and most severe crash in its history. However, this \"Black Thursday\" turned out to be the best buying opportunity of the last decade. What followed was a 1,500% rally in 18 months.",
        "contexto": "The COVID-19 pandemic declared by the WHO on March 11, 2020 triggered unprecedented global panic. Traditional markets collapsed (-30% in weeks). Crypto, being the most liquid and highest-risk asset, was the first to be liquidated. Leveraged traders were destroyed. But something crucial was happening underneath: the Fed announced the largest monetary stimulus program in history. And the institutions knew it.",
        "timeline": [
                {
                        "fecha": "11 Mar 2020",
                        "titulo": "WHO declares pandemic",
                        "descripcion": "Global markets in collapse. BTC at $7,900.",
                        "tipo": "neutro"
                },
                {
                        "fecha": "12 Mar 2020",
                        "titulo": "Black Thursday: -50% in 24h",
                        "descripcion": "BTC falls from $7,900 to $3,800 in less than 24 hours. Cascade of liquidations on exchanges. BitMEX has technical issues. $1B in positions liquidated.",
                        "tipo": "critico"
                },
                {
                        "fecha": "15 Mar 2020",
                        "titulo": "Fed announces infinite QE",
                        "descripcion": "The Federal Reserve announces unlimited asset purchases. Massive money printing. Institutions understand that money will be devalued.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Mar–May 2020",
                        "titulo": "Silent accumulation",
                        "descripcion": "BTC consolidates between $5,000-10,000. MicroStrategy analyzes BTC as store of value. Whales accumulate in the silence of frightened retail.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Aug 2020",
                        "titulo": "MicroStrategy buys BTC",
                        "descripcion": "MicroStrategy buys $250M in BTC. First public company to adopt BTC as treasury reserve. The missing institutional catalyst.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Oct 2020",
                        "titulo": "PayPal enables BTC",
                        "descripcion": "PayPal announces it will allow buying and selling BTC. 300 million users with potential access. The rally formally begins.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Nov 2020",
                        "titulo": "BTC surpasses 2017 ATH ($20,000)",
                        "descripcion": "For the first time since December 2017, BTC surpasses its previous all-time high. Technical confirmation of the new bull market.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Apr 2021",
                        "titulo": "ATH $64,000 — 1,500% from lows",
                        "descripcion": "From $3,800 of the COVID crash to $64,000. +1,584% in 13 months. Those who bought in the panic multiplied by 16.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "The March 2020 crash formed the clearest Wyckoff Accumulation pattern in Bitcoin's history. Selling Climax (SC) at $3,800, Automatic Rally (AR) to $10,000, Secondary Test (ST) multiple times at $5,000-6,000. The accumulation range lasted 7 months (March-October 2020). The Jump Across the Creek (JAC) occurred when BTC surpassed $12,000 in August-September 2020.",
        "senalesOnchain": "Massive Exchange Outflow during summer 2020: whales were withdrawing BTC from exchanges (signal of not selling). NUPL went from -0.2 (capitulation) in March to positive zones in July. The Puell Multiple touched historic lows during the crash.",
        "leccionesAprendidas": [
                "Black swans are the BEST buying opportunities — if you have liquidity prepared",
                "Extreme panic (Fear & Greed < 10) historically precedes the best returns at 12-18 months",
                "Macro events involving massive money printing are bullish for Bitcoin in the medium-long term",
                "Always keep a percentage of the portfolio in liquidity (20-30%) to capture extraordinary crashes",
                "In the crash, the Exchange Outflow that whales follow is more important than the price"
        ],
        "comoAplicarlo": "Prepare a \"crisis plan\": define in advance at what levels you would buy in a black swan. Rule of thumb: if BTC falls >40% in <72h, activate the staggered buying protocol. 30% of your available liquidity at the first -40%, 30% at -55%, 40% at -70%. This requires total discipline — in the moment of the crash, everything seems lost.",
        "conclusionFinal": "The 2020 COVID crash demonstrated that Bitcoin is not a safe-haven asset in the short term (correlates with risk in crises), but it is in the medium-long term when the catalyst is monetary. Those who sold in panic missed the biggest bull market in crypto history. Those who bought in extreme fear became millionaires.",
        "datosCarouselLabels": {
                "minimo": "Crash low",
                "caida_24h": "24h drop",
                "rally_post": "Subsequent rally",
                "ath_sig": "Next ATH",
                "tiempo_ath": "Time to ATH",
                "fg_minimo": "F&G at low"
        }
},
      sk: {
        "categoria": "AKUMULÁCIA",
        "titulo": "COVID Crash marec 2020 a zotavenie",
        "subtitulo": "Najrýchlejší crash v histórii a inštitucionálna akumulácia, ktorá nasledovala",
        "descripcion": "Analyzujeme najrýchlejší 50% crypto crash a inštitucionálnu akumuláciu, ktorá nasledovala.",
        "duracionLectura": "15 min",
        "nivel": "Základná",
        "resumen": "12. marca 2020 Bitcoin stratil 50% svojej hodnoty za menej ako 24 hodín. Najrýchlejší a najtvrdší crash v jeho histórii. Tento \"Black Thursday\" sa však ukázal byť najlepšou nákupnou príležitosťou za poslednú dekádu. Nasledoval rally o 1 500% za 18 mesiacov.",
        "contexto": "Pandémia COVID-19 vyhlásená WHO 11. marca 2020 spôsobila bezprecedentnú globálnu paniku. Tradičné trhy sa zrútili (-30% za týždne). Crypto, ako najlikvidnejšie a najrizikovejšie aktívum, bolo prvé, ktoré sa likvidovalo. Pákou obchodujúci traderi boli zničení. Ale niečo kľúčové sa dialo pod povrchom: Fed ohlásil najväčší program monetárneho stimulu v histórii. A inštitucionálni investori to vedeli.",
        "timeline": [
                {
                        "fecha": "11 Mar 2020",
                        "titulo": "WHO vyhlasuje pandémiu",
                        "descripcion": "Globálne trhy kolabujú. BTC na 7 900$.",
                        "tipo": "neutro"
                },
                {
                        "fecha": "12 Mar 2020",
                        "titulo": "Black Thursday: -50% za 24h",
                        "descripcion": "BTC klesá z 7 900$ na 3 800$ za menej ako 24 hodín. Kaskáda likvidácií na burzách. BitMEX má technické problémy. 1 000M$ v pozíciách zlikvidovaných.",
                        "tipo": "critico"
                },
                {
                        "fecha": "15 Mar 2020",
                        "titulo": "Fed oznamuje neobmedzené QE",
                        "descripcion": "Federálny rezervný systém oznamuje neobmedzené nákupy aktív. Masívna tlač peňazí. Inštitucionálni investori chápu, že peniaze sa budú znehodnocovať.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Mar–Máj 2020",
                        "titulo": "Tichá akumulácia",
                        "descripcion": "BTC konsoliduje medzi 5 000-10 000$. MicroStrategy analyzuje BTC ako uchovateľ hodnoty. Veľryby akumulujú v tichu vystrašených retailových investorov.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Aug 2020",
                        "titulo": "MicroStrategy nakupuje BTC",
                        "descripcion": "MicroStrategy nakupuje BTC za 250M$. Prvá verejná spoločnosť, ktorá prijíma BTC ako rezervu pokladnice. Chýbajúci inštitucionálny katalyzátor.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Okt 2020",
                        "titulo": "PayPal sprístupňuje BTC",
                        "descripcion": "PayPal oznamuje, že umožní nákup a predaj BTC. 300 miliónov používateľov s potenciálnym prístupom. Rally formálne začína.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Nov 2020",
                        "titulo": "BTC prekonáva ATH z 2017 (20 000$)",
                        "descripcion": "Prvýkrát od decembra 2017 BTC prekonáva svoje predchádzajúce historické maximum. Technické potvrdenie nového bull marketu.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Apr 2021",
                        "titulo": "ATH 64 000$ — 1 500% od miním",
                        "descripcion": "Od 3 800$ z COVID crashu po 64 000$. +1 584% za 13 mesiacov. Tí, čo nakúpili v panike, zmnožili svoj kapitál 16-krát.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "Crash z marca 2020 vytvoril najjasnejší Wyckoffov vzor akumulácie v histórii Bitcoinu. Selling Climax (SC) na 3 800$, Automatic Rally (AR) na 10 000$, viaceré Secondary Testy (ST) na 5 000-6 000$. Akumulačné pásmo trvalo 7 mesiacov (marec-október 2020). Jump Across the Creek (JAC) nastal, keď BTC prekonal 12 000$ v auguste-septembri 2020.",
        "senalesOnchain": "Masívny Exchange Outflow počas leta 2020: veľryby sťahovali BTC z búrz (signál nepredávať). NUPL prešiel z -0,2 (kapitulácia) v marci do pozitívnych zón v júli. Puell Multiple sa dotkol historických miním počas crashu.",
        "leccionesAprendidas": [
                "Black swany sú NAJLEPŠIE nákupné príležitosti — ak máte pripravenú likviditu",
                "Extrémna panika (Fear & Greed < 10) historicky predchádza najlepším výnosom za 12-18 mesiacov",
                "Makro udalosti zahŕňajúce masívnu tlač peňazí sú bullish pre Bitcoin v strednodobom až dlhodobom horizonte",
                "Vždy udržiavať časť portfólia v likvidite (20-30%) na zachytenie mimoriadnych crashov",
                "Pri crashi je Exchange Outflow, ktorý nasledujú veľryby, dôležitejší ako cena"
        ],
        "comoAplicarlo": "Pripravte si \"krízový plán\": vopred definujte, na akých úrovniach by ste nakupovali pri black swane. Praktické pravidlo: ak BTC klesne >40% za <72h, aktivujte protokol postupného nákupu. 30% vašej dostupnej likvidity pri prvých -40%, 30% pri -55%, 40% pri -70%. To vyžaduje úplnú disciplínu — v momente crashu sa všetko zdá stratené.",
        "conclusionFinal": "COVID crash z 2020 preukázal, že Bitcoin nie je krátkodobo útočiskové aktívum (koreluje s rizikom v kríze), ale áno strednodobě až dlhodobo, keď je katalyzátorom monetárna politika. Tí, čo predali v panike, prišli o najväčší bull market v histórii krypta. Tí, čo nakúpili v extrémnom strachu, sa stali milionármi.",
        "datosCarouselLabels": {
                "minimo": "Minimum crashu",
                "caida_24h": "Pokles za 24h",
                "rally_post": "Následný rally",
                "ath_sig": "Nasledujúce ATH",
                "tiempo_ath": "Čas do ATH",
                "fg_minimo": "F&G na minime"
        }
},
      de: {
        categoria: "AKKUMULATION",
        titulo: "COVID-Crash März 2020 und Erholung",
        subtitulo: "Der schnellste Crash der Geschichte und die institutionelle Akkumulation, die folgte",
        descripcion: "Analyse des schnellsten 50%-Krypto-Crashs und der institutionellen Akkumulation, die folgte.",
        duracionLectura: "15 min",
        nivel: "Grundlegend",
        resumen: "Am 12. März 2020 verlor Bitcoin 50% seines Wertes in weniger als 24 Stunden. Der schnellste und schwerste Crash seiner Geschichte. Doch dieser \"Black Thursday\" erwies sich als die beste Kaufgelegenheit des letzten Jahrzehnts. Was folgte, war eine Rally von 1.500% in 18 Monaten.",
        contexto: "Die von der WHO am 11. März 2020 ausgerufene COVID-19-Pandemie löste eine beispiellose globale Panik aus. Die traditionellen Märkte kollabierten (-30% in Wochen). Krypto, als liquidester und risikoreichster Vermögenswert, wurde als erstes liquidiert. Gehebelte Trader wurden vernichtet. Aber etwas Entscheidendes geschah im Hintergrund: Die Fed kündigte das größte monetäre Stimulusprogramm der Geschichte an. Und die Institutionellen wussten es.",
        timeline: [
          {
            fecha: "11 Mar 2020",
            titulo: "WHO erklärt Pandemie",
            descripcion: "Globale Märkte im Kollaps. BTC bei 7.900$.",
            tipo: "neutro"
          },
          {
            fecha: "12 Mar 2020",
            titulo: "Black Thursday: -50% in 24h",
            descripcion: "BTC fällt von 7.900$ auf 3.800$ in weniger als 24 Stunden. Kaskade von Liquidationen an Exchanges. BitMEX hat technische Probleme. 1.000M$ an Positionen liquidiert.",
            tipo: "critico"
          },
          {
            fecha: "15 Mar 2020",
            titulo: "Fed kündigt unbegrenztes QE an",
            descripcion: "Die Federal Reserve kündigt unbegrenzte Anleihekäufe an. Massive Gelddruckerei. Die Institutionellen verstehen, dass das Geld entwertet werden wird.",
            tipo: "critico"
          },
          {
            fecha: "Mar–May 2020",
            titulo: "Stille Akkumulation",
            descripcion: "BTC konsolidiert zwischen 5.000-10.000$. MicroStrategy analysiert BTC als Wertaufbewahrungsmittel. Die Wale akkumulieren in der Stille der verängstigten Retail-Investoren.",
            tipo: "alcista"
          },
          {
            fecha: "Ago 2020",
            titulo: "MicroStrategy kauft BTC",
            descripcion: "MicroStrategy kauft BTC für 250M$. Erstes börsennotiertes Unternehmen, das BTC als Treasury-Reserve übernimmt. Der fehlende institutionelle Katalysator.",
            tipo: "alcista"
          },
          {
            fecha: "Oct 2020",
            titulo: "PayPal ermöglicht BTC",
            descripcion: "PayPal kündigt an, dass es den Kauf und Verkauf von BTC ermöglichen wird. 300 Millionen Nutzer mit potenziellem Zugang. Die Rally beginnt offiziell.",
            tipo: "alcista"
          },
          {
            fecha: "Nov 2020",
            titulo: "BTC übertrifft ATH 2017 (20.000$)",
            descripcion: "Zum ersten Mal seit Dezember 2017 übertrifft BTC sein vorheriges Allzeithoch. Technische Bestätigung des neuen Bullenmarkts.",
            tipo: "alcista"
          },
          {
            fecha: "Abr 2021",
            titulo: "ATH 64.000$ — 1.500% seit Tiefstständen",
            descripcion: "Von 3.800$ des COVID-Crashs bis 64.000$. +1.584% in 13 Monaten. Diejenigen, die in der Panik kauften, vervielfachten ihr Kapital um das 16-fache.",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "Der Crash vom März 2020 bildete das klarste Wyckoff-Akkumulationsmuster in der Geschichte von Bitcoin. Selling Climax (SC) bei 3.800$, Automatic Rally (AR) auf 10.000$, Secondary Test (ST) mehrfach bei 5.000-6.000$. Die Akkumulationsphase dauerte 7 Monate (März-Oktober 2020). Der Jump Across the Creek (JAC) erfolgte, als BTC die 12.000$ im August-September 2020 überschritt.",
        senalesOnchain: "Massiver Exchange Outflow während des Sommers 2020: Die Wale zogen BTC von den Exchanges ab (Signal für Nicht-Verkauf). Der NUPL stieg von -0,2 (Kapitulation) im März auf positive Bereiche im Juli. Das Puell Multiple erreichte während des Crashs historische Tiefststände.",
        leccionesAprendidas: [
          "Black Swans sind die BESTEN Kaufgelegenheiten — wenn man vorbereitete Liquidität hat",
          "Extreme Panik (Fear & Greed < 10) geht historisch den besten Renditen nach 12-18 Monaten voraus",
          "Makroereignisse, die massive Gelddruckerei bedeuten, sind mittelfristig bis langfristig bullisch für Bitcoin",
          "Immer einen Prozentsatz des Portfolios in Liquidität halten (20-30%), um außergewöhnliche Crashes zu nutzen",
          "Beim Crash ist der Exchange Outflow der Wale wichtiger als der Preis"
        ],
        comoAplicarlo: "Bereite einen \"Krisenplan\" vor: Definiere im Voraus, auf welchen Niveaus du bei einem Black Swan kaufen würdest. Faustregel: Wenn BTC >40% in <72h fällt, aktiviere das gestaffelte Kaufprotokoll. 30% deiner verfügbaren Liquidität beim ersten -40%, 30% bei -55%, 40% bei -70%. Dies erfordert absolute Disziplin — im Moment des Crashs scheint alles verloren.",
        conclusionFinal: "Der COVID-Crash von 2020 zeigte, dass Bitcoin kurzfristig kein sicherer Hafen ist (korreliert mit Risiko in Krisen), aber mittelfristig bis langfristig schon, wenn der Katalysator monetär ist. Diejenigen, die in der Panik verkauften, verpassten den größten Bullenmarkt in der Krypto-Geschichte. Diejenigen, die in extremer Angst kauften, wurden Millionäre.",
        datosCarouselLabels: {
          minimo: "Crash-Minimum",
          caida_24h: "Rückgang in 24h",
          rally_post: "Nachfolgende Rally",
          ath_sig: "Nächstes ATH",
          tiempo_ath: "Zeit bis ATH",
          fg_minimo: "F&G bei Minimum"
        }
      },
      "zh-CN": {
        categoria: "ACUMULACIÓN",
        titulo: "2020年3月COVID崩盘与复苏",
        subtitulo: "史上最快崩盘及随后的机构积累",
        descripcion: "分析史上最快的50%加密崩盘及随后的机构积累。",
        duracionLectura: "15分钟",
        nivel: "基础",
        resumen: "2020年3月12日，Bitcoin在不到24小时内损失了50%的价值。这是其历史上最快、最严重的崩盘。然而，这个\"黑色星期四\"最终成为过去十年最佳买入机会。随后是18个月内1,500%的涨幅。",
        contexto: "2020年3月11日WHO宣布COVID-19大流行，引发了前所未有的全球恐慌。传统市场崩盘（数周内-30%）。加密货币作为流动性最强、风险最高的资产，首先被抛售。杠杆交易者被摧毁。但关键的事情在暗中发生：美联储宣布史上最大规模的货币刺激计划。机构投资者知道这一点。",
        timeline: [
          {
            fecha: "11 Mar 2020",
            titulo: "WHO宣布大流行",
            descripcion: "全球市场崩盘。BTC在7,900$。",
            tipo: "neutro"
          },
          {
            fecha: "12 Mar 2020",
            titulo: "黑色星期四：24小时-50%",
            descripcion: "BTC在不到24小时内从7,900$跌至3,800$。交易所连环爆仓。BitMEX出现技术问题。10亿美元头寸被清算。",
            tipo: "critico"
          },
          {
            fecha: "15 Mar 2020",
            titulo: "美联储宣布无限QE",
            descripcion: "美联储宣布无限量资产购买。大规模印钞。机构投资者明白货币将贬值。",
            tipo: "critico"
          },
          {
            fecha: "Mar–May 2020",
            titulo: "静默积累",
            descripcion: "BTC在5,000-10,000$之间盘整。MicroStrategy分析BTC作为价值储存。巨鲸在散户恐慌中静默积累。",
            tipo: "alcista"
          },
          {
            fecha: "Ago 2020",
            titulo: "MicroStrategy购买BTC",
            descripcion: "MicroStrategy购买2.5亿美元BTC。首家将BTC作为国库储备的上市公司。缺失的机构催化剂。",
            tipo: "alcista"
          },
          {
            fecha: "Oct 2020",
            titulo: "PayPal启用BTC",
            descripcion: "PayPal宣布允许买卖BTC。3亿用户的潜在访问。涨势正式开始。",
            tipo: "alcista"
          },
          {
            fecha: "Nov 2020",
            titulo: "BTC突破2017年ATH（20,000$）",
            descripcion: "自2017年12月以来首次，BTC突破其前历史高点。新牛市的技术确认。",
            tipo: "alcista"
          },
          {
            fecha: "Abr 2021",
            titulo: "ATH 64,000$ — 从低点涨1,500%",
            descripcion: "从COVID崩盘的3,800$到64,000$。13个月内+1,584%。在恐慌中买入的人资产翻了16倍。",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "2020年3月崩盘形成了Bitcoin历史上最清晰的Wyckoff积累模式。Selling Climax (SC)在3,800$，Automatic Rally (AR)至10,000$，Secondary Test (ST)多次在5,000-6,000$。积累区间持续7个月（2020年3-10月）。Jump Across the Creek (JAC)发生在2020年8-9月BTC突破12,000$时。",
        senalesOnchain: "2020年夏季大规模Exchange Outflow：巨鲸从交易所提取BTC（不卖出信号）。NUPL从3月的-0.2（投降）升至7月的正值区域。Puell Multiple在崩盘期间触及历史低点。",
        leccionesAprendidas: [
          "黑天鹅事件是最佳买入机会——如果你准备好了流动性",
          "极度恐慌（Fear & Greed < 10）历史上预示着12-18个月后的最佳回报",
          "涉及大规模印钞的宏观事件对Bitcoin中长期看涨",
          "始终保持投资组合20-30%的流动性以捕捉非凡崩盘",
          "在崩盘中，巨鲸的Exchange Outflow比价格更重要"
        ],
        comoAplicarlo: "准备\"危机计划\"：提前定义在黑天鹅事件中你会在哪些水平买入。实用规则：如果BTC在<72小时内跌>40%，启动分批买入协议。首次-40%时投入可用流动性的30%，-55%时30%，-70%时40%。这需要完全的纪律——在崩盘时刻，一切看起来都完了。",
        conclusionFinal: "2020年COVID崩盘证明Bitcoin短期内不是避险资产（危机中与风险资产相关），但当催化剂是货币性质时，中长期是避险资产。在恐慌中卖出的人错过了加密史上最大的牛市。在极度恐惧中买入的人成为了百万富翁。",
        datosCarouselLabels: {
          minimo: "崩盘最低点",
          caida_24h: "24小时跌幅",
          rally_post: "后续涨幅",
          ath_sig: "下一个ATH",
          tiempo_ath: "到达ATH时间",
          fg_minimo: "最低点F&G"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 3 · LUNA / UST
  // ───────────────────────────────────────────────────────────
  {
    slug: "colapso-luna-ust",
    colorCategoria: "#ff3355",
    nivel: "avanzado",
    datosCarousel: [
      { key: "cap_destruida", valor: "60.000M$", color: "#ff3355" },
      { key: "luna_de_a", valor: "80$ → 0.0001$", color: "#ff3355" },
      { key: "velocidad", valor: "7 días", color: "#ff3355" },
      { key: "ust_circ", valor: "18.000M$", color: "#ff6b35" },
      { key: "yield_anchor", valor: "19.5% APY", color: "#f5a623" },
      { key: "contagio", valor: ">200.000M$", color: "#ff3355" },
    ],
    i18n: {
      es: {
        categoria: "RIESGO SISTÉMICO",
        titulo: "Colapso LUNA/UST: La Espiral de Muerte de 60.000M USD",
        subtitulo: "Anatomía completa del mayor colapso de un proyecto cripto: cómo 60.000M desaparecieron en días",
        descripcion: "Desglose paso a paso de la espiral de muerte del stablecoin algorítmico y la cascada de contagio.",
        duracionLectura: "22 min",
        nivel: "Avanzado",
        resumen: "En mayo de 2022, LUNA cotizaba a 80$ con una capitalización de 40.000M$. UST, su stablecoin algorítmica, tenía 18.000M$ en circulación. En 7 días, ambos valían prácticamente cero. Lo que siguió fue el peor contagio de la historia cripto: Three Arrows Capital, Celsius, Voyager, BlockFi, FTX… todo conectado a LUNA.",
        contexto: "Terraform Labs, fundada por Do Kwon, había creado un ecosistema complejo: LUNA era el token de gobernanza, UST era una stablecoin algorítmica (mantenía su paridad con el dólar quemando/minando LUNA). Anchor Protocol ofrecía un 19.5% de rentabilidad sobre UST — insosteniblemente alto, financiado artificialmente. El proyecto atrajo miles de millones de inversores retail e institucionales buscando \"yield seguro\".",
        timeline: [
          { fecha: "07 May 2022", titulo: "Primera señal: UST pierde el peg", descripcion: "Un ataque coordinado (posiblemente por un actor con 1.000M$ en BTC vendidos en corto) rompe el peg de UST. Cae de 1$ a 0.98$. Do Kwon tweetea \"deploying more capital\".", tipo: "critico" },
          { fecha: "08 May 2022", titulo: "Pánico en Anchor — retiradas masivas", descripcion: "Los depositantes de Anchor Protocol empiezan a retirar UST masivamente. El algoritmo empieza a minar LUNA para absorber la venta. LUNA empieza a caer.", tipo: "critico" },
          { fecha: "09 May 2022", titulo: "La espiral de muerte empieza", descripcion: "UST cae a 0.60$. Para mantener el peg se mina más LUNA, lo que baja el precio de LUNA, lo que erosiona la confianza en UST, lo que genera más ventas de UST… Espiral de retroalimentación positiva.", tipo: "critico" },
          { fecha: "10 May 2022", titulo: "LUNA cae 70% en 24 horas", descripcion: "LUNA pasa de 60$ a 10$. La oferta de LUNA se multiplica por 10x para defender UST. Hiperinflación del token. Terra Foundation vende reservas de BTC.", tipo: "bajista" },
          { fecha: "11–12 May 2022", titulo: "Colapso total — LUNA a 0.0001$", descripcion: "LUNA pasa de 10$ a 0.0001$ en 48h. La oferta pasa de 350M tokens a 6.500B tokens. UST se mantiene en 0.10$. 60.000M$ de capitalización evaporados. Do Kwon desaparece de Twitter.", tipo: "critico" },
          { fecha: "May–Jun 2022", titulo: "Contagio sistémico", descripcion: "Three Arrows Capital (3AC) tiene 200M$ en LUNA/UST → insolvencia. Celsius Network congela retiradas. Voyager Digital solicita protección por bancarrota. El mercado cripto cae un 30% adicional.", tipo: "bajista" },
        ],
        analisisTecnico: "No había señales técnicas clásicas que predijesen este colapso — era riesgo de protocolo, no de precio. Sin embargo, en retrospectiva: (1) La rentabilidad del 19.5% de Anchor era insostenible y debería haber disparado alarmas. (2) El ratio de reservas de BTC respecto a UST en circulación era insuficiente. (3) El mecanismo algorítmico sin respaldo real era intrínsecamente frágil ante ataques coordinados.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "Rentabilidades superiores al 10% anual garantizadas en cripto son señales de alerta — algo no es sostenible",
          "Los stablecoins algorítmicos sin respaldo real (como UST) son intrínsecamente frágiles y susceptibles a ataques",
          "La concentración excesiva en un solo protocolo o ecosistema es riesgo sistémico puro",
          "En cripto, el contagio puede ser instantáneo y devastador — lo que colapsa hoy puede llevarse lo demás mañana",
          "La auditoría del mecanismo técnico de cualquier proyecto es tan importante como el análisis de precio",
        ],
        comoAplicarlo: "Antes de depositar capital en cualquier protocolo DeFi: (1) ¿De dónde viene la rentabilidad? Si no tiene respuesta clara → no entres. (2) ¿Está el stablecoin respaldado 1:1 por activos reales? (3) ¿Qué pasa si el token principal cae 90%? Si el protocolo colapsa → es UST. (4) Diversifica siempre en múltiples protocolos y nunca pongas más del 5-10% de tu capital en DeFi de alto riesgo.",
        conclusionFinal: "El colapso LUNA/UST no fue un accidente — fue el resultado predecible de un diseño defectuoso amplificado por rentabilidades insostenibles. La lección más importante: en cripto, el riesgo de protocolo puede ser más letal que el riesgo de mercado. Entiende exactamente qué posees y cómo funciona antes de poner tu capital.",
        datosCarouselLabels: {
          cap_destruida: "Cap. destruida",
          luna_de_a: "LUNA: de",
          velocidad: "Velocidad del colapso",
          ust_circ: "UST en circulación",
          yield_anchor: "Yield de Anchor",
          contagio: "Contagio estimado",
        },
      },
      en: {
        "categoria": "SYSTEMIC RISK",
        "titulo": "LUNA/UST Collapse: The $60B Death Spiral",
        "subtitulo": "Complete anatomy of the largest crypto project collapse: how $60B vanished in days",
        "descripcion": "Step-by-step breakdown of the algorithmic stablecoin death spiral and the contagion cascade.",
        "duracionLectura": "22 min",
        "nivel": "Advanced",
        "resumen": "In May 2022, LUNA was trading at $80 with a market cap of $40B. UST, its algorithmic stablecoin, had $18B in circulation. In 7 days, both were worth virtually zero. What followed was the worst contagion in crypto history: Three Arrows Capital, Celsius, Voyager, BlockFi, FTX… all connected to LUNA.",
        "contexto": "Terraform Labs, founded by Do Kwon, had created a complex ecosystem: LUNA was the governance token, UST was an algorithmic stablecoin (it maintained its dollar peg by burning/minting LUNA). Anchor Protocol offered 19.5% yield on UST — unsustainably high, artificially funded. The project attracted billions from retail and institutional investors seeking \"safe yield\".",
        "timeline": [
                {
                        "fecha": "07 May 2022",
                        "titulo": "First signal: UST loses the peg",
                        "descripcion": "A coordinated attack (possibly by an actor with $1B in BTC sold short) breaks UST's peg. It falls from $1 to $0.98. Do Kwon tweets \"deploying more capital\".",
                        "tipo": "critico"
                },
                {
                        "fecha": "08 May 2022",
                        "titulo": "Panic at Anchor — mass withdrawals",
                        "descripcion": "Anchor Protocol depositors begin massive UST withdrawals. The algorithm starts minting LUNA to absorb the selling. LUNA begins to fall.",
                        "tipo": "critico"
                },
                {
                        "fecha": "09 May 2022",
                        "titulo": "The death spiral begins",
                        "descripcion": "UST falls to $0.60. To maintain the peg, more LUNA is minted, which lowers LUNA's price, which erodes confidence in UST, which generates more UST selling… Positive feedback spiral.",
                        "tipo": "critico"
                },
                {
                        "fecha": "10 May 2022",
                        "titulo": "LUNA falls 70% in 24 hours",
                        "descripcion": "LUNA goes from $60 to $10. LUNA supply multiplies by 10x to defend UST. Token hyperinflation. Terra Foundation sells BTC reserves.",
                        "tipo": "bajista"
                },
                {
                        "fecha": "11–12 May 2022",
                        "titulo": "Total collapse — LUNA to $0.0001",
                        "descripcion": "LUNA goes from $10 to $0.0001 in 48h. Supply goes from 350M tokens to 6,500B tokens. UST stays at $0.10. $60B in market cap evaporated. Do Kwon disappears from Twitter.",
                        "tipo": "critico"
                },
                {
                        "fecha": "May–Jun 2022",
                        "titulo": "Systemic contagion",
                        "descripcion": "Three Arrows Capital (3AC) has $200M in LUNA/UST → insolvency. Celsius Network freezes withdrawals. Voyager Digital files for bankruptcy protection. The crypto market falls an additional 30%.",
                        "tipo": "bajista"
                }
        ],
        "analisisTecnico": "There were no classic technical signals that predicted this collapse — it was protocol risk, not price risk. However, in retrospect: (1) Anchor's 19.5% yield was unsustainable and should have raised red flags. (2) The ratio of BTC reserves to circulating UST was insufficient. (3) The algorithmic mechanism without real backing was inherently fragile to coordinated attacks.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "Guaranteed yields above 10% annual in crypto are warning signs — something is unsustainable",
                "Algorithmic stablecoins without real backing (like UST) are inherently fragile and susceptible to attacks",
                "Excessive concentration in a single protocol or ecosystem is pure systemic risk",
                "In crypto, contagion can be instantaneous and devastating — what collapses today can take everything else down tomorrow",
                "Auditing the technical mechanism of any project is as important as price analysis"
        ],
        "comoAplicarlo": "Before depositing capital in any DeFi protocol: (1) Where does the yield come from? If there's no clear answer → don't enter. (2) Is the stablecoin backed 1:1 by real assets? (3) What happens if the main token falls 90%? If the protocol collapses → it's UST. (4) Always diversify across multiple protocols and never put more than 5-10% of your capital in high-risk DeFi.",
        "conclusionFinal": "The LUNA/UST collapse was not an accident — it was the predictable result of flawed design amplified by unsustainable yields. The most important lesson: in crypto, protocol risk can be more lethal than market risk. Understand exactly what you own and how it works before putting in your capital.",
        "datosCarouselLabels": {
                "cap_destruida": "Cap. destroyed",
                "luna_de_a": "LUNA: from",
                "velocidad": "Collapse speed",
                "ust_circ": "UST in circulation",
                "yield_anchor": "Anchor Yield",
                "contagio": "Estimated contagion"
        }
},
      sk: {
        "categoria": "SYSTÉMOVÉ RIZIKO",
        "titulo": "Kolaps LUNA/UST: Špirála smrti za 60 000M USD",
        "subtitulo": "Kompletná anatómia najväčšieho kolapsu krypto projektu: ako zmizlo 60 000M za pár dní",
        "descripcion": "Podrobný rozbor špirály smrti algoritmického stablecoinu a kaskády nákazy.",
        "duracionLectura": "22 min",
        "nivel": "Pokročilý",
        "resumen": "V máji 2022 sa LUNA obchodovala za 80$ s kapitalizáciou 40 000M$. UST, jej algoritmický stablecoin, mal v obehu 18 000M$. Za 7 dní mali obe takmer nulovú hodnotu. Nasledovala najhoršia nákaza v histórii krypta: Three Arrows Capital, Celsius, Voyager, BlockFi, FTX… všetko spojené s LUNA.",
        "contexto": "Terraform Labs, ktorú založil Do Kwon, vytvoril komplexný ekosystém: LUNA bol governance token, UST bol algoritmický stablecoin (udržiaval paritu s dolárom spaľovaním/minovaním LUNA). Anchor Protocol ponúkal 19,5% výnos na UST — neudržateľne vysoký, umelé financovaný. Projekt prilákal miliardy od retailových aj inštitucionálnych investorov hľadajúcich \"bezpečný výnos\".",
        "timeline": [
                {
                        "fecha": "07 Máj 2022",
                        "titulo": "Prvý signál: UST stráca peg",
                        "descripcion": "Koordinovaný útok (pravdepodobne aktérom s 1 000M$ v shortovanom BTC) prelomí peg UST. Klesne z 1$ na 0,98$. Do Kwon tweetuje \"deploying more capital\".",
                        "tipo": "critico"
                },
                {
                        "fecha": "08 Máj 2022",
                        "titulo": "Panika v Anchor — masívne výbery",
                        "descripcion": "Vkladatelia Anchor Protocol začínajú masívne vyberať UST. Algoritmus začína minovať LUNA na absorbovanie predaja. LUNA začína klesať.",
                        "tipo": "critico"
                },
                {
                        "fecha": "09 Máj 2022",
                        "titulo": "Špirála smrti začína",
                        "descripcion": "UST klesne na 0,60$. Na udržanie pegu sa minuje viac LUNA, čo znižuje cenu LUNA, čo narúša dôveru v UST, čo generuje viac predajov UST… Špirála pozitívnej spätnej väzby.",
                        "tipo": "critico"
                },
                {
                        "fecha": "10 Máj 2022",
                        "titulo": "LUNA klesá o 70% za 24 hodín",
                        "descripcion": "LUNA ide z 60$ na 10$. Ponuka LUNA sa znásobí 10x na obranu UST. Hyperinflácia tokenu. Terra Foundation predáva rezervy BTC.",
                        "tipo": "bajista"
                },
                {
                        "fecha": "11–12 Máj 2022",
                        "titulo": "Totálny kolaps — LUNA na 0,0001$",
                        "descripcion": "LUNA ide z 10$ na 0,0001$ za 48h. Ponuka ide z 350M tokenov na 6 500B tokenov. UST zostáva na 0,10$. 60 000M$ kapitalizácie sa vyparilo. Do Kwon zmizne z Twitteru.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Máj–Jún 2022",
                        "titulo": "Systémová nákaza",
                        "descripcion": "Three Arrows Capital (3AC) má 200M$ v LUNA/UST → insolvencia. Celsius Network zmrazí výbery. Voyager Digital žiada ochranu pred bankrotom. Krypto trh klesá o ďalších 30%.",
                        "tipo": "bajista"
                }
        ],
        "analisisTecnico": "Neexistovali klasické technické signály, ktoré by predpovedali tento kolaps — bolo to riziko protokolu, nie ceny. Avšak spätne: (1) 19,5% výnos Anchoru bol neudržateľný a mal spustiť alarmy. (2) Pomer rezerv BTC voči UST v obehu bol nedostatočný. (3) Algoritmický mechanizmus bez reálneho krytia bol vnútorne krehký voči koordinovaným útokom.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "Garantované výnosy nad 10% ročne v krypte sú varovné signály — niečo nie je udržateľné",
                "Algoritmické stablecoiny bez reálneho krytia (ako UST) sú vnútorne krehké a náchylné na útoky",
                "Nadmerná koncentrácia v jednom protokole alebo ekosystéme je čisté systémové riziko",
                "V krypte môže byť nákaza okamžitá a devastujúca — čo zkolabuje dnes, môže zajtra stiahnuť všetko ostatné",
                "Audit technického mechanizmu akéhokoľvek projektu je rovnako dôležitý ako analýza ceny"
        ],
        "comoAplicarlo": "Pred vložením kapitálu do akéhokoľvek DeFi protokolu: (1) Odkiaľ pochádza výnos? Ak nemá jasnú odpoveď → nevstupuj. (2) Je stablecoin krytý 1:1 reálnymi aktívami? (3) Čo sa stane, ak hlavný token klesne o 90%? Ak protokol zkolabuje → je to UST. (4) Vždy diverzifikuj cez viacero protokolov a nikdy nedávaj viac ako 5-10% svojho kapitálu do vysoko rizikového DeFi.",
        "conclusionFinal": "Kolaps LUNA/UST nebol nehoda — bol predvídateľným výsledkom chybného dizajnu zosíleného neudržateľnými výnosmi. Najdôležitejšie ponaučenie: v krypte môže byť riziko protokolu smrteľnejšie než trhové riziko. Pochop presne, čo vlastníš a ako to funguje, skôr než vložíš svoj kapitál.",
        "datosCarouselLabels": {
                "cap_destruida": "Zničená kap.",
                "luna_de_a": "LUNA: z",
                "velocidad": "Rýchlosť kolapsu",
                "ust_circ": "UST v obehu",
                "yield_anchor": "Yield Anchoru",
                "contagio": "Odhadovaná nákaza"
        }
},
      de: {
        categoria: "SYSTEMISCHES RISIKO",
        titulo: "LUNA/UST-Kollaps: Die Todesspirale von 60.000M USD",
        subtitulo: "Vollständige Anatomie des größten Krypto-Projekt-Kollapses: wie 60.000M in Tagen verschwanden",
        descripcion: "Schritt-für-Schritt-Aufschlüsselung der Todesspirale des algorithmischen Stablecoins und der Ansteckungskaskade.",
        duracionLectura: "22 min",
        nivel: "Fortgeschritten",
        resumen: "Im Mai 2022 notierte LUNA bei 80$ mit einer Marktkapitalisierung von 40.000M$. UST, sein algorithmischer Stablecoin, hatte 18.000M$ im Umlauf. In 7 Tagen waren beide praktisch wertlos. Was folgte, war die schlimmste Ansteckung in der Krypto-Geschichte: Three Arrows Capital, Celsius, Voyager, BlockFi, FTX… alles mit LUNA verbunden.",
        contexto: "Terraform Labs, gegründet von Do Kwon, hatte ein komplexes Ökosystem geschaffen: LUNA war der Governance-Token, UST war ein algorithmischer Stablecoin (hielt seine Parität zum Dollar durch Brennen/Minten von LUNA). Anchor Protocol bot 19,5% Rendite auf UST — unhaltbar hoch, künstlich finanziert. Das Projekt zog Milliarden von Retail- und institutionellen Investoren an, die \"sichere Rendite\" suchten.",
        timeline: [
          {
            fecha: "07 May 2022",
            titulo: "Erstes Signal: UST verliert das Peg",
            descripcion: "Ein koordinierter Angriff (möglicherweise durch einen Akteur mit 1.000M$ in leerverkauftem BTC) bricht das Peg von UST. Fällt von 1$ auf 0,98$. Do Kwon twittert \"deploying more capital\".",
            tipo: "critico"
          },
          {
            fecha: "08 May 2022",
            titulo: "Panik bei Anchor — massive Abhebungen",
            descripcion: "Die Einleger von Anchor Protocol beginnen massiv UST abzuheben. Der Algorithmus beginnt LUNA zu minten, um den Verkauf zu absorbieren. LUNA beginnt zu fallen.",
            tipo: "critico"
          },
          {
            fecha: "09 May 2022",
            titulo: "Die Todesspirale beginnt",
            descripcion: "UST fällt auf 0,60$. Um das Peg zu halten, wird mehr LUNA gemintet, was den Preis von LUNA senkt, was das Vertrauen in UST untergräbt, was mehr UST-Verkäufe generiert… Positive Rückkopplungsspirale.",
            tipo: "critico"
          },
          {
            fecha: "10 May 2022",
            titulo: "LUNA fällt 70% in 24 Stunden",
            descripcion: "LUNA geht von 60$ auf 10$. Das Angebot von LUNA vervielfacht sich um das 10-fache, um UST zu verteidigen. Hyperinflation des Tokens. Terra Foundation verkauft BTC-Reserven.",
            tipo: "bajista"
          },
          {
            fecha: "11–12 May 2022",
            titulo: "Totaler Kollaps — LUNA auf 0,0001$",
            descripcion: "LUNA geht von 10$ auf 0,0001$ in 48h. Das Angebot steigt von 350M Token auf 6.500B Token. UST bleibt bei 0,10$. 60.000M$ Marktkapitalisierung verdampft. Do Kwon verschwindet von Twitter.",
            tipo: "critico"
          },
          {
            fecha: "May–Jun 2022",
            titulo: "Systemische Ansteckung",
            descripcion: "Three Arrows Capital (3AC) hat 200M$ in LUNA/UST → Insolvenz. Celsius Network friert Abhebungen ein. Voyager Digital beantragt Insolvenzschutz. Der Kryptomarkt fällt zusätzlich um 30%.",
            tipo: "bajista"
          }
        ],
        analisisTecnico: "Es gab keine klassischen technischen Signale, die diesen Kollaps vorhersagten — es war Protokollrisiko, nicht Preisrisiko. Jedoch im Nachhinein: (1) Die 19,5% Rendite von Anchor war unhaltbar und hätte Alarmglocken läuten lassen müssen. (2) Das Verhältnis der BTC-Reserven zu UST im Umlauf war unzureichend. (3) Der algorithmische Mechanismus ohne echte Deckung war intrinsisch fragil gegenüber koordinierten Angriffen.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "Garantierte Renditen über 10% jährlich in Krypto sind Warnsignale — etwas ist nicht nachhaltig",
          "Algorithmische Stablecoins ohne echte Deckung (wie UST) sind intrinsisch fragil und anfällig für Angriffe",
          "Übermäßige Konzentration in einem einzigen Protokoll oder Ökosystem ist reines systemisches Risiko",
          "In Krypto kann Ansteckung sofort und verheerend sein — was heute kollabiert, kann morgen alles andere mitreißen",
          "Die Prüfung des technischen Mechanismus eines Projekts ist genauso wichtig wie die Preisanalyse"
        ],
        comoAplicarlo: "Bevor du Kapital in ein DeFi-Protokoll einzahlst: (1) Woher kommt die Rendite? Wenn es keine klare Antwort gibt → steig nicht ein. (2) Ist der Stablecoin 1:1 durch echte Vermögenswerte gedeckt? (3) Was passiert, wenn der Haupt-Token um 90% fällt? Wenn das Protokoll kollabiert → es ist UST. (4) Diversifiziere immer über mehrere Protokolle und setze nie mehr als 5-10% deines Kapitals in Hochrisiko-DeFi.",
        conclusionFinal: "Der LUNA/UST-Kollaps war kein Unfall — er war das vorhersehbare Ergebnis eines fehlerhaften Designs, verstärkt durch unhaltbare Renditen. Die wichtigste Lektion: In Krypto kann Protokollrisiko tödlicher sein als Marktrisiko. Verstehe genau, was du besitzt und wie es funktioniert, bevor du dein Kapital einsetzt.",
        datosCarouselLabels: {
          cap_destruida: "Vernichtete Kap.",
          luna_de_a: "LUNA: von",
          velocidad: "Geschwindigkeit des Kollapses",
          ust_circ: "UST im Umlauf",
          yield_anchor: "Anchor-Rendite",
          contagio: "Geschätzte Ansteckung"
        }
      },
      "zh-CN": {
        categoria: "系统性风险",
        titulo: "LUNA/UST崩盘：600亿美元的死亡螺旋",
        subtitulo: "史上最大加密项目崩盘的完整剖析：600亿美元如何在数日内消失",
        descripcion: "算法稳定币死亡螺旋及连环传染崩盘的逐步解析。",
        duracionLectura: "22 分钟",
        nivel: "高级",
        resumen: "2022年5月，LUNA交易价格为80美元，市值400亿美元。其算法稳定币UST流通量达180亿美元。7天内，两者价值几乎归零。随之而来的是加密史上最严重的传染：Three Arrows Capital、Celsius、Voyager、BlockFi、FTX……全部与LUNA相连。",
        contexto: "由Do Kwon创立的Terraform Labs构建了一个复杂的生态系统：LUNA是治理代币，UST是算法稳定币（通过销毁/铸造LUNA来维持与美元的锚定）。Anchor Protocol为UST提供19.5%的收益率——不可持续的高收益，由人为资金支撑。该项目吸引了数十亿美元的散户和机构投资者寻求\"安全收益\"。",
        timeline: [
          {
            fecha: "07 May 2022",
            titulo: "首个信号：UST脱锚",
            descripcion: "一次协同攻击（可能由持有10亿美元BTC空头的行为者发起）打破了UST的锚定。从1美元跌至0.98美元。Do Kwon发推文称\"deploying more capital\"。",
            tipo: "critico"
          },
          {
            fecha: "08 May 2022",
            titulo: "Anchor恐慌——大规模提款",
            descripcion: "Anchor Protocol的存款人开始大规模提取UST。算法开始铸造LUNA以吸收抛售。LUNA开始下跌。",
            tipo: "critico"
          },
          {
            fecha: "09 May 2022",
            titulo: "死亡螺旋启动",
            descripcion: "UST跌至0.60美元。为维持锚定铸造更多LUNA，导致LUNA价格下跌，进而削弱对UST的信心，引发更多UST抛售……正反馈螺旋。",
            tipo: "critico"
          },
          {
            fecha: "10 May 2022",
            titulo: "LUNA 24小时暴跌70%",
            descripcion: "LUNA从60美元跌至10美元。LUNA供应量增加10倍以捍卫UST。代币恶性通胀。Terra Foundation抛售BTC储备。",
            tipo: "bajista"
          },
          {
            fecha: "11–12 May 2022",
            titulo: "全面崩盘——LUNA跌至0.0001美元",
            descripcion: "LUNA在48小时内从10美元跌至0.0001美元。供应量从3.5亿枚增至65000亿枚。UST维持在0.10美元。600亿美元市值蒸发。Do Kwon从Twitter消失。",
            tipo: "critico"
          },
          {
            fecha: "May–Jun 2022",
            titulo: "系统性传染",
            descripcion: "Three Arrows Capital (3AC)持有2亿美元LUNA/UST → 破产。Celsius Network冻结提款。Voyager Digital申请破产保护。加密市场额外下跌30%。",
            tipo: "bajista"
          }
        ],
        analisisTecnico: "没有经典技术信号能预测这次崩盘——这是协议风险，而非价格风险。然而，事后看来：(1) Anchor的19.5%收益率不可持续，本应引发警报。(2) BTC储备相对于UST流通量的比率不足。(3) 无真实支撑的算法机制在协同攻击面前本质上脆弱。",
        senalesOnchain: null,
        leccionesAprendidas: [
          "加密领域保证年化超过10%的收益率是警示信号——某些东西不可持续",
          "无真实支撑的算法稳定币（如UST）本质上脆弱，易受攻击",
          "过度集中于单一协议或生态系统是纯粹的系统性风险",
          "在加密领域，传染可以是即时且毁灭性的——今天崩盘的可能明天拖垮其他一切",
          "对任何项目技术机制的审计与价格分析同样重要"
        ],
        comoAplicarlo: "在向任何DeFi协议存入资金前：(1) 收益从何而来？如果没有明确答案 → 不要进入。(2) 稳定币是否由真实资产1:1支撑？(3) 如果主要代币下跌90%会发生什么？如果协议崩溃 → 那就是UST。(4) 始终在多个协议间分散投资，永远不要将超过5-10%的资金投入高风险DeFi。",
        conclusionFinal: "LUNA/UST崩盘不是意外——而是设计缺陷被不可持续收益率放大的可预见结果。最重要的教训：在加密领域，协议风险可能比市场风险更致命。在投入资金前，准确理解你持有什么以及它如何运作。",
        datosCarouselLabels: {
          cap_destruida: "市值摧毁",
          luna_de_a: "LUNA：从",
          velocidad: "崩盘速度",
          ust_circ: "UST流通量",
          yield_anchor: "Anchor收益率",
          contagio: "估计传染"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 4 · FTX
  // ───────────────────────────────────────────────────────────
  {
    slug: "colapso-ftx-suelo-btc",
    colorCategoria: "#ff6b35",
    nivel: "intermedio",
    datosCarousel: [
      { key: "minimo_ciclo", valor: "15.500$", color: "#ff3355" },
      { key: "fondos", valor: "8.000M$", color: "#ff3355" },
      { key: "afectados", valor: ">1M usuarios", color: "#ff6b35" },
      { key: "mvrv", valor: "0.7", color: "#00e676" },
      { key: "fg_min", valor: "6/100", color: "#00e676" },
      { key: "rally_desde_min", valor: "+345%", color: "#00e676" },
    ],
    i18n: {
      es: {
        categoria: "CAPITULACIÓN",
        titulo: "Colapso FTX y Suelo BTC 2022",
        subtitulo: "Cómo la insolvencia del segundo mayor exchange marcó el suelo definitivo del bear market",
        descripcion: "Cómo la insolvencia del exchange creó el mínimo definitivo de 2022 y la señal de acumulación smart money.",
        duracionLectura: "16 min",
        nivel: "Intermedio",
        resumen: "Noviembre 2022. El mercado cripto ya había caído 70% desde máximos. Entonces llegó FTX. El segundo exchange más grande del mundo colapsó en 72 horas, llevando BTC a 15.500$ — el mínimo del ciclo. Pero paradójicamente, este fue el mayor evento de capitulación y el punto exacto donde los smart money empezaron a acumular agresivamente.",
        contexto: "FTX, fundada por Sam Bankman-Fried (SBF), era considerada el exchange más \"confiable\" del ecosistema cripto. Apoyada por Sequoia, SoftBank, Tom Brady y el propio SBF era imagen de la regulación cripto. Lo que nadie sabía: Alameda Research (el hedge fund de SBF) usaba los fondos de los clientes de FTX para hacer trading. Un artículo de CoinDesk el 2 de noviembre reveló que el balance de Alameda dependía masivamente del token FTT (el token nativo de FTX).",
        timeline: [
          { fecha: "02 Nov 2022", titulo: "CoinDesk publica el balance de Alameda", descripcion: "El artículo revela que el 40% del balance de Alameda Research son tokens FTT (básicamente dinero creado por ellos mismos). El mercado empieza a inquietarse.", tipo: "critico" },
          { fecha: "06 Nov 2022", titulo: "Binance anuncia que vende todo su FTT", descripcion: "CZ (CEO de Binance) anuncia en Twitter que liquidará todos sus FTT (~580M$). La confianza en FTX colapsa. Bank run instantáneo: 6.000M$ retirados en 72 horas.", tipo: "critico" },
          { fecha: "08 Nov 2022", titulo: "FTX suspende retiradas", descripcion: "FTX no puede procesar más retiradas. Los usuarios descubren que no hay fondos. BTC cae a 17.000$. Pánico total en el mercado.", tipo: "bajista" },
          { fecha: "09 Nov 2022", titulo: "Binance rechaza comprar FTX", descripcion: "Binance anunció interés en comprar FTX, luego se retira tras ver la due diligence. Agujero de 8.000M$ en los fondos de clientes. BTC cae a 16.000$.", tipo: "critico" },
          { fecha: "11 Nov 2022", titulo: "FTX solicita bancarrota. SBF dimite.", descripcion: "FTX, FTX US y Alameda Research solicitan protección por bancarrota. SBF dimite. Se revelan pérdidas de 8.000M$ en fondos de clientes. BTC toca 15.500$.", tipo: "critico" },
          { fecha: "Nov–Dic 2022", titulo: "Capitulación total — mínimo del ciclo", descripcion: "El mercado capitula. Fear & Greed en 6/100. Exchange Outflow en máximos históricos (todos retiran de los exchanges). MVRV en 0.7 — históricamente zona de suelo.", tipo: "critico" },
          { fecha: "Ene 2023", titulo: "Inicio de la recuperación", descripcion: "BTC empieza a subir silenciosamente desde 15.500$. Los institucionales comprando off-exchange. El mercado aún está en pánico pero el suelo ya se formó.", tipo: "alcista" },
        ],
        analisisTecnico: "El mínimo de 15.500$ formó un patrón de capitulación clásico: vela de mecha muy larga inferior, volumen extremo (el más alto en meses), y rechazo inmediato. En retrospectiva: (1) MVRV en 0.7 → históricamente zona de suelo de ciclo. (2) Puell Multiple en mínimos → los mineros al límite de rentabilidad (señal de suelo). (3) NUPL en capitulación (-0.15). Todos los indicadores on-chain marcaban \"compra generacional\".",
        senalesOnchain: "Exchange Outflow el 8-9 de noviembre fue el más alto de la historia: todos retirando a wallets propias (pánico) PERO también las ballenas retirando para acumular off-exchange. El Spent Output Profit Ratio (SOPR) en mínimos históricos. Long-term holder supply en máximos: los HODLers no estaban vendiendo.",
        leccionesAprendidas: [
          "Nunca dejes grandes cantidades de cripto en exchanges — \"not your keys, not your coins\" nunca fue más relevante",
          "Los máximos eventos de pánico (FTX, LUNA) coinciden históricamente con suelos de mercado",
          "MVRV < 1 + NUPL en capitulación + Fear&Greed < 10 = señal de compra generacional (si no es el fin de BTC)",
          "La diversificación de custodia (múltiples wallets, cold storage) es gestión de riesgo fundamental",
          "El Exchange Outflow post-crisis es señal alcista: reduce la oferta disponible para vender",
        ],
        comoAplicarlo: "Protocolo de custodia segura: (1) Máximo 10% de tu portfolio en exchanges — solo lo que vayas a tradear activamente. (2) 90% en wallets propias (hardware wallet). (3) Nunca uses un exchange como banco de largo plazo. Para identificar suelos: MVRV < 1 + Fear&Greed < 15 = considera acumulación escalonada sin importar las noticias.",
        conclusionFinal: "FTX fue el mayor fraude de la historia cripto. Pero paradójicamente marcó el suelo definitivo del bear market 2022 y el inicio del bull market 2023-2024. Los que entendieron las señales on-chain y compraron en el pánico de noviembre 2022 multiplicaron por 4 en solo 14 meses.",
        datosCarouselLabels: {
          minimo_ciclo: "Mínimo del ciclo",
          fondos: "Fondos perdidos",
          afectados: "Afectados",
          mvrv: "MVRV en mínimo",
          fg_min: "F&G en mínimo",
          rally_desde_min: "Rally desde mínimo",
        },
      },
      en: {
        "categoria": "CAPITULATION",
        "titulo": "FTX Collapse and BTC Bottom 2022",
        "subtitulo": "How the insolvency of the second-largest exchange marked the definitive bear market bottom",
        "descripcion": "How the exchange's insolvency created the definitive 2022 bottom and the smart money accumulation signal.",
        "duracionLectura": "16 min",
        "nivel": "Intermediate",
        "resumen": "November 2022. The crypto market had already fallen 70% from all-time highs. Then came FTX. The world's second-largest exchange collapsed in 72 hours, taking BTC to $15,500 — the cycle bottom. But paradoxically, this was the greatest capitulation event and the exact point where smart money began to accumulate aggressively.",
        "contexto": "FTX, founded by Sam Bankman-Fried (SBF), was considered the \"most reliable\" exchange in the crypto ecosystem. Backed by Sequoia, SoftBank, Tom Brady, and SBF himself was the face of crypto regulation. What nobody knew: Alameda Research (SBF's hedge fund) was using FTX client funds for trading. A CoinDesk article on November 2nd revealed that Alameda's balance sheet was massively dependent on the FTT token (FTX's native token).",
        "timeline": [
                {
                        "fecha": "02 Nov 2022",
                        "titulo": "CoinDesk publishes Alameda's balance sheet",
                        "descripcion": "The article reveals that 40% of Alameda Research's balance sheet is FTT tokens (basically money created by themselves). The market starts to grow anxious.",
                        "tipo": "critico"
                },
                {
                        "fecha": "06 Nov 2022",
                        "titulo": "Binance announces it will sell all its FTT",
                        "descripcion": "CZ (Binance CEO) announces on Twitter that he will liquidate all his FTT (~$580M). Confidence in FTX collapses. Instant bank run: $6B withdrawn in 72 hours.",
                        "tipo": "critico"
                },
                {
                        "fecha": "08 Nov 2022",
                        "titulo": "FTX suspends withdrawals",
                        "descripcion": "FTX cannot process any more withdrawals. Users discover there are no funds. BTC drops to $17,000. Total market panic.",
                        "tipo": "bajista"
                },
                {
                        "fecha": "09 Nov 2022",
                        "titulo": "Binance refuses to buy FTX",
                        "descripcion": "Binance announced interest in buying FTX, then withdraws after seeing the due diligence. $8B hole in client funds. BTC drops to $16,000.",
                        "tipo": "critico"
                },
                {
                        "fecha": "11 Nov 2022",
                        "titulo": "FTX files for bankruptcy. SBF resigns.",
                        "descripcion": "FTX, FTX US, and Alameda Research file for bankruptcy protection. SBF resigns. $8B in client fund losses revealed. BTC touches $15,500.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Nov–Dec 2022",
                        "titulo": "Total capitulation — cycle bottom",
                        "descripcion": "The market capitulates. Fear & Greed at 6/100. Exchange Outflow at all-time highs (everyone withdrawing from exchanges). MVRV at 0.7 — historically a bottom zone.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Jan 2023",
                        "titulo": "Recovery begins",
                        "descripcion": "BTC starts to rise quietly from $15,500. Institutions buying off-exchange. The market is still in panic but the bottom has already formed.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "The $15,500 bottom formed a classic capitulation pattern: candle with a very long lower wick, extreme volume (the highest in months), and immediate rejection. In retrospect: (1) MVRV at 0.7 → historically a cycle bottom zone. (2) Puell Multiple at lows → miners at the edge of profitability (bottom signal). (3) NUPL in capitulation (-0.15). All on-chain indicators marked \"generational buy\".",
        "senalesOnchain": "Exchange Outflow on Nov 8-9 was the highest in history: everyone withdrawing to their own wallets (panic) BUT also whales withdrawing to accumulate off-exchange. The Spent Output Profit Ratio (SOPR) at historic lows. Long-term holder supply at highs: HODLers were not selling.",
        "leccionesAprendidas": [
                "Never leave large amounts of crypto on exchanges — \"not your keys, not your coins\" was never more relevant",
                "Major panic events (FTX, LUNA) historically coincide with market bottoms",
                "MVRV < 1 + NUPL in capitulation + Fear&Greed < 10 = generational buy signal (if it's not the end of BTC)",
                "Custody diversification (multiple wallets, cold storage) is fundamental risk management",
                "Post-crisis Exchange Outflow is a bullish signal: it reduces the supply available to sell"
        ],
        "comoAplicarlo": "Secure custody protocol: (1) Maximum 10% of your portfolio on exchanges — only what you're going to actively trade. (2) 90% in your own wallets (hardware wallet). (3) Never use an exchange as a long-term bank. To identify bottoms: MVRV < 1 + Fear&Greed < 15 = consider staggered accumulation regardless of news.",
        "conclusionFinal": "FTX was the biggest fraud in crypto history. But paradoxically it marked the definitive bottom of the 2022 bear market and the beginning of the 2023-2024 bull market. Those who understood the on-chain signals and bought during the November 2022 panic multiplied their investment by 4 in just 14 months.",
        "datosCarouselLabels": {
                "minimo_ciclo": "Cycle bottom",
                "fondos": "Funds lost",
                "afectados": "Affected",
                "mvrv": "MVRV at minimum",
                "fg_min": "F&G at minimum",
                "rally_desde_min": "Rally from bottom"
        }
},
      sk: {
        "categoria": "KAPITULÁCIA",
        "titulo": "Kolaps FTX a dno BTC 2022",
        "subtitulo": "Ako insolvencia druhej najväčšej burzy vytvorila definitívne dno medvedieho trhu",
        "descripcion": "Ako insolvencia burzy vytvorila definitívne minimum roku 2022 a signál akumulácie smart money.",
        "duracionLectura": "16 min",
        "nivel": "Stredne pokročilý",
        "resumen": "November 2022. Kryptotrh už klesol o 70% od maxím. Potom prišla FTX. Druhá najväčšia burza na svete skolabovala za 72 hodín, čím dostala BTC na 15 500$ — minimum cyklu. Ale paradoxne, toto bola najväčšia kapitulačná udalosť a presný bod, kde smart money začali agresívne akumulovať.",
        "contexto": "FTX, založená Samom Bankmanom-Friedom (SBF), bola považovaná za \"najdôveryhodnejšiu\" burzu v krypto ekosystéme. Podporená Sequoia, SoftBank, Tomom Bradym a samotný SBF bol tvárou krypto regulácie. Čo nikto nevedel: Alameda Research (hedge fund SBF) používala fondy klientov FTX na trading. Článok CoinDesk 2. novembra odhalil, že bilancia Alameda je masívne závislá od tokenu FTT (natívny token FTX).",
        "timeline": [
                {
                        "fecha": "02 Nov 2022",
                        "titulo": "CoinDesk publikuje bilanciu Alameda",
                        "descripcion": "Článok odhaľuje, že 40% bilancie Alameda Research tvoria tokeny FTT (v podstate peniaze vytvorené nimi samými). Trh sa začína znepokojovať.",
                        "tipo": "critico"
                },
                {
                        "fecha": "06 Nov 2022",
                        "titulo": "Binance oznamuje, že predá všetky FTT",
                        "descripcion": "CZ (CEO Binance) oznamuje na Twitteri, že zlikviduje všetky svoje FTT (~580M$). Dôvera vo FTX kolabuje. Okamžitý bank run: 6 000M$ vybraných za 72 hodín.",
                        "tipo": "critico"
                },
                {
                        "fecha": "08 Nov 2022",
                        "titulo": "FTX pozastavuje výbery",
                        "descripcion": "FTX nemôže spracovať ďalšie výbery. Používatelia zisťujú, že neexistujú žiadne fondy. BTC padá na 17 000$. Totálna panika na trhu.",
                        "tipo": "bajista"
                },
                {
                        "fecha": "09 Nov 2022",
                        "titulo": "Binance odmieta kúpiť FTX",
                        "descripcion": "Binance oznámila záujem kúpiť FTX, potom odstúpila po due diligence. Diera 8 000M$ vo fondoch klientov. BTC padá na 16 000$.",
                        "tipo": "critico"
                },
                {
                        "fecha": "11 Nov 2022",
                        "titulo": "FTX žiada o bankrot. SBF rezignuje.",
                        "descripcion": "FTX, FTX US a Alameda Research žiadajú o bankrotovú ochranu. SBF rezignuje. Odhalené straty 8 000M$ vo fondoch klientov. BTC dosiahne 15 500$.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Nov–Dec 2022",
                        "titulo": "Totálna kapitulácia — minimum cyklu",
                        "descripcion": "Trh kapituluje. Fear & Greed na 6/100. Exchange Outflow na historických maximách (všetci vyberajú z búrz). MVRV na 0.7 — historicky zóna dna.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Jan 2023",
                        "titulo": "Začiatok zotavenia",
                        "descripcion": "BTC začína ticho rásť z 15 500$. Inštitucionálni investori nakupujú off-exchange. Trh je stále v panike, ale dno je už vytvorené.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "Minimum 15 500$ vytvorilo klasický vzor kapitulácie: sviečka s veľmi dlhým dolným knôtom, extrémny objem (najvyšší za mesiace) a okamžité odmietnutie. Spätne: (1) MVRV na 0.7 → historicky zóna dna cyklu. (2) Puell Multiple na minimách → ťažiari na hranici ziskovosti (signál dna). (3) NUPL v kapitulácii (-0.15). Všetky on-chain indikátory ukazovali \"generačný nákup\".",
        "senalesOnchain": "Exchange Outflow 8.-9. novembra bol najvyšší v histórii: všetci vyberajú do vlastných peňaženiek (panika) ALE aj veľryby vyberajú na akumuláciu off-exchange. Spent Output Profit Ratio (SOPR) na historických minimách. Long-term holder supply na maximách: HODLeri nepredávali.",
        "leccionesAprendidas": [
                "Nikdy nenechávaj veľké množstvo krypta na burzách — \"not your keys, not your coins\" nikdy nebolo relevantnejšie",
                "Maximálne panické udalosti (FTX, LUNA) historicky zhodujú s dnami trhu",
                "MVRV < 1 + NUPL v kapitulácii + Fear&Greed < 10 = signál generačného nákupu (ak to nie je koniec BTC)",
                "Diverzifikácia úschovy (viacero peňaženiek, cold storage) je základný risk management",
                "Exchange Outflow po kríze je bullish signál: znižuje dostupnú ponuku na predaj"
        ],
        "comoAplicarlo": "Protokol bezpečnej úschovy: (1) Maximum 10% portfólia na burzách — len to, čo budeš aktívne tradovať. (2) 90% vo vlastných peňaženkách (hardware wallet). (3) Nikdy nepoužívaj burzu ako dlhodobú banku. Na identifikáciu dien: MVRV < 1 + Fear&Greed < 15 = zvaž postupnú akumuláciu bez ohľadu na správy.",
        "conclusionFinal": "FTX bol najväčší podvod v krypto histórii. Ale paradoxne vytvoril definitívne dno medvedieho trhu 2022 a začiatok býčieho trhu 2023-2024. Tí, ktorí pochopili on-chain signály a nakúpili v panike novembra 2022, znásobili za 14 mesiacov 4-násobne.",
        "datosCarouselLabels": {
                "minimo_ciclo": "Minimum cyklu",
                "fondos": "Stratené fondy",
                "afectados": "Postihnutí",
                "mvrv": "MVRV na minime",
                "fg_min": "F&G na minime",
                "rally_desde_min": "Rally od minima"
        }
},
      de: {
        categoria: "KAPITULATION",
        titulo: "FTX-Kollaps und BTC-Boden 2022",
        subtitulo: "Wie die Insolvenz der zweitgrößten Börse den endgültigen Boden des Bärenmarktes markierte",
        descripcion: "Wie die Insolvenz der Börse das endgültige Tief von 2022 und das Akkumulationssignal für Smart Money schuf.",
        duracionLectura: "16 min",
        nivel: "Fortgeschritten",
        resumen: "November 2022. Der Kryptomarkt war bereits 70% von den Höchstständen gefallen. Dann kam FTX. Die zweitgrößte Börse der Welt kollabierte innerhalb von 72 Stunden und brachte BTC auf 15.500$ — das Tief des Zyklus. Aber paradoxerweise war dies das größte Kapitulationsereignis und der exakte Punkt, an dem Smart Money aggressiv zu akkumulieren begann.",
        contexto: "FTX, gegründet von Sam Bankman-Fried (SBF), galt als die \"vertrauenswürdigste\" Börse des Krypto-Ökosystems. Unterstützt von Sequoia, SoftBank, Tom Brady, und SBF selbst war das Gesicht der Krypto-Regulierung. Was niemand wusste: Alameda Research (SBFs Hedgefonds) nutzte die Kundengelder von FTX für Trading. Ein CoinDesk-Artikel am 2. November enthüllte, dass die Bilanz von Alameda massiv vom FTT-Token (dem nativen Token von FTX) abhängig war.",
        timeline: [
          {
            fecha: "02 Nov 2022",
            titulo: "CoinDesk veröffentlicht Alamedas Bilanz",
            descripcion: "Der Artikel enthüllt, dass 40% der Bilanz von Alameda Research aus FTT-Token besteht (im Grunde von ihnen selbst geschaffenes Geld). Der Markt wird unruhig.",
            tipo: "critico"
          },
          {
            fecha: "06 Nov 2022",
            titulo: "Binance kündigt Verkauf aller FTT an",
            descripcion: "CZ (CEO von Binance) kündigt auf Twitter an, dass er alle FTT (~580M$) liquidieren wird. Das Vertrauen in FTX kollabiert. Sofortiger Bank Run: 6.000M$ in 72 Stunden abgezogen.",
            tipo: "critico"
          },
          {
            fecha: "08 Nov 2022",
            titulo: "FTX setzt Abhebungen aus",
            descripcion: "FTX kann keine weiteren Abhebungen mehr verarbeiten. Nutzer entdecken, dass keine Mittel vorhanden sind. BTC fällt auf 17.000$. Totale Panik am Markt.",
            tipo: "bajista"
          },
          {
            fecha: "09 Nov 2022",
            titulo: "Binance lehnt FTX-Kauf ab",
            descripcion: "Binance kündigte Interesse am Kauf von FTX an, zieht sich dann nach der Due Diligence zurück. 8.000M$ Loch in den Kundengeldern. BTC fällt auf 16.000$.",
            tipo: "critico"
          },
          {
            fecha: "11 Nov 2022",
            titulo: "FTX beantragt Insolvenz. SBF tritt zurück.",
            descripcion: "FTX, FTX US und Alameda Research beantragen Insolvenzschutz. SBF tritt zurück. Verluste von 8.000M$ an Kundengeldern werden enthüllt. BTC berührt 15.500$.",
            tipo: "critico"
          },
          {
            fecha: "Nov–Dez 2022",
            titulo: "Totale Kapitulation — Zyklustief",
            descripcion: "Der Markt kapituliert. Fear & Greed bei 6/100. Exchange Outflow auf historischen Höchstständen (alle ziehen von Börsen ab). MVRV bei 0.7 — historisch Bodenzone.",
            tipo: "critico"
          },
          {
            fecha: "Jan 2023",
            titulo: "Beginn der Erholung",
            descripcion: "BTC beginnt still von 15.500$ zu steigen. Institutionelle kaufen außerbörslich. Der Markt ist noch in Panik, aber der Boden hat sich bereits gebildet.",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "Das Tief von 15.500$ bildete ein klassisches Kapitulationsmuster: Kerze mit sehr langem unteren Docht, extremes Volumen (das höchste seit Monaten) und sofortige Ablehnung. Im Rückblick: (1) MVRV bei 0.7 → historisch Zyklusboden-Zone. (2) Puell Multiple auf Tiefstständen → Miner an der Rentabilitätsgrenze (Bodensignal). (3) NUPL in Kapitulation (-0.15). Alle On-Chain-Indikatoren zeigten \"generationaler Kauf\".",
        senalesOnchain: "Exchange Outflow am 8.-9. November war der höchste in der Geschichte: alle ziehen in eigene Wallets ab (Panik) ABER auch Wale ziehen ab, um außerbörslich zu akkumulieren. Der Spent Output Profit Ratio (SOPR) auf historischen Tiefstständen. Long-term Holder Supply auf Höchstständen: die HODLer verkauften nicht.",
        leccionesAprendidas: [
          "Lasse niemals große Mengen Krypto auf Börsen — \"not your keys, not your coins\" war nie relevanter",
          "Die größten Panikereignisse (FTX, LUNA) fallen historisch mit Marktböden zusammen",
          "MVRV < 1 + NUPL in Kapitulation + Fear&Greed < 10 = generationales Kaufsignal (wenn es nicht das Ende von BTC ist)",
          "Diversifizierung der Verwahrung (mehrere Wallets, Cold Storage) ist fundamentales Risikomanagement",
          "Exchange Outflow nach Krisen ist bullisches Signal: reduziert das verfügbare Angebot zum Verkauf"
        ],
        comoAplicarlo: "Protokoll für sichere Verwahrung: (1) Maximal 10% deines Portfolios auf Börsen — nur was du aktiv traden wirst. (2) 90% in eigenen Wallets (Hardware Wallet). (3) Nutze niemals eine Börse als langfristige Bank. Zur Identifizierung von Böden: MVRV < 1 + Fear&Greed < 15 = erwäge gestaffelte Akkumulation unabhängig von den Nachrichten.",
        conclusionFinal: "FTX war der größte Betrug in der Krypto-Geschichte. Aber paradoxerweise markierte es den endgültigen Boden des Bärenmarktes 2022 und den Beginn des Bullenmarktes 2023-2024. Diejenigen, die die On-Chain-Signale verstanden und in der Panik vom November 2022 kauften, vervierfachten ihr Investment in nur 14 Monaten.",
        datosCarouselLabels: {
          minimo_ciclo: "Zyklustief",
          fondos: "Verlorene Mittel",
          afectados: "Betroffene",
          mvrv: "MVRV auf Tief",
          fg_min: "F&G auf Tief",
          rally_desde_min: "Rally seit Tief"
        }
      },
      "zh-CN": {
        categoria: "投降",
        titulo: "FTX崩盘与BTC 2022年底部",
        subtitulo: "第二大交易所的破产如何标志着熊市的最终底部",
        descripcion: "交易所的破产如何创造了2022年的最终低点以及聪明资金的积累信号。",
        duracionLectura: "16分钟",
        nivel: "中级",
        resumen: "2022年11月。加密市场已从高点下跌70%。然后FTX来了。全球第二大交易所在72小时内崩盘，将BTC推至15,500美元——周期最低点。但矛盾的是，这是最大的投降事件，也是聪明资金开始激进积累的确切点。",
        contexto: "由Sam Bankman-Fried (SBF)创立的FTX被认为是加密生态系统中最\"可信\"的交易所。得到Sequoia、SoftBank、Tom Brady的支持，SBF本人是加密监管的形象代言人。没人知道的是：Alameda Research（SBF的对冲基金）使用FTX客户的资金进行交易。11月2日CoinDesk的一篇文章揭露Alameda的资产负债表严重依赖FTT代币（FTX的原生代币）。",
        timeline: [
          {
            fecha: "02 Nov 2022",
            titulo: "CoinDesk发布Alameda资产负债表",
            descripcion: "文章揭示Alameda Research资产负债表的40%是FTT代币（基本上是他们自己创造的钱）。市场开始不安。",
            tipo: "critico"
          },
          {
            fecha: "06 Nov 2022",
            titulo: "Binance宣布出售所有FTT",
            descripcion: "CZ（Binance首席执行官）在Twitter上宣布将清算所有FTT（约5.8亿美元）。对FTX的信心崩溃。瞬间挤兑：72小时内提取60亿美元。",
            tipo: "critico"
          },
          {
            fecha: "08 Nov 2022",
            titulo: "FTX暂停提款",
            descripcion: "FTX无法处理更多提款。用户发现没有资金。BTC跌至17,000美元。市场全面恐慌。",
            tipo: "bajista"
          },
          {
            fecha: "09 Nov 2022",
            titulo: "Binance拒绝收购FTX",
            descripcion: "Binance宣布有意收购FTX，在尽职调查后撤回。客户资金缺口80亿美元。BTC跌至16,000美元。",
            tipo: "critico"
          },
          {
            fecha: "11 Nov 2022",
            titulo: "FTX申请破产。SBF辞职。",
            descripcion: "FTX、FTX US和Alameda Research申请破产保护。SBF辞职。揭露客户资金损失80亿美元。BTC触及15,500美元。",
            tipo: "critico"
          },
          {
            fecha: "Nov–Dic 2022",
            titulo: "全面投降——周期最低点",
            descripcion: "市场投降。恐惧与贪婪指数6/100。交易所流出量创历史新高（所有人从交易所提币）。MVRV为0.7——历史上的底部区域。",
            tipo: "critico"
          },
          {
            fecha: "Ene 2023",
            titulo: "复苏开始",
            descripcion: "BTC从15,500美元悄然开始上涨。机构在场外购买。市场仍处于恐慌中，但底部已经形成。",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "15,500美元的最低点形成了经典的投降形态：下影线非常长的K线，极端交易量（数月来最高），以及立即反弹。回顾来看：(1) MVRV为0.7 → 历史上的周期底部区域。(2) Puell Multiple处于最低点 → 矿工处于盈利能力极限（底部信号）。(3) NUPL处于投降状态（-0.15）。所有链上指标都标志着\"世代买入机会\"。",
        senalesOnchain: "11月8-9日的交易所流出量是历史最高：所有人提币到自己的钱包（恐慌），但同时巨鲸也在提币以便场外积累。已花费输出利润率（SOPR）处于历史最低点。长期持有者供应量创新高：HODL者没有卖出。",
        leccionesAprendidas: [
          "永远不要在交易所存放大量加密货币——\"不是你的密钥，就不是你的币\"从未如此相关",
          "最大的恐慌事件（FTX、LUNA）历史上与市场底部重合",
          "MVRV < 1 + NUPL处于投降 + 恐惧与贪婪 < 10 = 世代买入信号（如果不是BTC的终结）",
          "托管多样化（多个钱包、冷存储）是基本的风险管理",
          "危机后的交易所流出是看涨信号：减少可供出售的供应"
        ],
        comoAplicarlo: "安全托管协议：(1) 最多10%的投资组合放在交易所——只放你要积极交易的部分。(2) 90%放在自己的钱包（硬件钱包）。(3) 永远不要将交易所用作长期银行。识别底部：MVRV < 1 + 恐惧与贪婪 < 15 = 考虑分批积累，无论新闻如何。",
        conclusionFinal: "FTX是加密历史上最大的欺诈案。但矛盾的是，它标志着2022年熊市的最终底部和2023-2024年牛市的开始。那些理解链上信号并在2022年11月恐慌中买入的人，仅在14个月内就获得了4倍回报。",
        datosCarouselLabels: {
          minimo_ciclo: "周期最低点",
          fondos: "损失资金",
          afectados: "受影响者",
          mvrv: "MVRV最低点",
          fg_min: "恐惧与贪婪最低点",
          rally_desde_min: "从最低点反弹"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 5 · Halving
  // ───────────────────────────────────────────────────────────
  {
    slug: "ciclos-halving-btc",
    colorCategoria: "#00d4ff",
    nivel: "intermedio",
    datosCarousel: [
      { key: "halvings", valor: "4 (2024)", color: "#00d4ff" },
      { key: "ret_min", valor: "+634%", color: "#00e676" },
      { key: "ret_max", valor: "+9.483%", color: "#00e676" },
      { key: "ret_avg", valor: "+2.698%", color: "#00e676" },
      { key: "aths_post", valor: "3 de 3", color: "#f5a623" },
      { key: "proximo", valor: "~2028", color: "#00d4ff" },
    ],
    i18n: {
      es: {
        categoria: "ANÁLISIS DE CICLO",
        titulo: "Ciclos Halving BTC: Análisis Estadístico",
        subtitulo: "El edge estadístico más fiable de Bitcoin: cómo cada halving ha precedido un bull market",
        descripcion: "Análisis cuantitativo de cada ciclo halving BTC y el edge estadístico que crea.",
        duracionLectura: "20 min",
        nivel: "Intermedio",
        resumen: "Cada 210.000 bloques (~4 años), la recompensa de los mineros de Bitcoin se reduce a la mitad. Este evento, el Halving, ha precedido cada uno de los tres grandes bull markets de la historia. No es coincidencia — es el mecanismo de oferta más predecible de cualquier activo financiero existente. Aquí está el análisis estadístico completo.",
        contexto: "Bitcoin tiene un suministro máximo de 21 millones de monedas. Actualmente se emiten ~900 BTC diarios (post-halving 2024: ~450 BTC/día). Los mineros son vendedores estructurales: necesitan vender BTC para pagar electricidad y equipos. El halving reduce a la mitad la oferta nueva. Si la demanda se mantiene constante y la oferta se reduce: el precio sube. Simple economía.",
        timeline: [
          { fecha: "28 Nov 2012", titulo: "Primer Halving: 50 → 25 BTC/bloque", descripcion: "BTC a 12$. El precio tardó 12 meses en reaccionar. En diciembre 2013 alcanzó 1.150$ (+9.483%). La narrativa no existía aún.", tipo: "critico" },
          { fecha: "09 Jul 2016", titulo: "Segundo Halving: 25 → 12.5 BTC/bloque", descripcion: "BTC a 650$. 17 meses después: ATH de 20.000$ en diciembre 2017 (+2.977%). Primer bull market mainstream.", tipo: "critico" },
          { fecha: "11 May 2020", titulo: "Tercer Halving: 12.5 → 6.25 BTC/bloque", descripcion: "BTC a 8.700$. Contexto COVID/estímulos. 12 meses después: ATH de 64.000$ en abril 2021 (+634%). El rally más rápido de la historia.", tipo: "critico" },
          { fecha: "20 Abr 2024", titulo: "Cuarto Halving: 6.25 → 3.125 BTC/bloque", descripcion: "BTC a 63.000$. Ya en zona de ATH pre-halving (primero en la historia). ETFs spot aprobados. Demanda institucional sin precedentes.", tipo: "critico" },
        ],
        analisisTecnico: "Estadísticas clave de los 3 ciclos anteriores: (1) Rendimiento medio en los 12 meses POST-halving: +634% (mínimo) a +9.483% (máximo). Media: +2.698%. (2) El precio SIEMPRE ha hecho ATH en los 12-18 meses post-halving. (3) El mínimo del ciclo SIEMPRE ocurre dentro de los 6 meses PREVIOS al halving. (4) El Puell Multiple (rentabilidad de mineros) cae a mínimos históricos en el halving → luego sube drásticamente.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "El halving es el evento más predecible y estadísticamente significativo de Bitcoin — planifica alrededor de él",
          "Los 6-12 meses previos al halving históricamente ofrecen las mejores relaciones riesgo/recompensa",
          "El DCA (Dollar Cost Averaging) en el año pre-halving y los 6 meses post-halving ha generado los mejores retornos",
          "El ciclo de 4 años no es una ley de la naturaleza — puede acelerarse o modificarse — pero ha funcionado 3 veces",
          "La narrativa del halving se convierte en profecía autocumplida: el mercado compra en anticipación, lo que genera el rally",
        ],
        comoAplicarlo: "Estrategia basada en ciclos de halving: (1) Identifica el halving aproximado (~4 años desde el anterior). (2) Empieza DCA 12 meses antes del halving. (3) Aumenta la posición en los 3 meses pre-halving. (4) Mantén hasta 12-18 meses post-halving. (5) Empieza a reducir cuando NUPL > 0.7 o MVRV > 3.5. Esta estrategia habría generado retornos extraordinarios en los 3 ciclos anteriores.",
        conclusionFinal: "Los ciclos de halving son la mayor ventaja estadística disponible para cualquier inversor en Bitcoin. No garantizan nada — el mercado puede evolucionar. Pero 3 de 3 ciclos han seguido el mismo patrón. El cuarto está en curso. Los que entienden el mecanismo y planifican alrededor de él tienen una ventaja real sobre el mercado.",
        datosCarouselLabels: {
          halvings: "Halvings ocurridos",
          ret_min: "Retorno mínimo post-H",
          ret_max: "Retorno máximo post-H",
          ret_avg: "Retorno promedio",
          aths_post: "ATHs post-halving",
          proximo: "Próximo halving",
        },
      },
      en: {
        "categoria": "CYCLE ANALYSIS",
        "titulo": "BTC Halving Cycles: Statistical Analysis",
        "subtitulo": "Bitcoin's most reliable statistical edge: how each halving has preceded a bull market",
        "descripcion": "Quantitative analysis of each BTC halving cycle and the statistical edge it creates.",
        "duracionLectura": "20 min",
        "nivel": "Intermediate",
        "resumen": "Every 210,000 blocks (~4 years), Bitcoin miners' reward is cut in half. This event, the Halving, has preceded each of the three major bull markets in history. It's no coincidence — it's the most predictable supply mechanism of any existing financial asset. Here is the complete statistical analysis.",
        "contexto": "Bitcoin has a maximum supply of 21 million coins. Currently ~900 BTC are issued daily (post-2024 halving: ~450 BTC/day). Miners are structural sellers: they need to sell BTC to pay for electricity and equipment. The halving cuts new supply in half. If demand remains constant and supply is reduced: price goes up. Simple economics.",
        "timeline": [
                {
                        "fecha": "28 Nov 2012",
                        "titulo": "First Halving: 50 → 25 BTC/block",
                        "descripcion": "BTC at $12. Price took 12 months to react. In December 2013 it reached $1,150 (+9,483%). The narrative didn't exist yet.",
                        "tipo": "critico"
                },
                {
                        "fecha": "09 Jul 2016",
                        "titulo": "Second Halving: 25 → 12.5 BTC/block",
                        "descripcion": "BTC at $650. 17 months later: ATH of $20,000 in December 2017 (+2,977%). First mainstream bull market.",
                        "tipo": "critico"
                },
                {
                        "fecha": "11 May 2020",
                        "titulo": "Third Halving: 12.5 → 6.25 BTC/block",
                        "descripcion": "BTC at $8,700. COVID/stimulus context. 12 months later: ATH of $64,000 in April 2021 (+634%). The fastest rally in history.",
                        "tipo": "critico"
                },
                {
                        "fecha": "20 Apr 2024",
                        "titulo": "Fourth Halving: 6.25 → 3.125 BTC/block",
                        "descripcion": "BTC at $63,000. Already in pre-halving ATH zone (first in history). Spot ETFs approved. Unprecedented institutional demand.",
                        "tipo": "critico"
                }
        ],
        "analisisTecnico": "Key statistics from the 3 previous cycles: (1) Average return in the 12 months POST-halving: +634% (minimum) to +9,483% (maximum). Average: +2,698%. (2) Price has ALWAYS made ATH within 12-18 months post-halving. (3) Cycle bottom ALWAYS occurs within 6 months BEFORE the halving. (4) The Puell Multiple (miner profitability) drops to historical lows at the halving → then rises dramatically.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "The halving is Bitcoin's most predictable and statistically significant event — plan around it",
                "The 6-12 months before the halving have historically offered the best risk/reward ratios",
                "DCA (Dollar Cost Averaging) in the pre-halving year and 6 months post-halving has generated the best returns",
                "The 4-year cycle is not a law of nature — it can accelerate or change — but it has worked 3 times",
                "The halving narrative becomes a self-fulfilling prophecy: the market buys in anticipation, which generates the rally"
        ],
        "comoAplicarlo": "Halving cycle-based strategy: (1) Identify the approximate halving (~4 years from the previous one). (2) Start DCA 12 months before the halving. (3) Increase position in the 3 months pre-halving. (4) Hold until 12-18 months post-halving. (5) Start reducing when NUPL > 0.7 or MVRV > 3.5. This strategy would have generated extraordinary returns in the 3 previous cycles.",
        "conclusionFinal": "Halving cycles are the greatest statistical edge available to any Bitcoin investor. They don't guarantee anything — the market can evolve. But 3 out of 3 cycles have followed the same pattern. The fourth is underway. Those who understand the mechanism and plan around it have a real edge over the market.",
        "datosCarouselLabels": {
                "halvings": "Halvings occurred",
                "ret_min": "Minimum post-H return",
                "ret_max": "Maximum post-H return",
                "ret_avg": "Average return",
                "aths_post": "Post-halving ATHs",
                "proximo": "Next halving"
        }
},
      sk: {
        "categoria": "ANALÝZA CYKLU",
        "titulo": "BTC Halving cykly: Štatistická analýza",
        "subtitulo": "Najspoľahlivejšia štatistická výhoda Bitcoinu: ako každý halving predchádzal bull marketu",
        "descripcion": "Kvantitatívna analýza každého BTC halving cyklu a štatistická výhoda, ktorú vytvára.",
        "duracionLectura": "20 min",
        "nivel": "Stredne pokročilý",
        "resumen": "Každých 210 000 blokov (~4 roky) sa odmena minerov Bitcoinu zníži na polovicu. Táto udalosť, Halving, predchádzala každému z troch veľkých bull marketov v histórii. Nie je to náhoda — je to najpredvídateľnejší mechanizmus ponuky akéhokoľvek existujúceho finančného aktíva. Tu je kompletná štatistická analýza.",
        "contexto": "Bitcoin má maximálnu ponuku 21 miliónov mincí. Momentálne sa emituje ~900 BTC denne (po halvingu 2024: ~450 BTC/deň). Mineri sú štrukturálni predajcovia: potrebujú predávať BTC na platenie elektriny a zariadení. Halving zníži novú ponuku na polovicu. Ak dopyt zostane konštantný a ponuka sa zníži: cena rastie. Jednoduchá ekonómia.",
        "timeline": [
                {
                        "fecha": "28 Nov 2012",
                        "titulo": "Prvý Halving: 50 → 25 BTC/blok",
                        "descripcion": "BTC na 12$. Cena reagovala až po 12 mesiacoch. V decembri 2013 dosiahla 1 150$ (+9 483%). Naratív ešte neexistoval.",
                        "tipo": "critico"
                },
                {
                        "fecha": "09 Júl 2016",
                        "titulo": "Druhý Halving: 25 → 12,5 BTC/blok",
                        "descripcion": "BTC na 650$. O 17 mesiacov neskôr: ATH 20 000$ v decembri 2017 (+2 977%). Prvý mainstreamový bull market.",
                        "tipo": "critico"
                },
                {
                        "fecha": "11 Máj 2020",
                        "titulo": "Tretí Halving: 12,5 → 6,25 BTC/blok",
                        "descripcion": "BTC na 8 700$. Kontext COVID/stimuly. O 12 mesiacov neskôr: ATH 64 000$ v apríli 2021 (+634%). Najrýchlejšie rally v histórii.",
                        "tipo": "critico"
                },
                {
                        "fecha": "20 Apr 2024",
                        "titulo": "Štvrtý Halving: 6,25 → 3,125 BTC/blok",
                        "descripcion": "BTC na 63 000$. Už v zóne ATH pred halvingom (prvýkrát v histórii). Schválené spotové ETF. Bezprecedentný inštitucionálny dopyt.",
                        "tipo": "critico"
                }
        ],
        "analisisTecnico": "Kľúčové štatistiky z 3 predchádzajúcich cyklov: (1) Priemerný výnos za 12 mesiacov PO halvingu: +634% (minimum) až +9 483% (maximum). Priemer: +2 698%. (2) Cena VŽDY dosiahla ATH v priebehu 12-18 mesiacov po halvingu. (3) Minimum cyklu sa VŽDY vyskytlo v priebehu 6 mesiacov PRED halvingom. (4) Puell Multiple (ziskovosť minerov) klesá na historické minimá pri halvingu → potom dramaticky rastie.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "Halving je najpredvídateľnejšia a štatisticky najvýznamnejšia udalosť Bitcoinu — plánuj okolo nej",
                "Obdobie 6-12 mesiacov pred halvingom historicky ponúka najlepší pomer rizika a odmeny",
                "DCA (Dollar Cost Averaging) v roku pred halvingom a 6 mesiacov po halvingu generoval najlepšie výnosy",
                "4-ročný cyklus nie je prírodný zákon — môže sa zrýchliť alebo zmeniť — ale fungoval 3-krát",
                "Naratív halvingu sa stáva self-fulfilling prophecy: trh kupuje v očakávaní, čo generuje rally"
        ],
        "comoAplicarlo": "Stratégia založená na halving cykloch: (1) Identifikuj približný halving (~4 roky od predchádzajúceho). (2) Začni DCA 12 mesiacov pred halvingom. (3) Zvýš pozíciu v 3 mesiacoch pred halvingom. (4) Drž až do 12-18 mesiacov po halvingu. (5) Začni redukovať, keď NUPL > 0,7 alebo MVRV > 3,5. Táto stratégia by generovala mimoriadne výnosy v 3 predchádzajúcich cykloch.",
        "conclusionFinal": "Halving cykly sú najväčšia štatistická výhoda dostupná pre akéhokoliv investora do Bitcoinu. Nezaručujú nič — trh sa môže vyvíjať. Ale 3 z 3 cyklov nasledovali rovnaký vzorec. Štvrtý je v plnom prúde. Tí, ktorí chápu mechanizmus a plánujú okolo neho, maju skutočnú výhodu oproti trhu.",
        "datosCarouselLabels": {
                "halvings": "Uskutočnené halvingy",
                "ret_min": "Minimálny výnos po H",
                "ret_max": "Maximálny výnos po H",
                "ret_avg": "Priemerný výnos",
                "aths_post": "ATH po halvingu",
                "proximo": "Ďalší halving"
        }
},
      de: {
        categoria: "ZYKLUSANALYSE",
        titulo: "BTC-Halving-Zyklen: Statistische Analyse",
        subtitulo: "Der zuverlässigste statistische Edge von Bitcoin: wie jedes Halving einem Bullenmarkt vorausging",
        descripcion: "Quantitative Analyse jedes BTC-Halving-Zyklus und des statistischen Edges, den er schafft.",
        duracionLectura: "20 Min.",
        nivel: "Fortgeschritten",
        resumen: "Alle 210.000 Blöcke (~4 Jahre) wird die Belohnung der Bitcoin-Miner halbiert. Dieses Ereignis, das Halving, ging jedem der drei großen Bullenmärkte der Geschichte voraus. Das ist kein Zufall — es ist der vorhersehbarste Angebotsmechanismus jedes existierenden Finanzanlageguts. Hier ist die vollständige statistische Analyse.",
        contexto: "Bitcoin hat ein maximales Angebot von 21 Millionen Münzen. Derzeit werden ~900 BTC täglich ausgegeben (nach Halving 2024: ~450 BTC/Tag). Miner sind strukturelle Verkäufer: Sie müssen BTC verkaufen, um Strom und Ausrüstung zu bezahlen. Das Halving halbiert das neue Angebot. Wenn die Nachfrage konstant bleibt und das Angebot sinkt: steigt der Preis. Einfache Ökonomie.",
        timeline: [
          {
            fecha: "28 Nov 2012",
            titulo: "Erstes Halving: 50 → 25 BTC/Block",
            descripcion: "BTC bei 12$. Der Preis brauchte 12 Monate, um zu reagieren. Im Dezember 2013 erreichte er 1.150$ (+9.483%). Die Narrativ existierte noch nicht.",
            tipo: "critico"
          },
          {
            fecha: "09 Jul 2016",
            titulo: "Zweites Halving: 25 → 12,5 BTC/Block",
            descripcion: "BTC bei 650$. 17 Monate später: ATH von 20.000$ im Dezember 2017 (+2.977%). Erster Mainstream-Bullenmarkt.",
            tipo: "critico"
          },
          {
            fecha: "11 May 2020",
            titulo: "Drittes Halving: 12,5 → 6,25 BTC/Block",
            descripcion: "BTC bei 8.700$. COVID/Stimulus-Kontext. 12 Monate später: ATH von 64.000$ im April 2021 (+634%). Die schnellste Rally der Geschichte.",
            tipo: "critico"
          },
          {
            fecha: "20 Abr 2024",
            titulo: "Viertes Halving: 6,25 → 3,125 BTC/Block",
            descripcion: "BTC bei 63.000$. Bereits in ATH-Zone vor dem Halving (erstmals in der Geschichte). Spot-ETFs genehmigt. Beispiellose institutionelle Nachfrage.",
            tipo: "critico"
          }
        ],
        analisisTecnico: "Wichtige Statistiken der 3 vorherigen Zyklen: (1) Durchschnittliche Rendite in den 12 Monaten NACH dem Halving: +634% (Minimum) bis +9.483% (Maximum). Durchschnitt: +2.698%. (2) Der Preis hat IMMER in den 12-18 Monaten nach dem Halving ein ATH erreicht. (3) Das Zyklustief tritt IMMER innerhalb der 6 Monate VOR dem Halving auf. (4) Der Puell Multiple (Miner-Rentabilität) fällt beim Halving auf historische Tiefststände → steigt dann drastisch.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "Das Halving ist das vorhersehbarste und statistisch signifikanteste Ereignis von Bitcoin — plane darum herum",
          "Die 6-12 Monate vor dem Halving haben historisch die besten Risiko-Ertrags-Verhältnisse geboten",
          "DCA (Dollar Cost Averaging) im Jahr vor dem Halving und in den 6 Monaten danach hat die besten Renditen generiert",
          "Der 4-Jahres-Zyklus ist kein Naturgesetz — er kann sich beschleunigen oder ändern — aber er hat 3 Mal funktioniert",
          "Die Halving-Narrativ wird zur selbsterfüllenden Prophezeiung: Der Markt kauft in Erwartung, was die Rally erzeugt"
        ],
        comoAplicarlo: "Strategie basierend auf Halving-Zyklen: (1) Identifiziere das ungefähre Halving (~4 Jahre nach dem vorherigen). (2) Beginne DCA 12 Monate vor dem Halving. (3) Erhöhe die Position in den 3 Monaten vor dem Halving. (4) Halte bis 12-18 Monate nach dem Halving. (5) Beginne zu reduzieren, wenn NUPL > 0,7 oder MVRV > 3,5. Diese Strategie hätte in den 3 vorherigen Zyklen außergewöhnliche Renditen generiert.",
        conclusionFinal: "Die Halving-Zyklen sind der größte statistische Vorteil, der jedem Bitcoin-Investor zur Verfügung steht. Sie garantieren nichts — der Markt kann sich entwickeln. Aber 3 von 3 Zyklen sind dem gleichen Muster gefolgt. Der vierte ist im Gange. Diejenigen, die den Mechanismus verstehen und darum herum planen, haben einen echten Vorteil gegenüber dem Markt.",
        datosCarouselLabels: {
          halvings: "Stattgefundene Halvings",
          ret_min: "Minimale Rendite nach H",
          ret_max: "Maximale Rendite nach H",
          ret_avg: "Durchschnittliche Rendite",
          aths_post: "ATHs nach Halving",
          proximo: "Nächstes Halving"
        }
      },
      "zh-CN": {
        categoria: "周期分析",
        titulo: "BTC减半周期：统计分析",
        subtitulo: "比特币最可靠的统计优势：每次减半如何引领牛市",
        descripcion: "每个BTC减半周期的量化分析及其创造的统计优势。",
        duracionLectura: "20 min",
        nivel: "中级",
        resumen: "每210,000个区块（约4年），比特币矿工的奖励减半。这一事件——减半（Halving），已经引领了历史上三次重大牛市。这不是巧合——这是现存金融资产中最可预测的供应机制。以下是完整的统计分析。",
        contexto: "比特币的最大供应量为2100万枚。目前每日发行约900 BTC（2024年减半后：约450 BTC/天）。矿工是结构性卖方：他们需要出售BTC来支付电费和设备。减半将新增供应减半。如果需求保持不变而供应减少：价格上涨。简单的经济学。",
        timeline: [
          {
            fecha: "28 Nov 2012",
            titulo: "第一次减半：50 → 25 BTC/区块",
            descripcion: "BTC价格12$。价格用了12个月才反应。2013年12月达到1,150$（+9,483%）。当时叙事尚不存在。",
            tipo: "critico"
          },
          {
            fecha: "09 Jul 2016",
            titulo: "第二次减半：25 → 12.5 BTC/区块",
            descripcion: "BTC价格650$。17个月后：2017年12月ATH 20,000$（+2,977%）。首次主流牛市。",
            tipo: "critico"
          },
          {
            fecha: "11 May 2020",
            titulo: "第三次减半：12.5 → 6.25 BTC/区块",
            descripcion: "BTC价格8,700$。COVID/刺激政策背景。12个月后：2021年4月ATH 64,000$（+634%）。历史上最快的涨势。",
            tipo: "critico"
          },
          {
            fecha: "20 Abr 2024",
            titulo: "第四次减半：6.25 → 3.125 BTC/区块",
            descripcion: "BTC价格63,000$。减半前已处于ATH区域（历史首次）。现货ETF获批。前所未有的机构需求。",
            tipo: "critico"
          }
        ],
        analisisTecnico: "前3个周期的关键统计数据：(1) 减半后12个月的平均回报：+634%（最低）至+9,483%（最高）。平均：+2,698%。(2) 价格始终在减半后12-18个月内创下ATH。(3) 周期最低点始终出现在减半前6个月内。(4) Puell Multiple（矿工盈利能力）在减半时跌至历史低点→随后大幅上升。",
        senalesOnchain: null,
        leccionesAprendidas: [
          "减半是比特币最可预测且统计上最显著的事件——围绕它进行规划",
          "减半前6-12个月历史上提供了最佳的风险/奖励比",
          "在减半前一年和减半后6个月进行DCA（定投）产生了最佳回报",
          "4年周期不是自然法则——可能加速或改变——但已成功3次",
          "减半叙事成为自我实现的预言：市场提前买入预期，从而产生涨势"
        ],
        comoAplicarlo: "基于减半周期的策略：(1) 确定大致减半时间（距上次约4年）。(2) 在减半前12个月开始DCA。(3) 在减半前3个月增加仓位。(4) 持有至减半后12-18个月。(5) 当NUPL > 0.7或MVRV > 3.5时开始减仓。这一策略在前3个周期中都会产生非凡回报。",
        conclusionFinal: "减半周期是任何比特币投资者可获得的最大统计优势。它们不保证任何事——市场可能演变。但3个周期中有3个遵循了相同模式。第四个正在进行中。那些理解机制并围绕它规划的人相对市场拥有真正的优势。",
        datosCarouselLabels: {
          halvings: "已发生的减半",
          ret_min: "减半后最低回报",
          ret_max: "减半后最高回报",
          ret_avg: "平均回报",
          aths_post: "减半后ATH次数",
          proximo: "下次减半"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 6 · Short Squeeze Nov 2023
  // ───────────────────────────────────────────────────────────
  {
    slug: "short-squeeze-nov-2023",
    colorCategoria: "#9b59ff",
    nivel: "intermedio",
    datosCarousel: [
      { key: "rally", valor: "+69%", color: "#00e676" },
      { key: "liquidaciones", valor: "1.200M$", color: "#9b59ff" },
      { key: "tiempo_rally", valor: "7 semanas", color: "#00d4ff" },
      { key: "funding", valor: "-0.02%", color: "#f5a623" },
      { key: "desde", valor: "26.000$", color: "#f5a623" },
      { key: "hasta", valor: "44.000$", color: "#00e676" },
    ],
    i18n: {
      es: {
        categoria: "SHORT SQUEEZE",
        titulo: "Anatomía Short Squeeze: Ruptura Noviembre 2023",
        subtitulo: "Cómo 1.200M$ en liquidaciones de shorts alimentaron el rally más explosivo del ciclo",
        descripcion: "Cómo 1.200M USD en liquidaciones short alimentaron el rally de Octubre 2023 de 26K a 44K USD.",
        duracionLectura: "14 min",
        nivel: "Intermedio",
        resumen: "Entre septiembre y octubre 2023, BTC llevaba meses consolidando en el rango 25.000-27.000$. Las posiciones cortas se acumularon masivamente — los traders apostaban que el precio seguiría cayendo. Entonces llegó el rumor del ETF de BlackRock. Lo que siguió fue uno de los rallies más explosivos de la historia: de 26.000$ a 44.000$ en 7 semanas, alimentado por 1.200M$ en shorts liquidados.",
        contexto: "El mercado en Q3 2023 era bajista: Bitcoin llevaba consolidando por meses, las tasas de interés de la Fed estaban en máximos de 22 años, y el sentimiento era de capitulación. Los traders de derivados habían acumulado posiciones cortas masivas, apostando a que el precio seguiría cayendo. El funding rate (coste de mantener shorts) era negativo — señal de exceso de posiciones cortas. Esta situación es el set-up perfecto para un short squeeze.",
        timeline: [
          { fecha: "Sep 2023", titulo: "BTC consolida en 26K. Shorts se acumulan.", descripcion: "Funding rate negativo: -0.02% por 8h (récord de bajismo). Open Interest en futuros en máximos. El mercado apostando masivamente al lado bajista.", tipo: "neutro" },
          { fecha: "16 Oct 2023", titulo: "Rumor falso del ETF de BlackRock", descripcion: "Medios publican (erróneamente) que la SEC aprobó el ETF de BlackRock. BTC sube de 27.000$ a 30.000$ en minutos. Liquidaciones masivas de shorts. El rumor es desmentido pero el precio no vuelve.", tipo: "alcista" },
          { fecha: "Oct 2023", titulo: "La tendencia cambia — BOS alcista", descripcion: "A pesar del rumor falso, el mercado no cae de vuelta. Los shorts siguen siendo liquidados. El precio establece máximos y mínimos crecientes. Cambio de estructura.", tipo: "alcista" },
          { fecha: "Nov 2023", titulo: "Rally explosivo: 30K → 44K", descripcion: "Con la confirmación de que BlackRock sí había aplicado para el ETF, el rally se acelera. 1.200M$ en shorts liquidados en pocas semanas. El feedback loop de liquidaciones alimenta el rally.", tipo: "alcista" },
          { fecha: "Dic 2023", titulo: "BTC consolida en 40-44K", descripcion: "El rally pausó pero no cayó. Los niveles de 40K se convirtieron en soporte. La estructura alcista estaba establecida. El bull market comenzó formalmente.", tipo: "alcista" },
        ],
        analisisTecnico: "El setup del short squeeze era perfectamente identificable ANTES del evento: (1) Funding rate muy negativo (mercado con exceso de cortos). (2) Open Interest en futuros en máximos (posiciones grandes abiertas). (3) BTC en zona de soporte clave (26-27K, máximo de 2019). (4) Precio comprimido en rango estrecho durante semanas (energía acumulada). Cuando el catalizador (ETF rumor) apareció, el resultado fue explosivo.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "Un funding rate muy negativo + precio en soporte = set-up de short squeeze. Considera posición larga con stop tight.",
          "Los short squeezes son autocumplidos: las liquidaciones de shorts generan demanda que fuerza más liquidaciones",
          "El \"buy the rumor\" funciona incluso cuando el rumor es falso — lo que importa es el reposicionamiento institucional",
          "El Open Interest en futuros es un indicador de riesgo: niveles extremos (altos o bajos) preceden movimientos violentos",
          "Después de un short squeeze, el nuevo nivel se convierte en soporte: el mercado recuerda \"cuánta presión absorbió\"",
        ],
        comoAplicarlo: "Identificar set-ups de short squeeze: (1) Busca funding rate < -0.01% durante >3 días. (2) Verifica que el Open Interest es alto (mucho capital en shorts). (3) Identifica un soporte técnico fuerte en el precio actual. (4) Espera un catalizador (noticia, datos macro) o simplemente una ruptura de resistencia. (5) Entrada con stop loss bajo el soporte. Target: las zonas donde se concentran los stops de los shorts (suelen ser máximos previos).",
        conclusionFinal: "El short squeeze de octubre-noviembre 2023 fue la señal definitiva del fin del bear market y el inicio del bull run 2024. Los que entendieron el setup (funding negativo + exceso de cortos + soporte clave) tuvieron la oportunidad de posicionarse ANTES del movimiento. La información estaba disponible — había que saber dónde mirar.",
        datosCarouselLabels: {
          rally: "Rally generado",
          liquidaciones: "Shorts liquidados",
          tiempo_rally: "Tiempo del rally",
          funding: "Funding rate previo",
          desde: "De",
          hasta: "A",
        },
      },
      en: {
        "categoria": "SHORT SQUEEZE",
        "titulo": "Short Squeeze Anatomy: November 2023 Breakout",
        "subtitulo": "How $1.2B in short liquidations fueled the most explosive rally of the cycle",
        "descripcion": "How 1.2B USD in short liquidations fueled the October 2023 rally from 26K to 44K USD.",
        "duracionLectura": "14 min",
        "nivel": "Intermediate",
        "resumen": "Between September and October 2023, BTC had been consolidating for months in the 25,000-27,000$ range. Short positions accumulated massively — traders were betting that the price would continue falling. Then came the BlackRock ETF rumor. What followed was one of the most explosive rallies in history: from $26,000 to $44,000 in 7 weeks, fueled by $1.2B in liquidated shorts.",
        "contexto": "The market in Q3 2023 was bearish: Bitcoin had been consolidating for months, the Fed interest rates were at 22-year highs, and sentiment was capitulation. Derivatives traders had accumulated massive short positions, betting that the price would continue falling. The funding rate (cost of maintaining shorts) was negative — a sign of excessive short positions. This situation is the perfect set-up for a short squeeze.",
        "timeline": [
                {
                        "fecha": "Sep 2023",
                        "titulo": "BTC consolidates at 26K. Shorts accumulate.",
                        "descripcion": "Negative funding rate: -0.02% per 8h (record bearishness). Open Interest in futures at highs. The market massively betting on the downside.",
                        "tipo": "neutro"
                },
                {
                        "fecha": "16 Oct 2023",
                        "titulo": "False BlackRock ETF rumor",
                        "descripcion": "Media publish (erroneously) that the SEC approved the BlackRock ETF. BTC rises from $27,000 to $30,000 in minutes. Massive short liquidations. The rumor is denied but the price doesn't return.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Oct 2023",
                        "titulo": "The trend changes — bullish BOS",
                        "descripcion": "Despite the false rumor, the market doesn't fall back. Shorts continue being liquidated. Price establishes higher highs and higher lows. Structure change.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Nov 2023",
                        "titulo": "Explosive rally: 30K → 44K",
                        "descripcion": "With confirmation that BlackRock had indeed applied for the ETF, the rally accelerates. $1.2B in shorts liquidated in a few weeks. The feedback loop of liquidations fuels the rally.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Dec 2023",
                        "titulo": "BTC consolidates at 40-44K",
                        "descripcion": "The rally paused but didn't fall. The 40K levels became support. The bullish structure was established. The bull market formally began.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "The short squeeze setup was perfectly identifiable BEFORE the event: (1) Very negative funding rate (market with excessive shorts). (2) Open Interest in futures at highs (large positions open). (3) BTC in key support zone (26-27K, 2019 high). (4) Price compressed in narrow range for weeks (accumulated energy). When the catalyst (ETF rumor) appeared, the result was explosive.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "A very negative funding rate + price at support = short squeeze set-up. Consider long position with tight stop.",
                "Short squeezes are self-fulfilling: short liquidations generate demand that forces more liquidations",
                "\"Buy the rumor\" works even when the rumor is false — what matters is institutional repositioning",
                "Open Interest in futures is a risk indicator: extreme levels (high or low) precede violent moves",
                "After a short squeeze, the new level becomes support: the market remembers \"how much pressure it absorbed\""
        ],
        "comoAplicarlo": "Identify short squeeze set-ups: (1) Look for funding rate < -0.01% for >3 days. (2) Verify that Open Interest is high (much capital in shorts). (3) Identify strong technical support at current price. (4) Wait for a catalyst (news, macro data) or simply a resistance breakout. (5) Entry with stop loss below support. Target: zones where short stops are concentrated (usually previous highs).",
        "conclusionFinal": "The October-November 2023 short squeeze was the definitive signal of the end of the bear market and the start of the 2024 bull run. Those who understood the setup (negative funding + excessive shorts + key support) had the opportunity to position themselves BEFORE the move. The information was available — you had to know where to look.",
        "datosCarouselLabels": {
                "rally": "Rally generated",
                "liquidaciones": "Shorts liquidated",
                "tiempo_rally": "Rally timeframe",
                "funding": "Previous funding rate",
                "desde": "From",
                "hasta": "To"
        }
},
      sk: {
        "categoria": "SHORT SQUEEZE",
        "titulo": "Anatómia Short Squeeze: Prelomenie November 2023",
        "subtitulo": "Ako 1 200M$ v likvidáciách shortov poháňalo najvýbušnejší rally cyklu",
        "descripcion": "Ako 1 200M USD v likvidáciách shortov poháňalo rally z októbra 2023 z 26K na 44K USD.",
        "duracionLectura": "14 min",
        "nivel": "Stredne pokročilý",
        "resumen": "Medzi septembrom a októbrom 2023 BTC konsolidoval mesiace v rozmedzí 25 000-27 000$. Krátke pozície sa masívne hromadili — traderi stávkovali, že cena bude ďalej klesať. Potom prišla fáma o ETF od BlackRock. To, co nasledovalo, bolo jedno z najvýbušnejších rally v histórii: z 26 000$ na 44 000$ za 7 týždňov, poháňané 1 200M$ zlikvidovaných shortov.",
        "contexto": "Trh v Q3 2023 byl medvedí: Bitcoin konsolidoval mesiace, úrokové sadzby Fed boli na 22-ročných maximách a sentiment bol kapitulačný. Traderi derivátov nahromadili masívne krátke pozície, stávkujúc na to, že cena bude ďalej klesať. Funding rate (náklady na udržanie shortov) bol negatívny — signál excesívnych krátkych pozícií. Táto situácia je dokonalý set-up pre short squeeze.",
        "timeline": [
                {
                        "fecha": "Sep 2023",
                        "titulo": "BTC konsoliduje na 26K. Shorty sa hromadia.",
                        "descripcion": "Funding rate negatívny: -0,02% za 8h (rekordný bearish). Open Interest vo futures na maximách. Trh masívne stávkuje na medvedí stranu.",
                        "tipo": "neutro"
                },
                {
                        "fecha": "16 Okt 2023",
                        "titulo": "Falošná fáma o ETF BlackRock",
                        "descripcion": "Médiá publikujú (chybne), že SEC schválila ETF BlackRock. BTC stúpa z 27 000$ na 30 000$ za minúty. Masívne likvidácie shortov. Fáma je vyvrátená, ale cena sa nevracia späť.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Okt 2023",
                        "titulo": "Trend sa mení — býčí BOS",
                        "descripcion": "Napriek falošnej fáme trh nespadne späť. Shorty sú naďalej likvidované. Cena ustanovuje rastúce maximá a minimá. Zmena štruktúry.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Nov 2023",
                        "titulo": "Výbušné rally: 30K → 44K",
                        "descripcion": "S potvrdením, že BlackRock skutočne podal žiadosť o ETF, sa rally urýchľuje. 1 200M$ v shortoch zlikvidovaných za niekoľko týždňov. Feedback loop likvidácií poháňa rally.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Dec 2023",
                        "titulo": "BTC konsoliduje na 40-44K",
                        "descripcion": "Rally zastalo, ale nespadlo. Úrovne 40K sa stali supportom. Býčia štruktúra bola ustanovená. Bull market formálne začal.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "Setup short squeeze bol dokonale identifikovateľný PRED udalosťou: (1) Funding rate veľmi negatívny (trh s excesom shortov). (2) Open Interest vo futures na maximách (veľké otvorené pozície). (3) BTC v zóne kľúčového supportu (26-27K, maximum z 2019). (4) Cena stlačená v úzkom rozmedzí týždne (akumulovaná energia). Keď sa objavil katalyzátor (ETF fáma), výsledok bol výbušný.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "Veľmi negatívny funding rate + cena na supporte = set-up short squeeze. Zváž long pozíciu s tesným stopom.",
                "Short squeezes sú samospĺňajúce: likvidácie shortov generujú dopyt, ktorý vynúti ďalšie likvidácie",
                "\"Buy the rumor\" funguje aj keď je fáma falošná — záleží na inštitucionálnom prepozícovaní",
                "Open Interest vo futures je indikátor rizika: extrémne úrovne (vysoké alebo nízke) predchádzajú násilným pohybom",
                "Po short squeeze sa nová úroveň stáva supportom: trh si pamätá \"koľko tlaku absorboval\""
        ],
        "comoAplicarlo": "Identifikácia set-upov short squeeze: (1) Hľadaj funding rate < -0,01% viac ako 3 dni. (2) Over, že Open Interest je vysoký (veľa kapitálu v shortoch). (3) Identifikuj silný technický support na aktuálnej cene. (4) Čakaj na katalyzátor (správy, makro dáta) alebo jednoducho prelomenie rezistencie. (5) Vstup so stop lossom pod supportom. Target: zóny, kde sa koncentrujú stopy shortov (zvyčajne predchádzajúce maximá).",
        "conclusionFinal": "Short squeeze z októbra-novembra 2023 bol definitívny signál konca bear marketu a začiatku bull runu 2024. Tí, čo pochopili setup (negatívny funding + exces shortov + kľúčový support), mali príležitosť poziciu ť sa PRED pohybom. Informácie boli dostupné — bolo treba vedieť, kam sa pozerať.",
        "datosCarouselLabels": {
                "rally": "Generované rally",
                "liquidaciones": "Zlikvidované shorty",
                "tiempo_rally": "Trvanie rally",
                "funding": "Predchádzajúci funding rate",
                "desde": "Z",
                "hasta": "Na"
        }
},
      de: {
        categoria: "SHORT SQUEEZE",
        titulo: "Anatomie Short Squeeze: Ausbruch November 2023",
        subtitulo: "Wie 1.200M$ an Short-Liquidationen die explosivste Rally des Zyklus befeuerten",
        descripcion: "Wie 1.200M USD an Short-Liquidationen die Rally von Oktober 2023 von 26K auf 44K USD befeuerten.",
        duracionLectura: "14 min",
        nivel: "Fortgeschritten",
        resumen: "Zwischen September und Oktober 2023 konsolidierte BTC monatelang in der Spanne 25.000-27.000$. Short-Positionen häuften sich massiv an — Trader wetteten darauf, dass der Preis weiter fallen würde. Dann kam das Gerücht über den BlackRock ETF. Was folgte, war eine der explosivsten Rallys der Geschichte: von 26.000$ auf 44.000$ in 7 Wochen, befeuert durch 1.200M$ an liquidierten Shorts.",
        contexto: "Der Markt in Q3 2023 war bärisch: Bitcoin konsolidierte seit Monaten, die Zinssätze der Fed standen auf 22-Jahres-Höchstständen, und die Stimmung war kapitulativ. Derivate-Trader hatten massive Short-Positionen aufgebaut und wetteten darauf, dass der Preis weiter fallen würde. Die Funding Rate (Kosten für das Halten von Shorts) war negativ — ein Zeichen für übermäßige Short-Positionen. Diese Situation ist das perfekte Setup für einen Short Squeeze.",
        timeline: [
          {
            fecha: "Sep 2023",
            titulo: "BTC konsolidiert bei 26K. Shorts häufen sich an.",
            descripcion: "Negative Funding Rate: -0,02% pro 8h (Rekord-Bärischkeit). Open Interest bei Futures auf Höchstständen. Der Markt wettet massiv auf die bärische Seite.",
            tipo: "neutro"
          },
          {
            fecha: "16 Oct 2023",
            titulo: "Falsches Gerücht über BlackRock ETF",
            descripcion: "Medien berichten (fälschlicherweise), dass die SEC den BlackRock ETF genehmigt hat. BTC steigt in Minuten von 27.000$ auf 30.000$. Massive Short-Liquidationen. Das Gerücht wird dementiert, aber der Preis kehrt nicht zurück.",
            tipo: "alcista"
          },
          {
            fecha: "Oct 2023",
            titulo: "Der Trend ändert sich — bullischer BOS",
            descripcion: "Trotz des falschen Gerüchts fällt der Markt nicht zurück. Shorts werden weiter liquidiert. Der Preis etabliert steigende Hochs und Tiefs. Strukturwechsel.",
            tipo: "alcista"
          },
          {
            fecha: "Nov 2023",
            titulo: "Explosive Rally: 30K → 44K",
            descripcion: "Mit der Bestätigung, dass BlackRock tatsächlich den ETF beantragt hatte, beschleunigt sich die Rally. 1.200M$ an Shorts werden in wenigen Wochen liquidiert. Die Feedback-Schleife der Liquidationen befeuert die Rally.",
            tipo: "alcista"
          },
          {
            fecha: "Dic 2023",
            titulo: "BTC konsolidiert bei 40-44K",
            descripcion: "Die Rally pausierte, fiel aber nicht. Die Niveaus von 40K wurden zur Unterstützung. Die bullische Struktur war etabliert. Der Bullenmarkt begann formell.",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "Das Setup des Short Squeeze war VOR dem Ereignis perfekt identifizierbar: (1) Sehr negative Funding Rate (Markt mit übermäßigen Shorts). (2) Open Interest bei Futures auf Höchstständen (große offene Positionen). (3) BTC in wichtiger Unterstützungszone (26-27K, Höchststand von 2019). (4) Preis in enger Spanne über Wochen komprimiert (akkumulierte Energie). Als der Katalysator (ETF-Gerücht) erschien, war das Ergebnis explosiv.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "Eine sehr negative Funding Rate + Preis an Unterstützung = Short-Squeeze-Setup. Erwäge Long-Position mit engem Stop.",
          "Short Squeezes sind selbsterfüllend: Liquidationen von Shorts erzeugen Nachfrage, die weitere Liquidationen erzwingt",
          "\"Buy the rumor\" funktioniert selbst wenn das Gerücht falsch ist — was zählt, ist die institutionelle Neupositionierung",
          "Das Open Interest bei Futures ist ein Risikoindikator: extreme Niveaus (hoch oder niedrig) gehen gewaltsamen Bewegungen voraus",
          "Nach einem Short Squeeze wird das neue Niveau zur Unterstützung: der Markt erinnert sich, \"wie viel Druck er absorbiert hat\""
        ],
        comoAplicarlo: "Short-Squeeze-Setups identifizieren: (1) Suche nach Funding Rate < -0,01% über >3 Tage. (2) Überprüfe, dass das Open Interest hoch ist (viel Kapital in Shorts). (3) Identifiziere eine starke technische Unterstützung beim aktuellen Preis. (4) Warte auf einen Katalysator (Nachrichten, Makrodaten) oder einfach einen Widerstandsausbruch. (5) Einstieg mit Stop Loss unter der Unterstützung. Ziel: die Zonen, wo sich die Stops der Shorts konzentrieren (meist vorherige Hochs).",
        conclusionFinal: "Der Short Squeeze von Oktober-November 2023 war das definitive Signal für das Ende des Bärenmarkts und den Beginn der Bull Run 2024. Diejenigen, die das Setup verstanden (negative Funding + übermäßige Shorts + wichtige Unterstützung), hatten die Gelegenheit, sich VOR der Bewegung zu positionieren. Die Information war verfügbar — man musste nur wissen, wo man hinschauen sollte.",
        datosCarouselLabels: {
          rally: "Generierte Rally",
          liquidaciones: "Liquidierte Shorts",
          tiempo_rally: "Dauer der Rally",
          funding: "Vorherige Funding Rate",
          desde: "Von",
          hasta: "Bis"
        }
      },
      "zh-CN": {
        categoria: "SHORT SQUEEZE",
        titulo: "Short Squeeze 解剖：2023年11月突破",
        subtitulo: "12亿美元空头清算如何推动本周期最爆炸性的反弹",
        descripcion: "12亿美元空头清算如何推动2023年10月从26K到44K美元的反弹。",
        duracionLectura: "14 分钟",
        nivel: "中级",
        resumen: "在2023年9月至10月期间，BTC在25,000-27,000美元区间盘整了数月。空头头寸大量积累——交易者押注价格将继续下跌。然后BlackRock ETF的传闻出现了。接下来发生的是历史上最爆炸性的反弹之一：7周内从26,000美元涨到44,000美元，由12亿美元的空头清算推动。",
        contexto: "2023年第三季度市场处于熊市：Bitcoin盘整了数月，Fed利率处于22年高位，市场情绪是投降。衍生品交易者积累了大量空头头寸，押注价格将继续下跌。Funding rate（维持空头的成本）为负——这是空头头寸过度的信号。这种情况是short squeeze的完美设置。",
        timeline: [
          {
            fecha: "Sep 2023",
            titulo: "BTC在26K盘整。空头积累。",
            descripcion: "Funding rate为负：-0.02%每8小时（看跌记录）。期货持仓量处于高位。市场大量押注看跌方向。",
            tipo: "neutro"
          },
          {
            fecha: "16 Oct 2023",
            titulo: "BlackRock ETF虚假传闻",
            descripcion: "媒体（错误地）报道SEC批准了BlackRock ETF。BTC在几分钟内从27,000美元涨到30,000美元。空头大量清算。传闻被否认但价格没有回落。",
            tipo: "alcista"
          },
          {
            fecha: "Oct 2023",
            titulo: "趋势改变——看涨BOS",
            descripcion: "尽管传闻是假的，市场没有回落。空头继续被清算。价格建立更高的高点和低点。结构改变。",
            tipo: "alcista"
          },
          {
            fecha: "Nov 2023",
            titulo: "爆炸性反弹：30K → 44K",
            descripcion: "随着确认BlackRock确实申请了ETF，反弹加速。几周内12亿美元空头被清算。清算的反馈循环推动反弹。",
            tipo: "alcista"
          },
          {
            fecha: "Dic 2023",
            titulo: "BTC在40-44K盘整",
            descripcion: "反弹暂停但没有下跌。40K水平成为支撑位。看涨结构已经建立。牛市正式开始。",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "Short squeeze的设置在事件发生之前是完全可识别的：(1) Funding rate非常负（市场空头过度）。(2) 期货持仓量处于高位（大量头寸开仓）。(3) BTC在关键支撑区（26-27K，2019年高点）。(4) 价格在狭窄区间压缩数周（能量积累）。当催化剂（ETF传闻）出现时，结果是爆炸性的。",
        senalesOnchain: null,
        leccionesAprendidas: [
          "非常负的funding rate + 价格在支撑位 = short squeeze设置。考虑紧止损的多头头寸。",
          "Short squeeze是自我实现的：空头清算产生需求，迫使更多清算",
          "\"买传闻\"即使传闻是假的也有效——重要的是机构重新定位",
          "期货持仓量是风险指标：极端水平（高或低）预示剧烈波动",
          "Short squeeze之后，新水平成为支撑位：市场记住\"吸收了多少压力\""
        ],
        comoAplicarlo: "识别short squeeze设置：(1) 寻找funding rate < -0.01%持续>3天。(2) 验证持仓量高（空头资金量大）。(3) 识别当前价格的强技术支撑位。(4) 等待催化剂（新闻、宏观数据）或简单的阻力位突破。(5) 在支撑位下方设置止损入场。目标：空头止损集中的区域（通常是之前的高点）。",
        conclusionFinal: "2023年10月至11月的short squeeze是熊市结束和2024年牛市开始的明确信号。理解设置（负funding + 空头过度 + 关键支撑位）的人有机会在波动之前定位。信息是可获得的——关键是知道在哪里看。",
        datosCarouselLabels: {
          rally: "产生的反弹",
          liquidaciones: "空头清算",
          tiempo_rally: "反弹时间",
          funding: "之前的Funding rate",
          desde: "从",
          hasta: "到"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 7 · Altseason
  // ───────────────────────────────────────────────────────────
  {
    slug: "altseason-rotacion-capital",
    colorCategoria: "#f5a623",
    nivel: "intermedio",
    datosCarousel: [
      { key: "ret_btc", valor: "+10x", color: "#f5a623" },
      { key: "ret_eth", valor: "+30x", color: "#00d4ff" },
      { key: "ret_large", valor: "+100x", color: "#00e676" },
      { key: "ret_small", valor: "+1000x", color: "#9b59ff" },
      { key: "peor_small", valor: "-99%", color: "#ff3355" },
      { key: "btcd_alt", valor: "<45%", color: "#f5a623" },
    ],
    i18n: {
      es: {
        categoria: "ROTACIÓN",
        titulo: "Altseason: Mecánica de Rotación de Capital",
        subtitulo: "Cómo leer el ciclo de dominancia de BTC para posicionarte antes de la altseason",
        descripcion: "Patrones institucionales de rotación de capital de BTC → ETH → large caps → mid caps → small caps.",
        duracionLectura: "17 min",
        nivel: "Intermedio",
        resumen: "La altseason no es aleatoria. Sigue un patrón de rotación de capital predecible: primero Bitcoin sube, luego Ethereum, luego large caps, luego mid caps, finalmente small caps y shitcoins. Entender CUÁNDO estás en cada fase es la diferencia entre multiplicar x5 o x50.",
        contexto: "La Dominancia de Bitcoin (BTC.D) es el porcentaje del mercado cripto total que representa Bitcoin. Cuando la dominancia sube, el capital fluye hacia BTC. Cuando baja, rota hacia altcoins. Históricamente, los grandes bull markets han seguido siempre la misma secuencia de rotación: primero BTC lidera, luego ETH, luego el resto.",
        timeline: [
          { fecha: "Q4 2020", titulo: "Fase 1: BTC lidera (BTC.D sube a 70%)", descripcion: "Bitcoin sube de 10K a 40K. Dominancia en máximos. Las altcoins se mueven poco. El capital entra al cripto vía Bitcoin primero.", tipo: "alcista" },
          { fecha: "Ene 2021", titulo: "Fase 2: ETH despierta (BTC.D baja a 60%)", descripcion: "Ethereum empieza a superar el rendimiento de BTC. ETH pasa de 700$ a 4.400$. La dominancia de BTC empieza a caer. Primera señal de altseason.", tipo: "alcista" },
          { fecha: "Feb–Mar 2021", titulo: "Fase 3: Large caps explotan", descripcion: "BNB, SOL, ADA, MATIC multiplican x5-x10. BTC.D cae al 55%. Los traders ven los retornos y migran capital hacia altcoins.", tipo: "alcista" },
          { fecha: "Abr–May 2021", titulo: "Fase 4: Mid y small caps — la locura", descripcion: "Altcoins desconocidas multiplican x20-x100. DOGE, SHIB, SafeMoon… BTC.D cae al 40%. Este es el pico de la altseason.", tipo: "critico" },
          { fecha: "May 2021", titulo: "El crash llega primero a las altcoins", descripcion: "Las small caps caen 80-95% antes que BTC. La rotación se invierte: capital huye de altcoins → ETH → BTC → fiat. BTC.D sube de nuevo.", tipo: "bajista" },
        ],
        analisisTecnico: "Señales de inicio de altseason: (1) BTC.D cayendo consistentemente por debajo de su media móvil de 20 semanas. (2) ETH/BTC par alcista: ETH superando en % a BTC. (3) Total3 (capitalización cripto sin BTC y ETH) empezando a subir más rápido que BTC. (4) El volumen en altcoins supera el 60% del volumen total del mercado.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "La rotación de capital siempre sigue el mismo orden: BTC → ETH → large caps → mid caps → small caps",
          "La señal más fiable de altseason: ETH/BTC rompiendo al alza en gráfico semanal",
          "Las small caps son las últimas en subir y las primeras en colapsar — el riesgo es proporcional al potencial",
          "Cuando tu taxista habla de una altcoin específica, la altseason está terminando",
          "La BTC.D por debajo del 45% históricamente precede las últimas fases de la altseason (y el crash posterior)",
        ],
        comoAplicarlo: "Framework de rotación: (1) Cuando BTC sube >50% desde su último mínimo → empieza a mirar ETH. (2) Cuando ETH/BTC rompe máximos → empieza a mirar large caps (SOL, ADA, AVAX, etc.). (3) Cuando las large caps han x2-x3 → considera mid caps con fundamentales sólidos. (4) Sal de small caps cuando BTC.D cae por debajo del 42%. (5) Siempre mantén un 30-40% en BTC/ETH como base.",
        conclusionFinal: "La altseason es predecible en su estructura pero impredecible en su timing exacto. Los mejores retornos se obtienen siendo paciente: comprar las bases antes de la rotación, no las small caps cuando ya están en x10. El 90% del retail compra small caps al final de la altseason y las aguanta todo el bear market. El 10% que entiende la rotación ya ha salido.",
        datosCarouselLabels: {
          ret_btc: "Retorno BTC medio ciclo",
          ret_eth: "Retorno ETH medio ciclo",
          ret_large: "Large caps mejor ciclo",
          ret_small: "Small caps mejor ciclo",
          peor_small: "Small caps peor resultado",
          btcd_alt: "BTC.D en altseason",
        },
      },
      en: {
        "categoria": "ROTATION",
        "titulo": "Altseason: Capital Rotation Mechanics",
        "subtitulo": "How to read the BTC dominance cycle to position yourself before altseason",
        "descripcion": "Institutional patterns of capital rotation from BTC → ETH → large caps → mid caps → small caps.",
        "duracionLectura": "17 min",
        "nivel": "Intermediate",
        "resumen": "Altseason is not random. It follows a predictable capital rotation pattern: first Bitcoin rises, then Ethereum, then large caps, then mid caps, finally small caps and shitcoins. Understanding WHEN you are in each phase is the difference between multiplying x5 or x50.",
        "contexto": "Bitcoin Dominance (BTC.D) is the percentage of the total crypto market that Bitcoin represents. When dominance rises, capital flows towards BTC. When it falls, it rotates towards altcoins. Historically, major bull markets have always followed the same rotation sequence: first BTC leads, then ETH, then the rest.",
        "timeline": [
                {
                        "fecha": "Q4 2020",
                        "titulo": "Phase 1: BTC leads (BTC.D rises to 70%)",
                        "descripcion": "Bitcoin rises from 10K to 40K. Dominance at highs. Altcoins move little. Capital enters crypto via Bitcoin first.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Jan 2021",
                        "titulo": "Phase 2: ETH awakens (BTC.D falls to 60%)",
                        "descripcion": "Ethereum starts to outperform BTC. ETH goes from $700 to $4,400. BTC dominance starts to fall. First signal of altseason.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Feb–Mar 2021",
                        "titulo": "Phase 3: Large caps explode",
                        "descripcion": "BNB, SOL, ADA, MATIC multiply x5-x10. BTC.D falls to 55%. Traders see the returns and migrate capital towards altcoins.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Apr–May 2021",
                        "titulo": "Phase 4: Mid and small caps — the madness",
                        "descripcion": "Unknown altcoins multiply x20-x100. DOGE, SHIB, SafeMoon… BTC.D falls to 40%. This is the peak of altseason.",
                        "tipo": "critico"
                },
                {
                        "fecha": "May 2021",
                        "titulo": "The crash hits altcoins first",
                        "descripcion": "Small caps fall 80-95% before BTC. Rotation reverses: capital flees from altcoins → ETH → BTC → fiat. BTC.D rises again.",
                        "tipo": "bajista"
                }
        ],
        "analisisTecnico": "Altseason start signals: (1) BTC.D consistently falling below its 20-week moving average. (2) ETH/BTC bullish pair: ETH outperforming BTC in %. (3) Total3 (crypto market cap without BTC and ETH) starting to rise faster than BTC. (4) Volume in altcoins exceeds 60% of total market volume.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "Capital rotation always follows the same order: BTC → ETH → large caps → mid caps → small caps",
                "The most reliable altseason signal: ETH/BTC breaking upward on the weekly chart",
                "Small caps are the last to rise and the first to collapse — risk is proportional to potential",
                "When your taxi driver talks about a specific altcoin, altseason is ending",
                "BTC.D below 45% historically precedes the final phases of altseason (and the subsequent crash)"
        ],
        "comoAplicarlo": "Rotation framework: (1) When BTC rises >50% from its last low → start watching ETH. (2) When ETH/BTC breaks highs → start watching large caps (SOL, ADA, AVAX, etc.). (3) When large caps have x2-x3 → consider mid caps with solid fundamentals. (4) Exit small caps when BTC.D falls below 42%. (5) Always maintain 30-40% in BTC/ETH as a base.",
        "conclusionFinal": "Altseason is predictable in its structure but unpredictable in its exact timing. The best returns are obtained by being patient: buying the bases before rotation, not small caps when they are already at x10. 90% of retail buys small caps at the end of altseason and holds them through the entire bear market. The 10% who understand rotation have already exited.",
        "datosCarouselLabels": {
                "ret_btc": "Average BTC return per cycle",
                "ret_eth": "Average ETH return per cycle",
                "ret_large": "Large caps best cycle",
                "ret_small": "Small caps best cycle",
                "peor_small": "Small caps worst result",
                "btcd_alt": "BTC.D in altseason"
        }
},
      sk: {
        "categoria": "ROTÁCIA",
        "titulo": "Altseason: Mechanika Rotácie Kapitálu",
        "subtitulo": "Ako čítať cyklus dominancie BTC, aby si sa pozicionoval pred altseason",
        "descripcion": "Inštitucionálne vzory rotácie kapitálu z BTC → ETH → large caps → mid caps → small caps.",
        "duracionLectura": "17 min",
        "nivel": "Stredne pokročilý",
        "resumen": "Altseason nie je náhodný. Nasleduje predvídateľný vzor rotácie kapitálu: najprv stúpa Bitcoin, potom Ethereum, potom large caps, potom mid caps, nakoniec small caps a shitcoiny. Pochopiť, KDE sa v každej fáze nachádzaš, je rozdiel medzi zmnožením x5 alebo x50.",
        "contexto": "Dominancia Bitcoinu (BTC.D) je percentuálny podiel celkového kryptotrhu, ktorý predstavuje Bitcoin. Keď dominancia stúpa, kapitál prúdi do BTC. Keď klesá, rotuje do altcoinov. Historicky veľké bull markety vždy nasledovali rovnakú sekvenciu rotácie: najprv vedie BTC, potom ETH, potom zvyšok.",
        "timeline": [
                {
                        "fecha": "Q4 2020",
                        "titulo": "Fáza 1: BTC vedie (BTC.D stúpa na 70%)",
                        "descripcion": "Bitcoin stúpa z 10K na 40K. Dominancia na maximách. Altcoiny sa pohybujú málo. Kapitál vstupuje do krypta cez Bitcoin ako prvý.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Jan 2021",
                        "titulo": "Fáza 2: ETH sa prebúdza (BTC.D klesá na 60%)",
                        "descripcion": "Ethereum začína prekonávať výkonnosť BTC. ETH prechádza z 700$ na 4 400$. Dominancia BTC začína klesať. Prvý signál altseason.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Feb–Mar 2021",
                        "titulo": "Fáza 3: Large caps explodujú",
                        "descripcion": "BNB, SOL, ADA, MATIC sa násobí x5-x10. BTC.D klesá na 55%. Traderi vidia výnosy a migrujú kapitál do altcoinov.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Apr–Máj 2021",
                        "titulo": "Fáza 4: Mid a small caps — šialenstvo",
                        "descripcion": "Neznáme altcoiny sa násobí x20-x100. DOGE, SHIB, SafeMoon… BTC.D klesá na 40%. Toto je vrchol altseason.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Máj 2021",
                        "titulo": "Crash prichádza najprv k altcoinom",
                        "descripcion": "Small caps padajú o 80-95% skôr ako BTC. Rotácia sa otáča: kapitál uteká z altcoinov → ETH → BTC → fiat. BTC.D opäť stúpa.",
                        "tipo": "bajista"
                }
        ],
        "analisisTecnico": "Signály začiatku altseason: (1) BTC.D konzistentne klesá pod svoj 20-týždňový kĺzavý priemer. (2) ETH/BTC pár je bullish: ETH prekonáva BTC v %. (3) Total3 (kapitalizácia krypto bez BTC a ETH) začína stúpať rýchlejšie ako BTC. (4) Objem v altcoinoch prekračuje 60% celkového objemu trhu.",
        "senalesOnchain": null,
        "leccionesAprendidas": [
                "Rotácia kapitálu vždy nasleduje rovnaké poradie: BTC → ETH → large caps → mid caps → small caps",
                "Najspoľahlivejší signál altseason: ETH/BTC prelomenie nahor na týždennom grafe",
                "Small caps sú posledné, čo stúpajú, a prvé, čo kolabujú — riziko je proporcionálne k potenciálu",
                "Keď tvoj taxikár hovorí o konkrétnom altcoine, altseason sa končí",
                "BTC.D pod 45% historicky predchádza posledným fázam altseason (a následnému crashu)"
        ],
        "comoAplicarlo": "Framework rotácie: (1) Keď BTC stúpne >50% od svojho posledného minima → začni sledovať ETH. (2) Keď ETH/BTC prelomí maximá → začni sledovať large caps (SOL, ADA, AVAX, atď.). (3) Keď large caps urobia x2-x3 → zvaž mid caps so solídnymi fundamentmi. (4) Vystúp zo small caps, keď BTC.D klesne pod 42%. (5) Vždy udržuj 30-40% v BTC/ETH ako základ.",
        "conclusionFinal": "Altseason je predvídateľný vo svojej štruktúre, ale nepredvídateľný v presnom časovaní. Najlepšie výnosy sa získavajú trpezlivosťou: nakupovať základy pred rotáciou, nie small caps, keď už sú na x10. 90% retailu kupuje small caps na konci altseason a drží ich celý bear market. 10%, ktoré rozumie rotácii, už vystúpilo.",
        "datosCarouselLabels": {
                "ret_btc": "Priemerný výnos BTC v cykle",
                "ret_eth": "Priemerný výnos ETH v cykle",
                "ret_large": "Large caps najlepší cyklus",
                "ret_small": "Small caps najlepší cyklus",
                "peor_small": "Small caps najhorší výsledok",
                "btcd_alt": "BTC.D v altseason"
        }
},
      de: {
        categoria: "ROTATION",
        titulo: "Altseason: Mechanik der Kapitalrotation",
        subtitulo: "Wie man den BTC-Dominanzzyklus liest, um sich vor der Altseason zu positionieren",
        descripcion: "Institutionelle Muster der Kapitalrotation von BTC → ETH → Large Caps → Mid Caps → Small Caps.",
        duracionLectura: "17 Min.",
        nivel: "Fortgeschritten",
        resumen: "Die Altseason ist nicht zufällig. Sie folgt einem vorhersehbaren Muster der Kapitalrotation: Zuerst steigt Bitcoin, dann Ethereum, dann Large Caps, dann Mid Caps, schließlich Small Caps und Shitcoins. Zu verstehen, WANN man sich in jeder Phase befindet, ist der Unterschied zwischen x5 oder x50 Multiplikation.",
        contexto: "Die Bitcoin-Dominanz (BTC.D) ist der Prozentsatz des gesamten Kryptomarktes, den Bitcoin repräsentiert. Wenn die Dominanz steigt, fließt Kapital in Richtung BTC. Wenn sie fällt, rotiert es in Richtung Altcoins. Historisch gesehen haben die großen Bull Markets immer derselben Rotationssequenz gefolgt: Zuerst führt BTC, dann ETH, dann der Rest.",
        timeline: [
          {
            fecha: "Q4 2020",
            titulo: "Phase 1: BTC führt (BTC.D steigt auf 70%)",
            descripcion: "Bitcoin steigt von 10K auf 40K. Dominanz auf Höchstständen. Die Altcoins bewegen sich wenig. Das Kapital tritt zuerst über Bitcoin in Krypto ein.",
            tipo: "alcista"
          },
          {
            fecha: "Ene 2021",
            titulo: "Phase 2: ETH erwacht (BTC.D fällt auf 60%)",
            descripcion: "Ethereum beginnt, die Performance von BTC zu übertreffen. ETH steigt von 700$ auf 4.400$. Die Dominanz von BTC beginnt zu fallen. Erstes Signal der Altseason.",
            tipo: "alcista"
          },
          {
            fecha: "Feb–Mar 2021",
            titulo: "Phase 3: Large Caps explodieren",
            descripcion: "BNB, SOL, ADA, MATIC multiplizieren x5-x10. BTC.D fällt auf 55%. Die Trader sehen die Renditen und migrieren Kapital in Richtung Altcoins.",
            tipo: "alcista"
          },
          {
            fecha: "Abr–May 2021",
            titulo: "Phase 4: Mid und Small Caps — der Wahnsinn",
            descripcion: "Unbekannte Altcoins multiplizieren x20-x100. DOGE, SHIB, SafeMoon… BTC.D fällt auf 40%. Dies ist der Höhepunkt der Altseason.",
            tipo: "critico"
          },
          {
            fecha: "May 2021",
            titulo: "Der Crash trifft zuerst die Altcoins",
            descripcion: "Die Small Caps fallen 80-95% vor BTC. Die Rotation kehrt sich um: Kapital flieht von Altcoins → ETH → BTC → Fiat. BTC.D steigt wieder.",
            tipo: "bajista"
          }
        ],
        analisisTecnico: "Signale für den Beginn der Altseason: (1) BTC.D fällt konsistent unter seinen gleitenden 20-Wochen-Durchschnitt. (2) ETH/BTC Paar bullisch: ETH übertrifft BTC in %. (3) Total3 (Kryptomarktkapitalisierung ohne BTC und ETH) beginnt schneller zu steigen als BTC. (4) Das Volumen bei Altcoins übersteigt 60% des gesamten Marktvolumens.",
        senalesOnchain: null,
        leccionesAprendidas: [
          "Die Kapitalrotation folgt immer derselben Reihenfolge: BTC → ETH → Large Caps → Mid Caps → Small Caps",
          "Das zuverlässigste Signal der Altseason: ETH/BTC bricht im Wochenchart nach oben aus",
          "Die Small Caps steigen als letzte und kollabieren als erste — das Risiko ist proportional zum Potenzial",
          "Wenn dein Taxifahrer über eine spezifische Altcoin spricht, endet die Altseason",
          "Die BTC.D unter 45% geht historisch den letzten Phasen der Altseason (und dem nachfolgenden Crash) voraus"
        ],
        comoAplicarlo: "Rotations-Framework: (1) Wenn BTC >50% von seinem letzten Tief steigt → beginne ETH zu beobachten. (2) Wenn ETH/BTC Höchststände durchbricht → beginne Large Caps zu beobachten (SOL, ADA, AVAX, etc.). (3) Wenn die Large Caps x2-x3 gemacht haben → erwäge Mid Caps mit soliden Fundamentaldaten. (4) Steige aus Small Caps aus, wenn BTC.D unter 42% fällt. (5) Halte immer 30-40% in BTC/ETH als Basis.",
        conclusionFinal: "Die Altseason ist in ihrer Struktur vorhersehbar, aber in ihrem exakten Timing unvorhersehbar. Die besten Renditen erzielt man durch Geduld: Kaufe die Basen vor der Rotation, nicht die Small Caps, wenn sie bereits bei x10 sind. 90% der Retail-Anleger kaufen Small Caps am Ende der Altseason und halten sie durch den gesamten Bärenmarkt. Die 10%, die die Rotation verstehen, sind bereits ausgestiegen.",
        datosCarouselLabels: {
          ret_btc: "Durchschnittliche BTC-Rendite pro Zyklus",
          ret_eth: "Durchschnittliche ETH-Rendite pro Zyklus",
          ret_large: "Large Caps bester Zyklus",
          ret_small: "Small Caps bester Zyklus",
          peor_small: "Small Caps schlechtestes Ergebnis",
          btcd_alt: "BTC.D in der Altseason"
        }
      },
      "zh-CN": {
        categoria: "ROTACIÓN",
        titulo: "山寨季：资本轮动机制",
        subtitulo: "如何解读BTC主导地位周期，在山寨季到来前提前布局",
        descripcion: "机构级资本轮动模式：BTC → ETH → 大盘币 → 中盘币 → 小盘币。",
        duracionLectura: "17 min",
        nivel: "中级",
        resumen: "山寨季并非随机发生。它遵循可预测的资本轮动模式：首先Bitcoin上涨，然后Ethereum，接着大盘币，然后中盘币，最后是小盘币和垃圾币。理解你处于哪个阶段，决定了你是获得5倍还是50倍收益。",
        contexto: "Bitcoin主导地位（BTC.D）是Bitcoin在整个加密市场总市值中所占的百分比。当主导地位上升时，资本流向BTC。当主导地位下降时，资本轮动至山寨币。历史上，所有大型牛市都遵循相同的轮动顺序：首先BTC领涨，然后ETH，最后是其他币种。",
        timeline: [
          {
            fecha: "Q4 2020",
            titulo: "第一阶段：BTC领涨（BTC.D升至70%）",
            descripcion: "Bitcoin从10K涨至40K。主导地位处于高位。山寨币几乎不动。资本首先通过Bitcoin进入加密市场。",
            tipo: "alcista"
          },
          {
            fecha: "Ene 2021",
            titulo: "第二阶段：ETH觉醒（BTC.D降至60%）",
            descripcion: "Ethereum开始跑赢BTC。ETH从700美元涨至4,400美元。BTC主导地位开始下降。山寨季的第一个信号。",
            tipo: "alcista"
          },
          {
            fecha: "Feb–Mar 2021",
            titulo: "第三阶段：大盘币爆发",
            descripcion: "BNB、SOL、ADA、MATIC涨幅达5-10倍。BTC.D降至55%。交易者看到收益后将资本转向山寨币。",
            tipo: "alcista"
          },
          {
            fecha: "Abr–May 2021",
            titulo: "第四阶段：中小盘币——疯狂时刻",
            descripcion: "不知名的山寨币涨幅达20-100倍。DOGE、SHIB、SafeMoon……BTC.D降至40%。这是山寨季的顶峰。",
            tipo: "critico"
          },
          {
            fecha: "May 2021",
            titulo: "崩盘首先冲击山寨币",
            descripcion: "小盘币在BTC之前下跌80-95%。轮动逆转：资本从山寨币逃向ETH → BTC → 法币。BTC.D再次上升。",
            tipo: "bajista"
          }
        ],
        analisisTecnico: "山寨季启动信号：(1) BTC.D持续跌破20周移动平均线。(2) ETH/BTC交易对看涨：ETH涨幅超过BTC。(3) Total3（除BTC和ETH外的加密市值）开始比BTC涨得更快。(4) 山寨币交易量超过市场总交易量的60%。",
        senalesOnchain: null,
        leccionesAprendidas: [
          "资本轮动始终遵循相同顺序：BTC → ETH → 大盘币 → 中盘币 → 小盘币",
          "山寨季最可靠的信号：ETH/BTC在周线图上向上突破",
          "小盘币最后上涨，最先崩盘——风险与潜力成正比",
          "当你的出租车司机谈论某个具体山寨币时，山寨季即将结束",
          "BTC.D低于45%在历史上预示着山寨季的最后阶段（以及随后的崩盘）"
        ],
        comoAplicarlo: "轮动框架：(1) 当BTC从最近低点上涨>50%时 → 开始关注ETH。(2) 当ETH/BTC突破新高时 → 开始关注大盘币（SOL、ADA、AVAX等）。(3) 当大盘币涨幅达2-3倍时 → 考虑基本面扎实的中盘币。(4) 当BTC.D跌破42%时退出小盘币。(5) 始终保持30-40%的BTC/ETH作为基础仓位。",
        conclusionFinal: "山寨季的结构可预测，但时机难以精确把握。最佳收益来自耐心：在轮动前买入底部，而非在小盘币已涨10倍时追高。90%的散户在山寨季末期买入小盘币，然后持有整个熊市。理解轮动的10%早已离场。",
        datosCarouselLabels: {
          ret_btc: "BTC周期平均回报",
          ret_eth: "ETH周期平均回报",
          ret_large: "大盘币最佳周期",
          ret_small: "小盘币最佳周期",
          peor_small: "小盘币最差表现",
          btcd_alt: "山寨季BTC.D"
        }
      },
    },
  },

  // ───────────────────────────────────────────────────────────
  // CASO 8 · BlackRock ETF
  // ───────────────────────────────────────────────────────────
  {
    slug: "blackrock-etf-adopcion-institucional",
    colorCategoria: "#00d4ff",
    nivel: "avanzado",
    datosCarousel: [
      { key: "etfs", valor: "11 simultáneos", color: "#00d4ff" },
      { key: "flujo_30d", valor: ">10.000M$", color: "#00e676" },
      { key: "ibit", valor: "ETF más rápido >10B$", color: "#f5a623" },
      { key: "ath", valor: "73.000$", color: "#00e676" },
      { key: "btc_exch", valor: "Mínimo 5 años", color: "#00d4ff" },
      { key: "blackrock_aum", valor: "10 billones USD", color: "#f5a623" },
    ],
    i18n: {
      es: {
        categoria: "INSTITUCIONAL",
        titulo: "BlackRock ETF: El Punto de Inflexión de la Adopción Institucional",
        subtitulo: "Cómo la aprobación del ETF Spot cambió la estructura del mercado Bitcoin para siempre",
        descripcion: "Analizando la respuesta de la estructura de mercado a la aprobación de ETFs Spot y la demanda institucional.",
        duracionLectura: "19 min",
        nivel: "Avanzado",
        resumen: "El 10 de enero de 2024, la SEC aprobó los primeros ETFs Spot de Bitcoin de la historia. BlackRock, Fidelity, ARK 21Shares… 11 ETFs aprobados simultáneamente. Lo que siguió fue el mayor flujo de capital institucional en la historia de Bitcoin. En solo 2 meses, los ETFs acumularon más BTC del que se mina en un año entero.",
        contexto: "Durante años, Bitcoin fue rechazado por las instituciones financieras tradicionales. La SEC había denegado más de 30 solicitudes de ETF Spot desde 2013. La narrativa era \"demasiado volátil, demasiado especulativo, sin regulación suficiente\". Todo cambió cuando BlackRock — el mayor gestor de activos del mundo con 10 billones de dólares bajo gestión — solicitó un ETF Bitcoin en junio de 2023. Si BlackRock lo quería, la SEC lo iba a aprobar.",
        timeline: [
          { fecha: "15 Jun 2023", titulo: "BlackRock solicita ETF Bitcoin Spot", descripcion: "La solicitud de BlackRock cambia todo. Si el mayor gestor de activos del mundo quiere un ETF Bitcoin, la aprobación es cuestión de tiempo. BTC sube un 20% en días.", tipo: "alcista" },
          { fecha: "Oct 2023", titulo: "Rumor de aprobación — short squeeze", descripcion: "Medios publican erróneamente la aprobación. El short squeeze de 26K a 44K (ver Caso 6). La anticipación institucional ya estaba reposicionando el mercado.", tipo: "alcista" },
          { fecha: "10 Ene 2024", titulo: "SEC aprueba 11 ETFs Spot simultáneamente", descripcion: "Historia hecha. La SEC aprueba los ETFs de BlackRock (IBIT), Fidelity (FBTC), ARK 21Shares (ARKB) y 8 más. Bitcoin en 46.000$.", tipo: "critico" },
          { fecha: "Ene–Feb 2024", titulo: "Flujo masivo de capital institucional", descripcion: "Los ETFs atraen más de 10.000M$ en los primeros 30 días. IBIT de BlackRock se convierte en el ETF de mayor crecimiento de la historia. El ritmo: los ETFs compran más BTC del que se mina en un año.", tipo: "alcista" },
          { fecha: "Mar 2024", titulo: "BTC alcanza nuevo ATH: 73.000$", descripcion: "Nuevo máximo histórico impulsado por la demanda de ETF. Por primera vez en la historia, BTC hace ATH ANTES del halving. La estructura del mercado ha cambiado.", tipo: "alcista" },
        ],
        analisisTecnico: "La aprobación del ETF cambió fundamentalmente la estructura del mercado: (1) El BTC \"disponible para vender\" en exchanges se redujo a mínimos históricos — los ETFs retiran BTC del mercado. (2) La correlación de BTC con activos de riesgo (NASDAQ) aumentó — ahora hay inversores institucionales con mandatos de gestión de riesgo. (3) La volatilidad a largo plazo se ha reducido — más capital, más profundidad de mercado.",
        senalesOnchain: "Exchange Balances en mínimos de 5 años: el BTC se va a wallets de custodia de los ETFs. Coinbase Institutional (custodia de IBIT) retira cantidades récord. El Long-term Holder Supply en máximos: manos fuertes no venden.",
        leccionesAprendidas: [
          "La adopción institucional cambia la estructura del mercado de forma permanente — no es solo una narrativa",
          "Los ETFs crean demanda estructural continua: cada día llegan nuevas compras de inversores institucionales",
          "La reducción del BTC en exchanges es la señal on-chain más poderosa de escasez de oferta",
          "El mercado anticipa los eventos regulatorios meses antes — la oportunidad estaba en junio 2023, no en enero 2024",
          "Con inversores institucionales, las correlaciones con mercados tradicionales aumentan — gestiona el riesgo macro también",
        ],
        comoAplicarlo: "En el nuevo ciclo post-ETF: (1) Monitorea los flujos de ETF diarios (disponibles en Farside Investors, Bloomberg). Flujos positivos sostenidos = alcista. (2) El Exchange Balance bajo = escasez de oferta = alcista. (3) Las correcciones institucionales son más profundas pero más cortas: las instituciones tienen stops y gestión de riesgo. (4) Los catalizadores macro (Fed, inflación, mercados tradicionales) afectan más que antes al precio de BTC.",
        conclusionFinal: "La aprobación del ETF de Bitcoin Spot es el mayor evento de adopción de la historia de Bitcoin. Superó la expectativa del mercado: en 2 meses, los ETFs acumularon más BTC que toda la minería de un año. Este es el punto de no retorno de la institucionalización de Bitcoin. El mercado que viene es diferente al que existía. Los que entiendan la nueva mecánica tendrán ventaja.",
        datosCarouselLabels: {
          etfs: "ETFs aprobados",
          flujo_30d: "Flujo primeros 30 días",
          ibit: "IBIT récord",
          ath: "ATH alcanzado",
          btc_exch: "BTC en exchanges",
          blackrock_aum: "Gestión BlackRock",
        },
      },
      en: {
        "categoria": "INSTITUTIONAL",
        "titulo": "BlackRock ETF: The Inflection Point of Institutional Adoption",
        "subtitulo": "How the Spot ETF approval changed Bitcoin's market structure forever",
        "descripcion": "Analyzing the market structure response to Spot ETF approval and institutional demand.",
        "duracionLectura": "19 min",
        "nivel": "Advanced",
        "resumen": "On January 10, 2024, the SEC approved the first Spot Bitcoin ETFs in history. BlackRock, Fidelity, ARK 21Shares… 11 ETFs approved simultaneously. What followed was the largest institutional capital inflow in Bitcoin's history. In just 2 months, the ETFs accumulated more BTC than is mined in an entire year.",
        "contexto": "For years, Bitcoin was rejected by traditional financial institutions. The SEC had denied more than 30 Spot ETF applications since 2013. The narrative was \"too volatile, too speculative, insufficient regulation.\" Everything changed when BlackRock — the world's largest asset manager with $10 trillion under management — filed for a Bitcoin ETF in June 2023. If BlackRock wanted it, the SEC was going to approve it.",
        "timeline": [
                {
                        "fecha": "15 Jun 2023",
                        "titulo": "BlackRock files for Bitcoin Spot ETF",
                        "descripcion": "BlackRock's application changes everything. If the world's largest asset manager wants a Bitcoin ETF, approval is a matter of time. BTC rises 20% in days.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Oct 2023",
                        "titulo": "Approval rumor — short squeeze",
                        "descripcion": "Media erroneously publish the approval. The short squeeze from 26K to 44K (see Case 6). Institutional anticipation was already repositioning the market.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "10 Jan 2024",
                        "titulo": "SEC approves 11 Spot ETFs simultaneously",
                        "descripcion": "History made. The SEC approves ETFs from BlackRock (IBIT), Fidelity (FBTC), ARK 21Shares (ARKB) and 8 more. Bitcoin at $46,000.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Jan–Feb 2024",
                        "titulo": "Massive institutional capital inflow",
                        "descripcion": "ETFs attract over $10B in the first 30 days. BlackRock's IBIT becomes the fastest-growing ETF in history. The pace: ETFs buy more BTC than is mined in a year.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Mar 2024",
                        "titulo": "BTC reaches new ATH: $73,000",
                        "descripcion": "New all-time high driven by ETF demand. For the first time in history, BTC makes ATH BEFORE halving. Market structure has changed.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "ETF approval fundamentally changed market structure: (1) \"Available to sell\" BTC on exchanges dropped to historic lows — ETFs withdraw BTC from the market. (2) BTC correlation with risk assets (NASDAQ) increased — there are now institutional investors with risk management mandates. (3) Long-term volatility has decreased — more capital, more market depth.",
        "senalesOnchain": "Exchange Balances at 5-year lows: BTC moves to ETF custody wallets. Coinbase Institutional (IBIT custody) withdraws record amounts. Long-term Holder Supply at highs: strong hands not selling.",
        "leccionesAprendidas": [
                "Institutional adoption changes market structure permanently — it's not just a narrative",
                "ETFs create continuous structural demand: every day new purchases arrive from institutional investors",
                "Reduction of BTC on exchanges is the most powerful on-chain signal of supply scarcity",
                "The market anticipates regulatory events months in advance — the opportunity was in June 2023, not January 2024",
                "With institutional investors, correlations with traditional markets increase — manage macro risk as well"
        ],
        "comoAplicarlo": "In the new post-ETF cycle: (1) Monitor daily ETF flows (available at Farside Investors, Bloomberg). Sustained positive flows = bullish. (2) Low Exchange Balance = supply scarcity = bullish. (3) Institutional corrections are deeper but shorter: institutions have stops and risk management. (4) Macro catalysts (Fed, inflation, traditional markets) affect BTC price more than before.",
        "conclusionFinal": "The approval of the Bitcoin Spot ETF is the biggest adoption event in Bitcoin's history. It exceeded market expectations: in 2 months, ETFs accumulated more BTC than all mining in a year. This is the point of no return for Bitcoin's institutionalization. The coming market is different from what existed before. Those who understand the new mechanics will have an advantage.",
        "datosCarouselLabels": {
                "etfs": "ETFs approved",
                "flujo_30d": "First 30-day inflow",
                "ibit": "IBIT record",
                "ath": "ATH reached",
                "btc_exch": "BTC on exchanges",
                "blackrock_aum": "BlackRock AUM"
        }
},
      sk: {
        "categoria": "INŠTITUCIONÁLNE",
        "titulo": "BlackRock ETF: Bod zlomu inštitucionálneho prijatia",
        "subtitulo": "Ako schválenie Spot ETF navždy zmenilo štruktúru trhu s Bitcoinom",
        "descripcion": "Analýza reakcie trhovej štruktúry na schválenie Spot ETF a inštitucionálny dopyt.",
        "duracionLectura": "19 min",
        "nivel": "Pokročilý",
        "resumen": "10. januára 2024 SEC schválila prvé Spot Bitcoin ETF v histórii. BlackRock, Fidelity, ARK 21Shares… 11 ETF schválených súčasne. Nasledoval najväčší príliv inštitucionálneho kapitálu v histórii Bitcoinu. Za 2 mesiace ETF nakúpili více BTC, než sa vyťaží za celý rok.",
        "contexto": "Roky bol Bitcoin odmietaný tradičnými finančnými inštitúciami. SEC zamietla viac ako 30 žiadostí o Spot ETF od roku 2013. Naratív bol \"príliš volatilný, príliš špekulatívny, nedostatočne regulovaný\". Všetko sa zmenilo, keď BlackRock — najväčší správca aktív na svete so 10 biliónmi dolárov v správe — požiadal o Bitcoin ETF v júni 2023. Ak to chcel BlackRock, SEC to schváli.",
        "timeline": [
                {
                        "fecha": "15 Jún 2023",
                        "titulo": "BlackRock žiada o Spot Bitcoin ETF",
                        "descripcion": "Žiadosť BlackRock mení všetko. Ak najväčší správca aktív na svete chce Bitcoin ETF, schválenie je otázkou času. BTC stúpa o 20% za dni.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Okt 2023",
                        "titulo": "Fáma o schválení — short squeeze",
                        "descripcion": "Médiá omylom publikujú schválenie. Short squeeze z 26K na 44K (pozri Prípad 6). Inštitucionálne očakávanie už prepozicionovalo trh.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "10 Jan 2024",
                        "titulo": "SEC schvaľuje 11 Spot ETF súčasne",
                        "descripcion": "História sa píše. SEC schvaľuje ETF BlackRock (IBIT), Fidelity (FBTC), ARK 21Shares (ARKB) a ďalších 8. Bitcoin na 46.000$.",
                        "tipo": "critico"
                },
                {
                        "fecha": "Jan–Feb 2024",
                        "titulo": "Masívny príliv inštitucionálneho kapitálu",
                        "descripcion": "ETF priťahujú viac ako 10.000M$ za prvých 30 dní. IBIT od BlackRock sa stáva najrýchlejšie rastúcim ETF v histórii. Tempo: ETF kupujú viac BTC, než sa vyťaží za rok.",
                        "tipo": "alcista"
                },
                {
                        "fecha": "Mar 2024",
                        "titulo": "BTC dosahuje nové ATH: 73.000$",
                        "descripcion": "Nové historické maximum poháňané dopytom po ETF. Prvýkrát v histórii BTC robí ATH PRED halvingom. Štruktúra trhu sa zmenila.",
                        "tipo": "alcista"
                }
        ],
        "analisisTecnico": "Schválenie ETF zásadne zmenilo štruktúru trhu: (1) BTC \"dostupný na predaj\" na burzách klesol na historické minimá — ETF sťahujú BTC z trhu. (2) Korelácia BTC s rizikovými aktívami (NASDAQ) sa zvýšila — teraz tu sú inštitucionálni investori s mandátmi na riadenie rizika. (3) Dlhodobá volatilita sa znížila — viac kapitálu, väčšia hĺbka trhu.",
        "senalesOnchain": "Exchange Balances na 5-ročných minimách: BTC odchádza do custody peňaženiek ETF. Coinbase Institutional (custodia IBIT) sťahuje rekordné množstvá. Long-term Holder Supply na maximách: silné ruky nepredávajú.",
        "leccionesAprendidas": [
                "Inštitucionálne prijatie mení štruktúru trhu permanentne — nie je to len naratív",
                "ETF vytvárajú štruktúrny nepretržitý dopyt: každý deň prichádzajú nové nákupy od inštitucionálnych investorov",
                "Zníženie BTC na burzách je najsilnejší on-chain signál nedostatku ponuky",
                "Trh anticipuje regulačné udalosti mesiace dopredu — príležitosť bola v júni 2023, nie v januári 2024",
                "S inštitucionálnymi investormi sa zvyšujú korelácie s tradičnými trhmi — riadi aj makro riziko"
        ],
        "comoAplicarlo": "V novom post-ETF cykle: (1) Monitoruj denné toky ETF (dostupné na Farside Investors, Bloomberg). Udržateľné pozitívne toky = bullish. (2) Nízky Exchange Balance = nedostatok ponuky = bullish. (3) Inštitucionálne korekcie sú hlbšie, ale kratšie: inštitúcie majú stopy a riadenie rizika. (4) Makro katalyzátory (Fed, inflácia, tradičné trhy) ovplyvňujú cenu BTC viac ako predtým.",
        "conclusionFinal": "Schválenie Spot Bitcoin ETF je najväčšia udalosť prijatia v histórii Bitcoinu. Prekonalo očakávania trhu: za 2 mesiace ETF nakúpili viac BTC než celá ťažba za rok. Toto je bod návratu inštitucionalizácie Bitcoinu. Prichádzajúci trh je iný ako ten, ktorý existoval. Tí, čo pochopia novú mechaniku, budú mať výhodu.",
        "datosCarouselLabels": {
                "etfs": "Schválené ETF",
                "flujo_30d": "Tok prvých 30 dní",
                "ibit": "IBIT rekord",
                "ath": "Dosiahnuté ATH",
                "btc_exch": "BTC na burzách",
                "blackrock_aum": "BlackRock správa"
        }
},
      de: {
        categoria: "INSTITUCIONAL",
        titulo: "BlackRock ETF: Der Wendepunkt der institutionellen Adoption",
        subtitulo: "Wie die Genehmigung des Spot-ETF die Marktstruktur von Bitcoin für immer veränderte",
        descripcion: "Analyse der Marktstruktur-Reaktion auf die Genehmigung von Spot-ETFs und die institutionelle Nachfrage.",
        duracionLectura: "19 min",
        nivel: "Fortgeschritten",
        resumen: "Am 10. Januar 2024 genehmigte die SEC die ersten Bitcoin-Spot-ETFs der Geschichte. BlackRock, Fidelity, ARK 21Shares… 11 ETFs gleichzeitig genehmigt. Was folgte, war der größte institutionelle Kapitalzufluss in der Geschichte von Bitcoin. In nur 2 Monaten akkumulierten die ETFs mehr BTC, als in einem ganzen Jahr gemint wird.",
        contexto: "Jahrelang wurde Bitcoin von traditionellen Finanzinstitutionen abgelehnt. Die SEC hatte seit 2013 über 30 Spot-ETF-Anträge abgelehnt. Die Narrative war „zu volatil, zu spekulativ, unzureichend reguliert\". Alles änderte sich, als BlackRock — der weltweit größte Vermögensverwalter mit 10 Billionen Dollar unter Verwaltung — im Juni 2023 einen Bitcoin-ETF beantragte. Wenn BlackRock es wollte, würde die SEC es genehmigen.",
        timeline: [
          {
            fecha: "15 Jun 2023",
            titulo: "BlackRock beantragt Bitcoin-Spot-ETF",
            descripcion: "Der Antrag von BlackRock ändert alles. Wenn der weltweit größte Vermögensverwalter einen Bitcoin-ETF will, ist die Genehmigung nur eine Frage der Zeit. BTC steigt innerhalb von Tagen um 20%.",
            tipo: "alcista"
          },
          {
            fecha: "Oct 2023",
            titulo: "Gerücht über Genehmigung — Short Squeeze",
            descripcion: "Medien veröffentlichen fälschlicherweise die Genehmigung. Der Short Squeeze von 26K auf 44K (siehe Fall 6). Die institutionelle Erwartung positionierte den Markt bereits neu.",
            tipo: "alcista"
          },
          {
            fecha: "10 Ene 2024",
            titulo: "SEC genehmigt 11 Spot-ETFs gleichzeitig",
            descripcion: "Geschichte geschrieben. Die SEC genehmigt die ETFs von BlackRock (IBIT), Fidelity (FBTC), ARK 21Shares (ARKB) und 8 weitere. Bitcoin bei 46.000$.",
            tipo: "critico"
          },
          {
            fecha: "Ene–Feb 2024",
            titulo: "Massiver institutioneller Kapitalzufluss",
            descripcion: "Die ETFs ziehen in den ersten 30 Tagen über 10.000M$ an. BlackRocks IBIT wird zum am schnellsten wachsenden ETF der Geschichte. Das Tempo: Die ETFs kaufen mehr BTC, als in einem Jahr gemint wird.",
            tipo: "alcista"
          },
          {
            fecha: "Mar 2024",
            titulo: "BTC erreicht neues ATH: 73.000$",
            descripcion: "Neues Allzeithoch, getrieben durch ETF-Nachfrage. Zum ersten Mal in der Geschichte macht BTC ATH VOR dem Halving. Die Marktstruktur hat sich verändert.",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "Die ETF-Genehmigung veränderte die Marktstruktur grundlegend: (1) Das „zum Verkauf verfügbare\" BTC auf Exchanges erreichte historische Tiefststände — die ETFs entziehen dem Markt BTC. (2) Die Korrelation von BTC mit Risiko-Assets (NASDAQ) nahm zu — jetzt gibt es institutionelle Investoren mit Risikomanagement-Mandaten. (3) Die langfristige Volatilität hat sich verringert — mehr Kapital, mehr Markttiefe.",
        senalesOnchain: "Exchange Balances auf 5-Jahres-Tiefs: BTC wandert in Custody-Wallets der ETFs. Coinbase Institutional (Verwahrung von IBIT) entzieht Rekordmengen. Long-term Holder Supply auf Höchstständen: starke Hände verkaufen nicht.",
        leccionesAprendidas: [
          "Institutionelle Adoption verändert die Marktstruktur dauerhaft — es ist nicht nur eine Narrative",
          "ETFs schaffen kontinuierliche strukturelle Nachfrage: Jeden Tag kommen neue Käufe von institutionellen Investoren",
          "Die Reduzierung von BTC auf Exchanges ist das stärkste On-Chain-Signal für Angebotsknappheit",
          "Der Markt antizipiert regulatorische Ereignisse Monate im Voraus — die Gelegenheit war im Juni 2023, nicht im Januar 2024",
          "Mit institutionellen Investoren steigen die Korrelationen mit traditionellen Märkten — manage auch das Makro-Risiko"
        ],
        comoAplicarlo: "Im neuen Post-ETF-Zyklus: (1) Überwache die täglichen ETF-Zuflüsse (verfügbar bei Farside Investors, Bloomberg). Anhaltend positive Zuflüsse = bullisch. (2) Niedriger Exchange Balance = Angebotsknappheit = bullisch. (3) Institutionelle Korrekturen sind tiefer, aber kürzer: Institutionen haben Stops und Risikomanagement. (4) Makro-Katalysatoren (Fed, Inflation, traditionelle Märkte) beeinflussen den BTC-Preis stärker als zuvor.",
        conclusionFinal: "Die Genehmigung des Bitcoin-Spot-ETF ist das größte Adoptionsereignis in der Geschichte von Bitcoin. Es übertraf die Markterwartung: In 2 Monaten akkumulierten die ETFs mehr BTC als das gesamte Mining eines Jahres. Dies ist der Point of No Return der Institutionalisierung von Bitcoin. Der kommende Markt ist anders als der, der existierte. Diejenigen, die die neue Mechanik verstehen, werden einen Vorteil haben.",
        datosCarouselLabels: {
          etfs: "Genehmigte ETFs",
          flujo_30d: "Zufluss erste 30 Tage",
          ibit: "IBIT-Rekord",
          ath: "Erreichtes ATH",
          btc_exch: "BTC auf Exchanges",
          blackrock_aum: "BlackRock-Verwaltung"
        }
      },
      "zh-CN": {
        categoria: "INSTITUCIONAL",
        titulo: "BlackRock ETF：机构采用的转折点",
        subtitulo: "现货ETF批准如何永久改变了比特币市场结构",
        descripcion: "分析市场结构对现货ETF批准和机构需求的响应。",
        duracionLectura: "19 min",
        nivel: "高级",
        resumen: "2024年1月10日，SEC批准了史上首批比特币现货ETF。BlackRock、Fidelity、ARK 21Shares……11只ETF同时获批。随之而来的是比特币历史上最大规模的机构资本流入。仅在2个月内，这些ETF积累的BTC超过了一整年的挖矿产量。",
        contexto: "多年来，比特币一直被传统金融机构拒之门外。自2013年以来，SEC已拒绝了超过30份现货ETF申请。主流叙事是\"波动性太大、投机性太强、监管不足\"。当BlackRock——全球最大的资产管理公司，管理着10万亿美元资产——于2023年6月申请比特币ETF时，一切都改变了。如果BlackRock想要，SEC就会批准。",
        timeline: [
          {
            fecha: "15 Jun 2023",
            titulo: "BlackRock申请比特币现货ETF",
            descripcion: "BlackRock的申请改变了一切。当全球最大的资产管理公司想要比特币ETF时，批准只是时间问题。BTC在几天内上涨20%。",
            tipo: "alcista"
          },
          {
            fecha: "Oct 2023",
            titulo: "批准传闻——空头挤压",
            descripcion: "媒体错误发布批准消息。从26K到44K的空头挤压（见案例6）。机构预期已经在重新定位市场。",
            tipo: "alcista"
          },
          {
            fecha: "10 Ene 2024",
            titulo: "SEC同时批准11只现货ETF",
            descripcion: "历史性时刻。SEC批准BlackRock（IBIT）、Fidelity（FBTC）、ARK 21Shares（ARKB）及其他8只ETF。比特币价格46,000$。",
            tipo: "critico"
          },
          {
            fecha: "Ene–Feb 2024",
            titulo: "机构资本大规模流入",
            descripcion: "ETF在前30天吸引超过100亿美元。BlackRock的IBIT成为史上增长最快的ETF。速度：ETF购买的BTC超过一年的挖矿产量。",
            tipo: "alcista"
          },
          {
            fecha: "Mar 2024",
            titulo: "BTC达到新ATH：73,000$",
            descripcion: "由ETF需求推动的新历史高点。比特币历史上首次在减半前创下ATH。市场结构已经改变。",
            tipo: "alcista"
          }
        ],
        analisisTecnico: "ETF批准从根本上改变了市场结构：(1) 交易所\"可供出售\"的BTC降至历史最低——ETF将BTC从市场中撤出。(2) BTC与风险资产（NASDAQ）的相关性增加——现在有机构投资者执行风险管理指令。(3) 长期波动性降低——更多资本，更深的市场深度。",
        senalesOnchain: "交易所余额处于5年最低：BTC转移到ETF托管钱包。Coinbase Institutional（IBIT托管方）提取创纪录数量。长期持有者供应量创新高：强手不卖。",
        leccionesAprendidas: [
          "机构采用永久改变市场结构——这不仅仅是叙事",
          "ETF创造持续的结构性需求：每天都有来自机构投资者的新买盘",
          "交易所BTC减少是供应稀缺最强大的链上信号",
          "市场提前数月预期监管事件——机会在2023年6月，而非2024年1月",
          "有了机构投资者，与传统市场的相关性增加——也要管理宏观风险"
        ],
        comoAplicarlo: "在ETF后的新周期中：(1) 监控每日ETF流量（可在Farside Investors、Bloomberg查看）。持续正流入=看涨。(2) 交易所余额低=供应稀缺=看涨。(3) 机构回调更深但更短：机构有止损和风险管理。(4) 宏观催化剂（Fed、通胀、传统市场）比以前更影响BTC价格。",
        conclusionFinal: "比特币现货ETF的批准是比特币历史上最大的采用事件。超出了市场预期：在2个月内，ETF积累的BTC超过了一整年的挖矿产量。这是比特币机构化的不归点。未来的市场与过去不同。理解新机制的人将拥有优势。",
        datosCarouselLabels: {
          etfs: "批准的ETF",
          flujo_30d: "前30天流入",
          ibit: "IBIT纪录",
          ath: "达到的ATH",
          btc_exch: "交易所BTC",
          blackrock_aum: "BlackRock管理规模"
        }
      },
    },
  },
];

// Map slug → index for fast lookup.
export const CASO_INDEX_BY_SLUG = Object.fromEntries(
  CASOS_ESTUDIO.map((c, i) => [c.slug, i])
);

// Resolve a localized caso with fallback to ES.
export const getCaso = (slug, lang) => {
  const caso = CASOS_ESTUDIO.find((c) => c.slug === slug);
  if (!caso) return null;
  const tx = (caso.i18n && (caso.i18n[lang] || caso.i18n.es)) || {};
  return { ...caso, ...tx };
};

// UI labels for the detail page sections — translatable.
export const CASOS_UI = {
  es: {
    breadcrumb_academy: "Academia",
    breadcrumb_lab: "Lab de Mercado",
    back_lab: "Todos los casos",
    cta_card: "VER CASO DE ESTUDIO",
    meta_reading: "Lectura",
    meta_level: "Nivel",
    section_resumen: "Resumen del Caso",
    section_contexto: "Contexto y Antecedentes",
    section_timeline: "Timeline de Eventos",
    section_tecnico: "Análisis Técnico",
    section_onchain: "Señales On-Chain",
    section_lecciones: "Lecciones Aprendidas",
    section_aplicar: "Cómo Aplicarlo en Tu Trading",
    section_conclusion: "Conclusión",
    nav_prev: "Caso anterior",
    nav_next: "Caso siguiente",
    nav_all: "Todos los casos",
    tipo_label: {
      critico: "Crítico",
      alcista: "Alcista",
      bajista: "Bajista",
      neutro: "Neutro",
    },
    nivel_label: {
      basico: "BÁSICO",
      intermedio: "INTERMEDIO",
      avanzado: "AVANZADO",
    },
  },
  en: {
    breadcrumb_academy: "Academy",
    breadcrumb_lab: "Market Lab",
    back_lab: "All case studies",
    cta_card: "READ CASE STUDY",
    meta_reading: "Reading",
    meta_level: "Level",
    section_resumen: "Case Summary",
    section_contexto: "Context & Background",
    section_timeline: "Event Timeline",
    section_tecnico: "Technical Analysis",
    section_onchain: "On-Chain Signals",
    section_lecciones: "Lessons Learned",
    section_aplicar: "How to Apply It in Your Trading",
    section_conclusion: "Conclusion",
    nav_prev: "Previous case",
    nav_next: "Next case",
    nav_all: "All cases",
    tipo_label: {
      critico: "Critical",
      alcista: "Bullish",
      bajista: "Bearish",
      neutro: "Neutral",
    },
    nivel_label: {
      basico: "BASIC",
      intermedio: "INTERMEDIATE",
      avanzado: "ADVANCED",
    },
  },
  sk: {
    breadcrumb_academy: "Akadémia",
    breadcrumb_lab: "Trhové Lab",
    back_lab: "Všetky prípady",
    cta_card: "ČÍTAŤ PRÍPADOVÚ ŠTÚDIU",
    meta_reading: "Čítanie",
    meta_level: "Úroveň",
    section_resumen: "Zhrnutie Prípadu",
    section_contexto: "Kontext a Pozadie",
    section_timeline: "Časová Os Udalostí",
    section_tecnico: "Technická Analýza",
    section_onchain: "On-Chain Signály",
    section_lecciones: "Naučené Lekcie",
    section_aplicar: "Ako to Aplikovať v Tvojom Tradingu",
    section_conclusion: "Záver",
    nav_prev: "Predchádzajúci prípad",
    nav_next: "Ďalší prípad",
    nav_all: "Všetky prípady",
    tipo_label: {
      critico: "Kritický",
      alcista: "Býčí",
      bajista: "Medvedí",
      neutro: "Neutrálny",
    },
    nivel_label: {
      basico: "ZÁKLADNÝ",
      intermedio: "STREDNÝ",
      avanzado: "POKROČILÝ",
    },
  },
  de: {
    breadcrumb_academy: "Akademie",
    breadcrumb_lab: "Markt-Labor",
    back_lab: "Alle Fälle",
    cta_card: "FALLSTUDIE ANSEHEN",
    meta_reading: "Lesezeit",
    meta_level: "Niveau",
    section_resumen: "Fallzusammenfassung",
    section_contexto: "Kontext und Hintergrund",
    section_timeline: "Ereignis-Timeline",
    section_tecnico: "Technische Analyse",
    section_onchain: "On-Chain-Signale",
    section_lecciones: "Gelernte Lektionen",
    section_aplicar: "Wie du es in deinem Trading anwendest",
    section_conclusion: "Fazit",
    nav_prev: "Vorheriger Fall",
    nav_next: "Nächster Fall",
    nav_all: "Alle Fälle",
    tipo_label: {
      critico: "Kritisch",
      alcista: "Bullisch",
      bajista: "Bärisch",
      neutro: "Neutral",
    },
    nivel_label: {
      basico: "GRUNDLAGEN",
      intermedio: "FORTGESCHRITTEN",
      avanzado: "EXPERTE",
    },
  },
  "zh-CN": {
    breadcrumb_academy: "学院",
    breadcrumb_lab: "市场实验室",
    back_lab: "所有案例",
    cta_card: "查看案例研究",
    meta_reading: "阅读",
    meta_level: "级别",
    section_resumen: "案例摘要",
    section_contexto: "背景与前情",
    section_timeline: "事件时间线",
    section_tecnico: "技术分析",
    section_onchain: "链上信号",
    section_lecciones: "经验教训",
    section_aplicar: "如何应用于你的交易",
    section_conclusion: "结论",
    nav_prev: "上一个案例",
    nav_next: "下一个案例",
    nav_all: "所有案例",
    tipo_label: {
      critico: "关键",
      alcista: "看涨",
      bajista: "看跌",
      neutro: "中性",
    },
    nivel_label: {
      basico: "基础",
      intermedio: "中级",
      avanzado: "高级",
    },
  },
};

export const getCasosUi = (lang) => CASOS_UI[lang] || CASOS_UI.es;
